(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bt-before-after')) return;

    class BtBeforeAfter extends HTMLElement {
      constructor() {
        super();
        this.position = 50;
        this.dragging = false;
        this._rafId = 0;
        this._pending = null;
        this._animTimer = 0;
      }

      connectedCallback() {
        if (this.__btInit) return;
        this.__btInit = true;

        this.compare = this.querySelector('[data-bt-ba-compare]');
        this.handle = this.querySelector('[data-bt-ba-handle]');
        this.afterImg = this.querySelector('[data-bt-ba-after]');
        if (!this.compare || !this.handle) return;

        this.position = parseFloat(this.getAttribute('data-initial'));
        if (isNaN(this.position)) this.position = 50;
        this._apply(this.position, false);

        this._bindEvents();

        if (this.getAttribute('data-auto-animate') === 'true') {
          this._setupAutoAnimate();
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._rafId);
        clearTimeout(this._animTimer);
        if (this._io) this._io.disconnect();
      }

      _bindEvents() {
        // Pointer down on handle starts a drag session
        this.handle.addEventListener('pointerdown', this._onPointerDown.bind(this));
        // Pointer down on the compare area outside the handle — jump + start drag
        this.compare.addEventListener('pointerdown', this._onCompareDown.bind(this));
        // Keyboard
        this.handle.addEventListener('keydown', this._onKey.bind(this));
      }

      _onPointerDown(e) {
        e.preventDefault();
        this._startDrag(e);
      }

      _onCompareDown(e) {
        // Ignore clicks that originate from the handle itself (handled above).
        if (e.target === this.handle || this.handle.contains(e.target)) return;
        this._jumpTo(e, true);
        this._startDrag(e);
      }

      _startDrag(e) {
        this.dragging = true;
        this.compare.classList.add('is-dragging');
        this.compare.classList.remove('is-animated');
        clearTimeout(this._animTimer);
        try { this.handle.setPointerCapture(e.pointerId); } catch (err) {}

        const onMove = (ev) => {
          if (!this.dragging) return;
          ev.preventDefault();
          this._jumpTo(ev, false);
        };
        const onUp = (ev) => {
          this.dragging = false;
          this.compare.classList.remove('is-dragging');
          try { this.handle.releasePointerCapture(ev.pointerId); } catch (err) {}
          this.handle.removeEventListener('pointermove', onMove);
          this.handle.removeEventListener('pointerup', onUp);
          this.handle.removeEventListener('pointercancel', onUp);
          window.removeEventListener('pointerup', onUp);
        };
        this.handle.addEventListener('pointermove', onMove);
        this.handle.addEventListener('pointerup', onUp);
        this.handle.addEventListener('pointercancel', onUp);
        // Safety: if pointerup fires outside the handle
        window.addEventListener('pointerup', onUp, { once: true });
      }

      _jumpTo(e, animated) {
        const rect = this.compare.getBoundingClientRect();
        if (!rect.width) return;
        const x = e.clientX - rect.left;
        const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
        this._apply(pct, animated);
      }

      _onKey(e) {
        const step = e.shiftKey ? 10 : 2;
        let handled = true;
        if (e.key === 'ArrowLeft') this._apply(Math.max(0, this.position - step), true);
        else if (e.key === 'ArrowRight') this._apply(Math.min(100, this.position + step), true);
        else if (e.key === 'Home') this._apply(0, true);
        else if (e.key === 'End') this._apply(100, true);
        else handled = false;
        if (handled) e.preventDefault();
      }

      _apply(pct, animated) {
        this.position = pct;
        if (animated) {
          this.compare.classList.add('is-animated');
          clearTimeout(this._animTimer);
          this._animTimer = setTimeout(() => {
            this.compare.classList.remove('is-animated');
          }, 600);
        } else {
          this.compare.classList.remove('is-animated');
        }
        // rAF-throttle to the nearest frame for buttery-smooth drag
        this._pending = pct;
        if (this._rafId) return;
        this._rafId = requestAnimationFrame(() => {
          this._rafId = 0;
          const value = this._pending;
          this._pending = null;
          this.compare.style.setProperty('--bt-ba-split', value + '%');
          this.handle.setAttribute('aria-valuenow', Math.round(value));
        });
      }

      _setupAutoAnimate() {
        if (!('IntersectionObserver' in window)) return;
        let done = false;
        this._io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !done) {
              done = true;
              this._io.disconnect();
              // Subtle attention-drawing sweep: right → left → center
              const base = this.position;
              setTimeout(() => this._apply(Math.min(100, base + 25), true), 150);
              setTimeout(() => this._apply(Math.max(0, base - 25), true), 900);
              setTimeout(() => this._apply(base, true), 1650);
            }
          });
        }, { threshold: 0.25 });
        this._io.observe(this);
      }
    }

    customElements.define('bt-before-after', BtBeforeAfter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts-bricktopia"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      if (!root || root.__btBpReady) return;
      root.__btBpReady = true;

      var pills = root.querySelectorAll('[data-bt-bp-filter]');
      var cards = root.querySelectorAll('[data-bt-bp-card]');
      var empty = root.querySelector('[data-bt-bp-empty]');

      if (pills.length === 0) return;

      pills.forEach(function(pill) {
        pill.addEventListener('click', function() {
          var f = (pill.getAttribute('data-bt-bp-filter') || '').toLowerCase();
          pills.forEach(function(p) { p.classList.toggle('is-active', p === pill); });
          var visible = 0;
          cards.forEach(function(card) {
            var tags = (card.getAttribute('data-bt-bp-tags') || '').toLowerCase();
            var show = f === 'all' || tags.split(',').map(function(s){ return s.trim(); }).indexOf(f) !== -1;
            card.hidden = !show;
            if (show) visible++;
          });
          if (empty) empty.hidden = visible !== 0;
        });
      });
    }

    document.querySelectorAll('[data-bt-bp]').forEach(init);
    document.addEventListener('shopify:section:load', function(e) {
      if (e.target) e.target.querySelectorAll('[data-bt-bp]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMarquee(root) {
      if (!root || root.__btBrcReady) return;
      root.__btBrcReady = true;
      var track = root.querySelector('[data-bt-brc-track]');
      if (!track) return;
      var html = track.innerHTML;
      track.innerHTML = html + html;
      var speed = parseFloat(root.getAttribute('data-speed')) || 18;
      requestAnimationFrame(function () {
        var w = track.scrollWidth / 2;
        if (w > 0) {
          var duration = w / (speed * 4);
          track.style.setProperty('--brc-marquee-duration', Math.max(8, duration) + 's');
        }
      });
    }
    document.querySelectorAll('[data-bt-brc-marquee]').forEach(initMarquee);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-brc-marquee]').forEach(initMarquee);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMarquee(root) {
      if (!root || root.__btBrandsReady) return;
      root.__btBrandsReady = true;
      var track = root.querySelector('[data-bt-brands-track]');
      if (!track) return;
      // Duplicate content for seamless infinite loop
      var html = track.innerHTML;
      track.innerHTML = html + html;
      // Compute duration based on speed + total track width
      var speed = parseFloat(root.getAttribute('data-speed')) || 20;
      // Wait a frame for layout so scrollWidth is accurate
      requestAnimationFrame(function () {
        var fullWidth = track.scrollWidth / 2; // one loop length
        if (fullWidth > 0) {
          var duration = fullWidth / (speed * 4);
          track.style.setProperty('--brands-marquee-duration', Math.max(8, duration) + 's');
        }
      });
    }
    document.querySelectorAll('[data-bt-brands-marquee]').forEach(initMarquee);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-brands-marquee]').forEach(initMarquee);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-ai-prompt-generator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupBlock(el) {
      if (el.__btApgInit) return;
      el.__btApgInit = true;

      var baseBefore = el.dataset.baseBefore || '';
      var baseAfter = el.dataset.baseAfter || '';
      var scales = {
        small:  el.dataset.scaleSmall  || '',
        medium: el.dataset.scaleMedium || '',
        large:  el.dataset.scaleLarge  || ''
      };
      var charLimit = parseInt(el.dataset.charLimit, 10) || 1300;
      var successTemplate = el.dataset.successTemplate || 'Copied {count} characters';

      var output = el.querySelector('[data-apg-output]');
      var counter = el.querySelector('[data-apg-counter]');
      var copyBtn = el.querySelector('[data-apg-copy]');
      var copyLabel = copyBtn ? copyBtn.querySelector('[data-apg-copy-label]') : null;
      var copyDefault = copyBtn ? copyBtn.dataset.defaultText : '';

      var currentSize = el.dataset.defaultSize || 'medium';
      var active = el.querySelector('[data-apg-chip-group="size"] .is-active');
      if (active) currentSize = active.dataset.apgSize || currentSize;

      function buildPrompt() {
        if (!output) return;
        var scale = scales[currentSize] || scales.medium || '';
        var prompt = baseBefore + scale + baseAfter;
        output.value = prompt;
        if (counter) {
          counter.textContent = prompt.length + ' / ' + charLimit;
          if (prompt.length > charLimit) counter.classList.add('is-over');
          else counter.classList.remove('is-over');
        }
      }

      // Size chip click → radio behaviour
      el.querySelectorAll('[data-apg-chip-group="size"] .bt-apg__chip').forEach(function (btn) {
        btn.addEventListener('click', function () {
          el.querySelectorAll('[data-apg-chip-group="size"] .bt-apg__chip').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          currentSize = btn.dataset.apgSize || 'medium';
          buildPrompt();
        });
      });

      // Copy button — clipboard with execCommand fallback
      if (copyBtn && output) {
        copyBtn.addEventListener('click', function () {
          var text = output.value;
          var successMsg = successTemplate.replace(/\{count\}/g, text.length);
          var done = function () {
            // Re-trigger the CSS animation if user clicks copy again before the
            // 2.4s reset — strip + force reflow + re-add the class.
            copyBtn.classList.remove('is-success');
            // eslint-disable-next-line no-unused-expressions
            void copyBtn.offsetWidth;
            copyBtn.classList.add('is-success');
            if (copyLabel) copyLabel.textContent = successMsg;
            setTimeout(function () {
              copyBtn.classList.remove('is-success');
              if (copyLabel) copyLabel.textContent = copyDefault;
            }, 2400);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done).catch(fallbackCopy);
          } else {
            fallbackCopy();
          }
          function fallbackCopy() {
            try {
              var wasReadonly = output.hasAttribute('readonly');
              if (wasReadonly) output.removeAttribute('readonly');
              output.select();
              output.setSelectionRange(0, 99999);
              document.execCommand('copy');
              if (wasReadonly) output.setAttribute('readonly', 'readonly');
              done();
            } catch (e) {
              console.warn('[bt-apg] copy failed', e);
            }
          }
        });
      }

      buildPrompt();
    }

    function init() {
      document.querySelectorAll('[data-bt-apg]').forEach(setupBlock);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-apg]').forEach(setupBlock);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBA(root) {
      if (root.dataset.btBaReady === '1') return;
      root.dataset.btBaReady = '1';

      var stage = root.querySelector('[data-bt-baft-stage]');
      if (!stage) return;
      var start = parseFloat(root.dataset.start || '50');
      var pos = isNaN(start) ? 50 : start;
      var dragging = false;

      function setPos(pct, animate) {
        pos = Math.min(97, Math.max(3, pct));
        if (animate) {
          root.style.transition = '--bt-baft-pos 0.3s ease';
        }
        root.style.setProperty('--bt-baft-pos', pos + '%');
      }

      function pctFromEvent(e) {
        var rect = stage.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        return (x / rect.width) * 100;
      }

      stage.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { stage.setPointerCapture(e.pointerId); } catch (err) { /* capture is best-effort */ }
        setPos(pctFromEvent(e));
      });
      stage.addEventListener('pointermove', function (e) {
        if (dragging) setPos(pctFromEvent(e));
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        stage.addEventListener(ev, function () { dragging = false; });
      });

      // Keyboard access on the handle
      var handle = root.querySelector('[data-bt-baft-handle]');
      if (handle) {
        handle.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); setPos(pos - 4); }
          if (e.key === 'ArrowRight') { e.preventDefault(); setPos(pos + 4); }
        });
      }

      // One gentle wiggle when the block first scrolls into view, so it's
      // obviously draggable. Skipped for reduced-motion users.
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduced && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            var seq = [pos - 7, pos + 7, pos];
            var i = 0;
            var timer = setInterval(function () {
              if (dragging || i >= seq.length) { clearInterval(timer); return; }
              var target = seq[i++];
              var from = pos;
              var t0 = null;
              requestAnimationFrame(function frame(now) {
                if (dragging) return;
                if (t0 === null) t0 = now;
                var k = Math.min((now - t0) / 260, 1);
                var eased = 1 - Math.pow(1 - k, 2);
                setPos(from + (target - from) * eased);
                if (k < 1) requestAnimationFrame(frame);
              });
            }, 320);
          });
        }, { threshold: 0.5 });
        io.observe(root);
      }
    }

    function init(scope) {
      scope.querySelectorAll('[data-bt-baft]').forEach(initBA);
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-bento-features"] && !Shopify.designMode) return;
  try {
    
  // Tile videos are `preload: none` — start them only once the tile is on
  // screen, and stop them when it leaves, so a bento of 6 clips stays cheap.
  (function () {
    function init(scope) {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            // iOS needs playsinline + muted set before play() resolves.
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.muted = true;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });

      scope.querySelectorAll('[data-bt-bento-video]').forEach(function (wrap) {
        if (wrap.dataset.btReady === '1') return;
        wrap.dataset.btReady = '1';
        io.observe(wrap);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-contact-button"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupBlock(root) {
      if (!root || root.__btCbReady) return;
      root.__btCbReady = true;

      var openBtn = root.querySelector('[data-bt-cb-open]');
      var overlay = root.querySelector('[data-bt-cb-overlay]');
      var closeBtn = root.querySelector('[data-bt-cb-close]');
      var webhookUrl = (root.dataset.webhook || '').trim();
      var tgEnabled = !!root.dataset.tgEnabled;
      var sourceName = root.dataset.source || 'contact-button';

      /* 24.10.2026: другий обовʼязковий контакт (прапорець two_contacts). */
      function c2Mail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
      function c2Phone(v) { return !/[^\d\s()+\-.]/.test(v) && v.replace(/\D/g, '').length >= 9; }
      function c2Same(a, b) {
        var da = String(a).replace(/\D/g, ''), db = String(b).replace(/\D/g, '');
        if (da.length >= 9 && db.length >= 9 && c2Phone(a) && c2Phone(b)) return da.slice(-9) === db.slice(-9);
        return String(a).trim().toLowerCase().replace(/^@/, '') === String(b).trim().toLowerCase().replace(/^@/, '');
      }
      function c2Fill(lead, list, tgMethod) {
        list.forEach(function (v) {
          v = String(v || '').trim();
          if (!v) return;
          if (c2Mail(v)) { if (!lead.email) lead.email = v; }
          else if (c2Phone(v)) { if (!lead.phone) lead.phone = v; }
          else if (/t\.me\//i.test(v) || (tgMethod && /^@?[A-Za-z][A-Za-z0-9_]{3,31}$/.test(v))) { if (!lead.telegram) lead.telegram = v; }
        });
      }
      /* Тексти форми рендерить Liquid у data-атрибути кореня (тут Liquid не
         працює). Дефолти за мовою — на випадок кешованого HTML без атрибутів. */
      var msgLang = String(root.dataset.locale || (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
      var MSG_DEFAULTS = {
        pl: { sending: 'Wysyłamy…', success: 'Dziękujemy! Skontaktujemy się z Tobą wkrótce.', errRequired: 'Wypełnij imię i telefon', errSend: 'Nie udało się wysłać. Spróbuj ponownie później.', errNoWebhook: 'Kontakt nie jest skonfigurowany' },
        uk: { sending: 'Надсилаємо…', success: 'Дякуємо! Ми зв`яжемося з вами найближчим часом.', errRequired: 'Заповніть ім`я та телефон', errSend: 'Не вдалося надіслати. Спробуйте пізніше.', errNoWebhook: 'Контакт не налаштований' },
        it: { sending: 'Invio in corso…', success: 'Grazie! Ti contatteremo a breve.', errRequired: 'Inserisci nome e telefono', errSend: 'Invio non riuscito. Riprova più tardi.', errNoWebhook: 'Il contatto non è configurato' },
        de: { sending: 'Wird gesendet…', success: 'Danke! Wir melden uns in Kürze bei dir.', errRequired: 'Bitte gib Name und Telefonnummer ein', errSend: 'Senden fehlgeschlagen. Bitte versuche es später erneut.', errNoWebhook: 'Der Kontakt ist nicht eingerichtet' },
        cs: { sending: 'Odesíláme…', success: 'Děkujeme! Brzy se vám ozveme.', errRequired: 'Vyplňte jméno a telefon', errSend: 'Odeslání se nezdařilo. Zkuste to prosím později.', errNoWebhook: 'Kontakt není nastaven' },
        es: { sending: 'Enviando…', success: '¡Gracias! Nos pondremos en contacto contigo en breve.', errRequired: 'Escribe tu nombre y tu teléfono', errSend: 'No se ha podido enviar. Inténtalo de nuevo más tarde.', errNoWebhook: 'El contacto no está configurado' },
        fr: { sending: 'Envoi en cours…', success: 'Merci ! Nous vous recontacterons très bientôt.', errRequired: 'Renseignez votre nom et votre téléphone', errSend: 'L’envoi a échoué. Veuillez réessayer plus tard.', errNoWebhook: 'Le contact n’est pas configuré' },
        nl: { sending: 'Bezig met verzenden…', success: 'Bedankt! We nemen binnenkort contact met je op.', errRequired: 'Vul je naam en telefoonnummer in', errSend: 'Verzenden is mislukt. Probeer het later opnieuw.', errNoWebhook: 'Het contact is niet ingesteld' },
        sk: { sending: 'Odosielame…', success: 'Ďakujeme! Čoskoro sa vám ozveme.', errRequired: 'Vyplňte meno a telefón', errSend: 'Odoslanie sa nepodarilo. Skúste to prosím neskôr.', errNoWebhook: 'Kontakt nie je nastavený' },
        hu: { sending: 'Küldés folyamatban…', success: 'Köszönjük! Hamarosan jelentkezünk.', errRequired: 'Add meg a neved és a telefonszámod', errSend: 'A küldés nem sikerült. Próbáld újra később.', errNoWebhook: 'A kapcsolat nincs beállítva' },
        ro: { sending: 'Se trimite…', success: 'Mulțumim! Revenim în curând.', errRequired: 'Completează numele și telefonul', errSend: 'Trimiterea nu a reușit. Încearcă din nou mai târziu.', errNoWebhook: 'Contactul nu este configurat' },
        lt: { sending: 'Siunčiama…', success: 'Ačiū! Netrukus su jumis susisieksime.', errRequired: 'Įrašykite vardą ir telefoną', errSend: 'Išsiųsti nepavyko. Bandykite dar kartą vėliau.', errNoWebhook: 'Kontaktas nesukonfigūruotas' },
        lv: { sending: 'Sūtām…', success: 'Paldies! Drīz ar tevi sazināsimies.', errRequired: 'Ievadi vārdu un tālruni', errSend: 'Neizdevās nosūtīt. Mēģini vēlreiz vēlāk.', errNoWebhook: 'Kontakts nav iestatīts' },
        et: { sending: 'Saadame…', success: 'Aitäh! Võtame sinuga peagi ühendust.', errRequired: 'Sisesta nimi ja telefon', errSend: 'Saatmine ebaõnnestus. Proovi hiljem uuesti.', errNoWebhook: 'Kontakt pole seadistatud' },
        ru: { sending: 'Отправляем…', success: 'Спасибо! Мы свяжемся с вами в ближайшее время.', errRequired: 'Заполните имя и телефон', errSend: 'Не удалось отправить. Попробуйте позже.', errNoWebhook: 'Контакт не настроен' },
        en: { sending: 'Sending…', success: 'Thank you! We will get in touch with you shortly.', errRequired: 'Please fill in your name and phone', errSend: 'Could not send. Please try again later.', errNoWebhook: 'Contact is not configured' }
      };
      var msgDef = MSG_DEFAULTS[msgLang] || MSG_DEFAULTS.pl;
      var MSG = {
        sending: root.dataset.msgSending || msgDef.sending,
        success: root.dataset.msgSuccess || msgDef.success,
        errRequired: root.dataset.msgErrRequired || msgDef.errRequired,
        errSend: root.dataset.msgErrSend || msgDef.errSend,
        errNoWebhook: root.dataset.msgErrNowebhook || msgDef.errNoWebhook
      };

      function open() {
        if (!overlay) return;
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        prefetchCart();
      }
      function close() {
        if (!overlay) return;
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      if (openBtn) openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) {
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay) close();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) close();
      });

      /* Telegram-webhook notification — fires when ANY contact channel is
         clicked. We fetch /cart.js to attach the visitor's current cart so
         the merchant immediately sees what they're asking about.

         The user navigates to the channel URL in a NEW tab (target=_blank
         on the link), so the webhook POST and the navigation race in
         parallel — but since we use `keepalive: true` the request finishes
         even if the page unloads. */
      function buildPayload(channel, cart) {
        var items = (cart && cart.items) ? cart.items.map(function (i) {
          return {
            title: i.product_title || i.title,
            qty: i.quantity,
            price: i.line_price ? (i.line_price / 100).toFixed(2) : null,
            variant: i.variant_title,
            url: i.url
          };
        }) : [];
        return {
          source: sourceName,
          channel: channel,
          page: window.location.href,
          referrer: document.referrer || null,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
          cart: cart ? {
            item_count: cart.item_count,
            total_price: cart.total_price ? (cart.total_price / 100).toFixed(2) : null,
            currency: cart.currency,
            items: items
          } : null
        };
      }

      /* Extract human-readable config details from a cart item's properties.
         Returns an array of "label: value" strings suitable for Telegram.
         Skips internal flags (_upsell, preview_url, bricktopia_price_*). */
      function extractItemConfig(item) {
        var out = [];
        if (!item || !item.properties) return out;
        var props = item.properties;

        function pushIf(label, val) {
          if (val !== undefined && val !== null && val !== '' && val !== false) {
            out.push('     • ' + label + ': ' + val);
          }
        }

        /* Try parsing builder_config JSON — that's where the meat is. */
        var cfg = null;
        /* _builder_config — нове імʼя (приховане від покупця), builder_config — старі кошики */
        var rawCfg = props._builder_config || props.builder_config || props['builder_config'];
        if (rawCfg) {
          try { cfg = typeof rawCfg === 'string' ? JSON.parse(rawCfg) : rawCfg; }
          catch (e) { cfg = null; }
        }
        if (cfg) {
          if (cfg.frameSize)    pushIf('Rozmiar рамки', cfg.frameSize);
          if (cfg.frameColor)   pushIf('Колір рамки', cfg.frameColor);
          if (cfg.figuresCount) pushIf('Кількість фігурок', cfg.figuresCount);
          if (cfg.keychain !== undefined) pushIf('Брелок', cfg.keychain ? 'Так' : 'Ні');
          if (cfg.delayDays)    pushIf('Затримка (днів)', cfg.delayDays);
          if (cfg.type)         pushIf('Тип', cfg.type);
        }

        /* Design IDs — show them so the merchant can look up the actual build. */
        var designId = props._figure_config_id || props.figure_config_id
          || props._frame_config_id || props.frame_config_id
          || props._pet_config_id || props.pet_config_id;
        if (designId) out.push('     • Design ID: ' + designId);

        /* Preview URL — clickable link in Telegram */
        var previewUrl = props._preview_url || props.preview_url || (cfg && cfg.preview);
        if (previewUrl) out.push('     🖼 Прев`ю: ' + previewUrl);

        /* Other custom properties (non-internal) */
        Object.keys(props).forEach(function (k) {
          if (k.charAt(0) === '_') return; /* internal flags */
          if (k === 'builder_config' || k === 'preview_url') return;
          if (k === 'figure_config_id' || k === 'frame_config_id' || k === 'pet_config_id') return;
          if (k.indexOf('bricktopia_price_') === 0) return; /* price label, redundant */
          var v = props[k];
          if (v === '' || v === null || v === undefined) return;
          /* Truncate long values */
          var vStr = String(v);
          if (vStr.length > 80) vStr = vStr.slice(0, 77) + '…';
          out.push('     • ' + k + ': ' + vStr);
        });

        return out;
      }

      /* Format the cart object into a human-readable Telegram message.
         Includes per-item config details so the merchant can quickly look
         at what the customer was building. */
      function formatTelegramMessage(channel, cart, formData) {
        var lines = [];
        if (formData) {
          lines.push('🔔 Нова заявка з форми:');
          lines.push('📝 Ім`я: ' + (formData.name || '—'));
          lines.push('📞 Telefon: ' + (formData.phone || '—'));
          if (formData.second) lines.push('📇 ' + (root.dataset.c2Row || 'Ще контакт') + ': ' + formData.second);
          if (formData.comment) lines.push('💬 Коментар: ' + formData.comment);
        } else {
          lines.push('🔔 Клік на канал зв`язку: ' + channel);
        }
        lines.push('📍 Сторінка: ' + window.location.href);
        lines.push('🏷 Source: ' + sourceName);
        lines.push('⏰ Час: ' + new Date().toLocaleString('uk-UA'));

        if (cart && cart.items && cart.items.length > 0) {
          lines.push('');
          lines.push('🛒 Koszyk (' + cart.item_count + ' шт):');
          cart.items.forEach(function (item, i) {
            var title = (item.product_title || item.title || '').slice(0, 60);
            var qty = item.quantity || 1;
            var price = item.line_price ? (item.line_price / 100).toFixed(2) : '?';
            var variant = item.variant_title && item.variant_title !== 'Default Title'
              ? ' (' + item.variant_title + ')' : '';
            lines.push((i + 1) + '. ' + title + variant + ' × ' + qty + ' = ' + price + ' ' + (cart.currency || 'PLN'));
            /* Append config details indented under the line */
            var cfg = extractItemConfig(item);
            if (cfg.length > 0) {
              lines.push.apply(lines, cfg);
            }
          });
          if (cart.total_price) {
            lines.push('💰 Усього: ' + (cart.total_price / 100).toFixed(2) + ' ' + (cart.currency || 'PLN'));
          }
        } else if (cart) {
          lines.push('');
          lines.push('🛒 Koszyk: порожній (Kloniko PL)');
        }
        return lines.join('\n');
      }

      /* Telegram send через бекенд (kickflip) — токен бота живе тільки на сервері.
         Старий шлях: працює, лише коли bt-lead.js не завантажився. */
      function sendToTelegram(channel, cart, formData) {
        if (!tgEnabled) return Promise.resolve(false);
        var text = formatTelegramMessage(channel, cart, formData);
        return fetch('https://web-production-05000.up.railway.app/site/notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text: text }),
          keepalive: true
        }).then(function (r) { return r.ok; }).catch(function () { return false; });
      }

      function fetchCart() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }

      /* assets/bt-lead.js (window.btLead) вантажиться defer — перевіряємо
         в момент кліку/сабміту, а не при ініціалізації секції. */
      function leadApi(method) {
        var l = window.btLead;
        return l && typeof l[method] === 'function' ? l : null;
      }

      /* Кошик для кліку беремо заздалегідь — коли відкривається попап. Канали
         відкриваються в новій вкладці чи в застосунку: мобільний браузер ховає
         сторінку й може приспати JS, поки /cart.js ще летить, — і клік до
         складу вже не дійде. З готовим кошиком beacon іде в момент кліку. */
      var cartCache = null;
      function prefetchCart() {
        var l = leadApi('cart');
        if (!l) return;
        var entry = { at: Date.now(), value: null };
        cartCache = entry;
        try {
          l.cart(3000).then(function (c) { entry.value = c || { raw: null, summary: null }; }, function () {});
        } catch (e) { /* swallow */ }
      }

      function notifyWebhook(channel, formData) {
        /* Strategy: є bt-lead.js — клік іде в склад («Кліки на месенджер»,
           beacon з keepalive; без згоди на аналітику bt-lead.js його не шле).
           Немає — як раніше, Telegram через kickflip. Якщо webhook URL теж
           заповнений — шлемо і туди паралельно. */
        var lead = leadApi('beacon');
        var cached = lead && cartCache && cartCache.value && Date.now() - cartCache.at < 600000 ? cartCache.value : null;
        var cartReady = cached
          ? Promise.resolve(cached)
          : lead && typeof lead.cart === 'function'
            ? lead.cart(3000)
            : fetchCart().then(function (raw) { return { raw: raw, summary: null }; });

        if (lead) {
          /* Кошика ще нема — чекаємо його (≤ 3 с), але якщо сторінку ховають
             раніше (перехід у месенджер), клік іде одразу, без кошика. Рівно один. */
          var clickSent = false;
          var onHide = function (e) {
            if ((e && e.type === 'pagehide') || document.visibilityState === 'hidden') sendClick(null);
          };
          var sendClick = function (c) {
            if (clickSent) return;
            clickSent = true;
            try {
              document.removeEventListener('visibilitychange', onHide);
              window.removeEventListener('pagehide', onHide);
            } catch (e) { /* swallow */ }
            try {
              lead.beacon({
                kind: 'contact_click',
                source: sourceName,
                notify: tgEnabled,
                details: { channel: channel, cart: (c && c.summary) || null }
              });
            } catch (e) { /* swallow */ }
          };
          if (cached) {
            sendClick(cached);
          } else {
            try {
              document.addEventListener('visibilitychange', onHide);
              window.addEventListener('pagehide', onHide);
            } catch (e) { /* swallow */ }
            cartReady.then(sendClick, function () { sendClick(null); });
          }
        }

        cartReady
          .then(function (c) {
            var cart = (c && c.raw) || null;
            if (!lead && tgEnabled) {
              /* Telegram через бекенд */
              sendToTelegram(channel, cart, formData);
            }
            /* Generic webhook (if configured) */
            if (webhookUrl) {
              var payload = buildPayload(channel, cart);
              if (formData) payload.form = formData;
              try {
                fetch(webhookUrl, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload),
                  keepalive: true,
                  mode: 'cors'
                }).catch(function () { /* swallow */ });
              } catch (e) { /* swallow */ }
            }
          });
      }

      var channelLinks = root.querySelectorAll('[data-bt-cb-channel]');
      channelLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          var channel = link.getAttribute('data-bt-cb-channel') || 'unknown';
          notifyWebhook(channel);
        });
      });

      /* Callback form — sends name/phone/comment + cart info to the webhook
         so the merchant gets a Telegram notification with everything they
         need to call back. */
      var form = root.querySelector('[data-bt-cb-form]');
      if (form) {
        var msgEl = form.querySelector('[data-bt-cb-form-message]');
        var submitBtn = form.querySelector('[data-bt-cb-submit]');
        var origSubmitText = submitBtn ? submitBtn.querySelector('.bt-cb__submit-label') : null;
        var origSubmitTextValue = origSubmitText ? origSubmitText.textContent : '';

        function setMessage(text, kind) {
          if (!msgEl) return;
          msgEl.textContent = text || '';
          msgEl.classList.remove('is-success', 'is-error');
          if (kind === 'success') msgEl.classList.add('is-success');
          if (kind === 'error') msgEl.classList.add('is-error');
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          /* No destination configured → can't send anywhere */
          if (!webhookUrl && !tgEnabled) {
            setMessage(MSG.errNoWebhook, 'error');
            return;
          }
          var fd = new FormData(form);
          var name = (fd.get('name') || '').toString().trim();
          var phone = (fd.get('phone') || '').toString().trim();
          var comment = (fd.get('comment') || '').toString().trim();
          if (!name || !phone) {
            setMessage(MSG.errRequired, 'error');
            return;
          }
          var second = form.querySelector('input[name="contact2"]') ? (fd.get('contact2') || '').toString().trim().slice(0, 200) : null;
          if (second !== null) {
            if (phone.replace(/\D/g, '').length < 9) { setMessage(root.dataset.c2ErrPhone, 'error'); return; }
            if (second.length < 3) { setMessage(root.dataset.c2Err, 'error'); return; }
            if (c2Same(phone, second)) { setMessage(root.dataset.c2Same, 'error'); return; }
          }
          if (submitBtn) {
            submitBtn.disabled = true;
            if (origSubmitText) origSubmitText.textContent = MSG.sending;
          }
          setMessage('', '');

          var formData = { name: name, phone: phone, second: second || '', comment: comment };
          var lead = tgEnabled ? leadApi('send') : null;
          var sending;

          if (lead) {
            /* Склад («Заявки з сайту»); склад недоступний — bt-lead.js сам
               шле цей самий повний текст у Telegram через kickflip. */
            sending = (typeof lead.cart === 'function' ? lead.cart() : Promise.resolve(null))
              .then(function (c) {
                c = c || {};
                var fallbackText = '';
                try { fallbackText = formatTelegramMessage('callback-form', c.raw || null, formData); } catch (err) { /* без запасного тексту */ }
                return lead.send({
                  kind: 'callback',
                  source: sourceName,
                  name: name,
                  phone: phone,
                  contact_method: 'Telefon',
                  contact: second ? (phone + ' · ' + second).slice(0, 300) : phone,
                  email: second && c2Mail(second) ? second : undefined,
                  telegram: second && /t\.me\//i.test(second) ? second : undefined,
                  message: comment,
                  details: { cart: c.summary || null }
                }, { fallbackText: fallbackText });
              })
              .then(function (res) { return !!(res && res.ok); });
          } else {
            sending = fetchCart().then(function (cart) {
              /* Telegram через бекенд — preferred */
              if (tgEnabled) {
                return sendToTelegram('callback-form', cart, formData);
              }
              /* Webhook fallback */
              var payload = buildPayload('callback-form', cart);
              payload.form = formData;
              return fetch(webhookUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                keepalive: true,
                mode: 'cors'
              }).then(function (r) { return !!(r && r.ok); });
            });
          }

          /* Успіх — ЛИШЕ коли заявка справді кудись дійшла (раніше «Dziękujemy»
             показувалось навіть при збої відправки). */
          sending
            .then(function (delivered) {
              if (!delivered) {
                setMessage(MSG.errSend, 'error');
                return;
              }
              setMessage(MSG.success, 'success');
              form.reset();
            })
            .catch(function () {
              setMessage(MSG.errSend, 'error');
            })
            .finally(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
                if (origSubmitText) origSubmitText.textContent = origSubmitTextValue;
              }
            });
        });
      }
    }

    function init() {
      document.querySelectorAll('[data-bt-contact-button]').forEach(setupBlock);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-contact-button]').forEach(setupBlock);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-corp-projects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      scope.querySelectorAll('[data-bt-cprj]').forEach(function (root) {
        if (root.dataset.btCprjReady === '1') return;
        root.dataset.btCprjReady = '1';

        var pop = root.querySelector('[data-bt-cprj-pop]');
        var content = root.querySelector('[data-bt-cprj-content]');
        var opener = null;

        function open(id) {
          var tpl = root.querySelector('[data-bt-cprj-data="' + id + '"]');
          if (!tpl) return;
          content.innerHTML = '';
          content.appendChild(tpl.content.cloneNode(true));
          pop.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          var close = pop.querySelector('[data-bt-cprj-close]');
          if (close) close.focus();
        }

        function close() {
          pop.hidden = true;
          content.innerHTML = '';
          document.documentElement.style.overflow = '';
          if (opener) opener.focus();
        }

        root.querySelectorAll('[data-bt-cprj-open]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            opener = btn;
            open(btn.getAttribute('data-bt-cprj-open'));
          });
        });

        pop.addEventListener('click', function (e) {
          if (e.target.closest('[data-bt-cprj-close]')) close();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !pop.hidden) close();
        });
      });
    }
    document.addEventListener('DOMContentLoaded', function () { init(document); });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-corp-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      scope.querySelectorAll('[data-bt-ctst]').forEach(function (root) {
        if (root.dataset.btCtstReady === '1') return;
        root.dataset.btCtstReady = '1';
        var track = root.querySelector('[data-bt-ctst-track]');
        var prev = root.querySelector('[data-bt-ctst-prev]');
        var next = root.querySelector('[data-bt-ctst-next]');
        if (!track || !prev || !next) return;

        function step() {
          var card = track.firstElementChild;
          return card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
        }
        function sync() {
          var max = track.scrollWidth - track.clientWidth - 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max;
          prev.hidden = next.hidden = max <= 0;   // усе вміщається — стрілки не потрібні
        }
        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      });
    }
    document.addEventListener('DOMContentLoaded', function () { init(document); });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-faq-categorized"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.__btFaqcReady) return;
      root.__btFaqcReady = true;

      /* Tab / sidebar nav switching — disabled in «stacked» layout
         (all panels visible at once). */
      var isStacked = root.classList.contains('bt-faqc--stacked');
      if (!isStacked) {
        root.querySelectorAll('[data-bt-faqc-nav-btn]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var idx = btn.getAttribute('data-bt-faqc-nav-btn');
            root.querySelectorAll('[data-bt-faqc-nav-btn]').forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            root.querySelectorAll('[data-bt-faqc-panel]').forEach(function (p) {
              p.classList.toggle('is-active', p.getAttribute('data-bt-faqc-panel') === idx);
            });
          });
        });
      }

      /* Search — filter Q&A items across all panels by matching the
         question text (case-insensitive). When a query is active, all
         panels become visible so matches across categories are shown. */
      var search = root.querySelector('[data-bt-faqc-search]');
      var emptyMsg = root.querySelector('[data-bt-faqc-empty]');
      if (search) {
        var allPanels = root.querySelectorAll('[data-bt-faqc-panel]');
        var allItems = root.querySelectorAll('[data-bt-faqc-item]');
        var navBtns = root.querySelectorAll('[data-bt-faqc-nav-btn]');

        function applyFilter() {
          var q = (search.value || '').trim().toLowerCase();
          if (!q) {
            /* Clear filter — restore tab/sidebar mode */
            allItems.forEach(function (it) { it.classList.remove('is-hidden'); });
            if (!isStacked) {
              allPanels.forEach(function (p) {
                p.classList.toggle('is-active', p.getAttribute('data-bt-faqc-panel') === '1');
              });
              navBtns.forEach(function (b) {
                b.classList.toggle('is-active', b.getAttribute('data-bt-faqc-nav-btn') === '1');
              });
            }
            if (emptyMsg) emptyMsg.classList.remove('is-visible');
            return;
          }
          /* Active query — show all panels, hide non-matching items. */
          allPanels.forEach(function (p) { p.classList.add('is-active'); });
          var matched = 0;
          allItems.forEach(function (it) {
            var text = it.getAttribute('data-bt-faqc-q') || '';
            var ans = (it.querySelector('.bt-faqc__a') || {}).textContent || '';
            var hit = text.indexOf(q) !== -1 || ans.toLowerCase().indexOf(q) !== -1;
            it.classList.toggle('is-hidden', !hit);
            if (hit) matched++;
          });
          if (emptyMsg) emptyMsg.classList.toggle('is-visible', matched === 0);
          /* Hide nav while searching to clarify cross-category matches */
          navBtns.forEach(function (b) { b.classList.remove('is-active'); });
        }

        search.addEventListener('input', applyFilter);
      }
    }
    document.querySelectorAll('.bt-faqc').forEach(initSection);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('.bt-faqc').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-features-with-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Smooth scroll-to-top for any CTA button marked with `data-bt-fwi-scroll-top`.
       We attach a single delegated listener on document so it works for buttons
       added later (e.g. customizer re-renders) without re-binding. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bt-fwi-scroll-top]');
      if (!btn) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-gallery-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      scope.querySelectorAll('[data-bt-gw]').forEach(function (root) {
        if (root.dataset.btGwReady === '1') return;
        root.dataset.btGwReady = '1';

        var wrap = root.querySelector('[data-bt-gw-wrap]');
        var moreBtn = root.querySelector('[data-bt-gw-more]');
        if (moreBtn && wrap) {
          // Hide the toggle when the wall already fits into the collapsed height.
          var check = function () {
            var wall = wrap.querySelector('.bt-gw__wall');
            var overflows = wall.scrollHeight > wrap.clientHeight + 20;
            moreBtn.hidden = wrap.classList.contains('is-collapsed') && !overflows;
          };
          check();
          window.addEventListener('resize', check);

          moreBtn.addEventListener('click', function () {
            var collapsed = wrap.classList.toggle('is-collapsed');
            moreBtn.querySelector('[data-bt-gw-more-label]').hidden = !collapsed;
            moreBtn.querySelector('[data-bt-gw-less-label]').hidden = collapsed;
            if (collapsed) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }

        var lb = root.querySelector('[data-bt-gw-lightbox]');
        var lbImg = root.querySelector('[data-bt-gw-lb-img]');
        root.querySelectorAll('[data-bt-gw-zoom]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            lbImg.src = btn.getAttribute('data-bt-gw-zoom');
            lb.hidden = false;
            document.documentElement.style.overflow = 'hidden';
          });
        });
        function close() {
          lb.hidden = true;
          lbImg.src = '';
          document.documentElement.style.overflow = '';
        }
        lb.addEventListener('click', function (e) {
          if (e.target === lb || e.target.closest('[data-bt-gw-close]')) close();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !lb.hidden) close();
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-gift-ready"] && !Shopify.designMode) return;
  try {
    
  // Lazy video: attach src only when the section is on screen; pause off-screen.
  (function () {
    function init(scope) {
      if (!('IntersectionObserver' in window)) {
        scope.querySelectorAll('[data-bt-gfr-video] video').forEach(function (v) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
        });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting) {
            if (!v.src && v.dataset.src) v.src = v.dataset.src;
            v.playsInline = true;
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (v.src) {
            v.pause();
          }
        });
      }, { threshold: 0.25 });

      scope.querySelectorAll('[data-bt-gfr-video]').forEach(function (wrap) {
        if (wrap.dataset.btReady === '1') return;
        wrap.dataset.btReady = '1';
        io.observe(wrap);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-live-designs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function relTime(iso, L) {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      var mins = Math.floor((Date.now() - d.getTime()) / 60000);
      if (mins < 0) mins = 0;
      if (mins < 5) return L.now;
      if (mins < 60) return mins + L.min;
      var hours = Math.floor(mins / 60);
      if (hours < 24) return hours + L.hour;
      var days = Math.floor(hours / 24);
      if (days === 1) return L.yesterday;
      if (days < 7) return days + L.days;
      return Math.floor(days / 7) + L.weeks;
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
      });
    }

    function load(root) {
      var apiBase = root.getAttribute('data-api-base');
      var designType = root.getAttribute('data-type') || 'mini';
      var localesParam = root.getAttribute('data-locales') || '';
      var labelFrame = root.getAttribute('data-label-frame') || '';
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 10;
      var showCtaCard = root.getAttribute('data-show-cta-card') === 'true';
      var ctaUrl = root.getAttribute('data-cta-url') || '#';
      var labelKeychain = root.getAttribute('data-label-keychain') || '';
      var labelFigure = root.getAttribute('data-label-figure') || '';
      var ctaCardText = root.getAttribute('data-cta-card-text') || '';
      var L = {
        now: root.getAttribute('data-label-now') || 'przed chwilą',
        min: root.getAttribute('data-t-min') || ' min temu',
        hour: root.getAttribute('data-t-hour') || ' godz. temu',
        yesterday: root.getAttribute('data-t-yesterday') || 'wczoraj',
        days: root.getAttribute('data-t-days') || ' dn. temu',
        weeks: root.getAttribute('data-t-weeks') || ' tyg. temu'
      };

      var wrap = root.querySelector('[data-bt-live-wrap]');
      var strip = root.querySelector('[data-bt-live-strip]');
      var skeleton = root.querySelector('[data-bt-live-skeleton]');

      // Кеш останньої вдалої відповіді. Стрічка малюється з нього ОДРАЗУ,
      // а мережевий запит лише оновлює її. Якщо API тупить або лежить —
      // покупець бачить реальні дизайни, а не скелетони чи порожнє місце.
      var cacheKey = 'btLive:' + designType + ':' + localesParam;
      var CACHE_TTL_MS = 7 * 24 * 3600 * 1000;
      var FETCH_TIMEOUT_MS = 12000;

      function readCache() {
        try {
          var c = JSON.parse(localStorage.getItem(cacheKey) || 'null');
          if (!c || !c.designs || !c.designs.length) return null;
          if (Date.now() - (c.savedAt || 0) > CACHE_TTL_MS) return null;
          return c.designs;
        } catch (e) { return null; }
      }
      function writeCache(designs) {
        try {
          localStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), designs: designs }));
        } catch (e) { /* приватний режим / переповнений storage — не критично */ }
      }

      function render(designs) {
        // Підпис «N хв тому» показуємо, лише поки він працює НА нас: дизайн,
        // старший за вікно свіжості, малюється без часу — тихий день не має
        // рекламувати себе як «3 дні тому». Для кешу це теж рятівне: старі
        // картки просто втрачають підпис, а не брешуть.
        var freshHours = parseFloat(root.getAttribute('data-time-fresh-hours')) || 0;

        var cards = designs.map(function (d) {
          var t = relTime(d.createdAt, L);
          if (freshHours > 0 && d.createdAt) {
            var ageMins = (Date.now() - new Date(d.createdAt).getTime()) / 60000;
            if (isNaN(ageMins) || ageMins > freshHours * 60) t = '';
          }
          var isNow = t === L.now;
          var tag = designType === 'frame'
            ? (labelFrame + (d.frameSize ? ' ' + d.frameSize : '')).trim()
            : (d.keychain ? labelKeychain : labelFigure);
          return '<div class="bt-live__card">' +
            // 30.09.2026: thumbUrl — зменшена WebP-копія зі складу (~10 КБ замість 120–245 КБ оригіналу);
            // якщо вона не відкрилась — пробуємо оригінал, і лише потім ховаємо картку.
            '<img class="bt-live__img" src="' + esc(d.thumbUrl || d.previewUrl) + '"' +
              (d.thumbUrl ? ' data-orig="' + esc(d.previewUrl) + '"' : '') +
              ' alt="' + esc(tag) + '" loading="lazy" width="300" height="300"' +
              ' onerror="if(this.dataset.orig){var o=this.dataset.orig;this.removeAttribute(&quot;data-orig&quot;);this.src=o;}else{var c=this.closest(&quot;.bt-live__card&quot;); if(c) c.hidden=true;}">' +
            (t ? '<div class="bt-live__time' + (isNow ? ' bt-live__time--now' : '') + '">' + esc(t) + '</div>' : '') +
            (tag ? '<div class="bt-live__tag">' + esc(tag) + '</div>' : '') +
          '</div>';
        }).join('');

        if (showCtaCard && ctaCardText) {
          cards += '<a class="bt-live__cta" href="' + esc(ctaUrl) + '">' +
            '<span class="bt-live__cta-plus" aria-hidden="true">+</span>' +
            '<span class="bt-live__cta-label">' + ctaCardText + '</span>' +
          '</a>';
        }

        // Дублюємо набір, щоб marquee-цикл був безшовним (анімація зсуває на −50%).
        strip.innerHTML = cards + cards;
        if (skeleton) skeleton.hidden = true;
        strip.hidden = false;
      }

      var rendered = false;
      var cached = readCache();
      if (cached) { render(cached); rendered = true; }

      function fail() {
        // На екрані вже є кеш — нічого не чіпаємо, хай стоїть.
        if (rendered) return;
        // Дані не приїхали — прибираємо скелетони, щоб секція не «висіла».
        if (skeleton) skeleton.hidden = true;
        if (wrap) wrap.hidden = true;
      }

      // Запит не має права висіти вічно: без обмеження один повільний
      // роут тримав скелетони по 20+ секунд.
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { ctrl ? ctrl.abort() : fail(); }, FETCH_TIMEOUT_MS);

      fetch(apiBase + '/api/public/recent-designs?limit=' + limit + '&type=' + encodeURIComponent(designType) +
            (localesParam ? '&locales=' + encodeURIComponent(localesParam) : ''),
            ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          clearTimeout(timer);
          if (!data || !data.success || !data.designs || !data.designs.length) { fail(); return; }
          writeCache(data.designs);
          render(data.designs);
          rendered = true;
        })
        .catch(function () { clearTimeout(timer); fail(); });
    }

    function init(root) {
      if (!root || root.__btLiveReady) return;
      root.__btLiveReady = true;
      // CTA веде на верх сторінки (до блока покупки), а не на посилання —
      // якщо увімкнено відповідний чекбокс.
      if (root.getAttribute('data-cta-scroll-top') === 'true') {
        root.addEventListener('click', function (e) {
          if (e.target.closest('.bt-live__btn, .bt-live__cta')) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { io.disconnect(); load(root); }
          });
        }, { rootMargin: '800px 0px' });
        io.observe(root);
      } else {
        load(root);
      }
    }

    document.querySelectorAll('[data-bt-live]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-live]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-magnet-click"] && !Shopify.designMode) return;
  try {
    
  // Lazy video: attach src only when the section is on screen; pause off-screen.
  (function () {
    function init(scope) {
      if (!('IntersectionObserver' in window)) {
        // No IO — attach immediately so the section still works.
        scope.querySelectorAll('[data-bt-mgc-video] video').forEach(function (v) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
        });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting) {
            if (!v.src && v.dataset.src) v.src = v.dataset.src;
            v.playsInline = true;
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (v.src) {
            v.pause();
          }
        });
      }, { threshold: 0.25 });

      scope.querySelectorAll('[data-bt-mgc-video]').forEach(function (wrap) {
        if (wrap.dataset.btReady === '1') return;
        wrap.dataset.btReady = '1';
        io.observe(wrap);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-scroll-to-top"] && !Shopify.designMode) return;
  try {
    
  /* Floating scroll-to-top button.
     - Tracks scroll position via rAF-throttled `scroll` listener (passive)
     - Computes scroll percentage relative to total page height
     - Toggles `.is-visible` once threshold is crossed
     - On click, smoothly scrolls window to top
     - Re-evaluates on resize (page height can change e.g. when accordions open) */
  (function () {
    var btns = document.querySelectorAll('[data-bt-scroll-top]');
    if (!btns.length) return;

    var ticking = false;

    function evaluate() {
      var scrolled = window.scrollY || document.documentElement.scrollTop || 0;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? (scrolled / total) * 100 : 0;

      btns.forEach(function (btn) {
        var threshold = parseFloat(btn.dataset.threshold);
        if (isNaN(threshold)) threshold = 50;
        btn.classList.toggle('is-visible', pct >= threshold);
      });
      ticking = false;
    }

    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(evaluate);
        ticking = true;
      }
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          /* Fallback for older browsers without smooth-scroll support */
          window.scrollTo(0, 0);
        }
      });
    });

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    evaluate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-story-narrative"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hasIO = ('IntersectionObserver' in window);

    function initArrowDraw() {
      if (!hasIO) {
        // Fallback: just mark all arrows as drawn so the line is visible
        document.querySelectorAll('.bt-narr__intro-arrow').forEach(function (svg) {
          svg.classList.add('is-drawn');
        });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-drawn');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.bt-narr__intro-arrow').forEach(function (svg) {
        observer.observe(svg);
      });
    }

    /* Slide-in trigger for the CTA right image. Adds .is-in-view when the
       element enters the viewport so the CSS transition from "off-screen
       right" to "user position" plays once. We unobserve after firing so the
       animation never replays on subsequent scrolls. */
    function initCtaImageAnim() {
      var els = document.querySelectorAll('.bt-narr__cta-image--anim');
      if (!els.length) return;
      if (!hasIO) {
        els.forEach(function (el) { el.classList.add('is-in-view'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
      els.forEach(function (el) { observer.observe(el); });
    }

    function init() {
      initArrowDraw();
      initCtaImageAnim();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-whats-included"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupBlock(el) {
      if (el.__btWiInit) return;
      el.__btWiInit = true;

      var items = Array.prototype.slice.call(el.querySelectorAll('[data-wi-item]'));
      var medias = Array.prototype.slice.call(el.querySelectorAll('[data-wi-media]'));
      var progress = el.querySelector('[data-wi-progress]');
      var autoplay = el.dataset.autoplay === 'true' && items.length > 1;
      var interval = parseInt(el.dataset.autoplayInterval, 10) || 4500;
      if (!items.length) return;

      var currentIdx = 0;
      var timer = null;
      var rafId = null;
      var cycleStart = 0;
      var hovered = false;

      function setActive(idx) {
        currentIdx = ((idx % items.length) + items.length) % items.length;
        items.forEach(function (item, i) {
          var on = (i === currentIdx);
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        medias.forEach(function (m, i) {
          var on = (i === currentIdx);
          m.classList.toggle('is-active', on);
          m.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      }

      function advance() { setActive(currentIdx + 1); }

      function stepProgress() {
        if (!progress || !autoplay || hovered) return;
        var elapsed = performance.now() - cycleStart;
        var pct = Math.min(1, elapsed / interval);
        progress.style.transform = 'scaleX(' + pct + ')';
        if (pct >= 1) {
          cycleStart = performance.now();
          advance();
        }
        rafId = requestAnimationFrame(stepProgress);
      }

      function startAuto() {
        stopAuto();
        if (!autoplay) return;
        cycleStart = performance.now();
        rafId = requestAnimationFrame(stepProgress);
      }
      function stopAuto() {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        if (progress) progress.style.transform = 'scaleX(0)';
      }

      // Click / keyboard activation
      items.forEach(function (item, i) {
        item.addEventListener('click', function () {
          setActive(i);
          startAuto(); // reset cycle timer
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setActive(i);
            startAuto();
          } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            var next = (i + 1) % items.length;
            items[next].focus();
            setActive(next);
            startAuto();
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var prev = (i - 1 + items.length) % items.length;
            items[prev].focus();
            setActive(prev);
            startAuto();
          }
        });
      });

      // Pause on hover/focus, resume on leave
      el.addEventListener('mouseenter', function () { hovered = true; stopAuto(); });
      el.addEventListener('mouseleave', function () { hovered = false; startAuto(); });

      // Pause when tab not visible
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAuto();
        else if (!hovered) startAuto();
      });

      setActive(0);
      startAuto();
    }

    function init() {
      document.querySelectorAll('[data-bt-wi]').forEach(setupBlock);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-wi]').forEach(setupBlock);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products-bricktopia"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      if (!root || root.__btCpReady) return;
      root.__btCpReady = true;

      // Cards are rendered server-side from the chosen collection — no fetch.
      initCards(root);
    }

    function initCards(root) {
      // Image gallery
      root.querySelectorAll('.bt-cp__card').forEach(function(card) {
        if (card.__btGalleryReady) return;
        var wrap = card.querySelector('.bt-cp__card-imgwrap');
        if (!wrap) return;
        var imgs = wrap.querySelectorAll('.bt-cp__card-img');
        var dots = card.querySelectorAll('.bt-cp__card-dot-btn');
        if (imgs.length < 2) return;
        card.__btGalleryReady = true;

        var current = 0, pinned = false;
        var startX = 0, startY = 0, startT = 0;
        var swipeDetected = false, swipeBlocked = false;
        var link = card.querySelector('.bt-cp__card-link');

        function show(idx) {
          if (idx < 0) idx = imgs.length - 1;
          if (idx >= imgs.length) idx = 0;
          current = idx;
          for (var i = 0; i < imgs.length; i++) imgs[i].classList.toggle('is-active', i === idx);
          for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === idx);
        }

        card.addEventListener('mouseenter', function() { if (!pinned) show(1); });
        card.addEventListener('mouseleave', function() { if (!pinned) show(0); });
        dots.forEach(function(dot, idx) {
          dot.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation(); pinned = true; show(idx);
          });
        });
        card.querySelectorAll('[data-bt-card-arrow]').forEach(function(arrow) {
          arrow.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation(); pinned = true;
            var dir = arrow.getAttribute('data-bt-card-arrow');
            show(dir === 'next' ? current + 1 : current - 1);
          });
        });

        wrap.addEventListener('touchstart', function(e) {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX; startY = e.touches[0].clientY; startT = Date.now();
          swipeDetected = false;
        }, { passive: true });
        wrap.addEventListener('touchmove', function(e) {
          if (e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          if (!swipeDetected) {
            if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) swipeDetected = true;
          }
          if (swipeDetected && e.cancelable) e.preventDefault();
        }, { passive: false });
        wrap.addEventListener('touchend', function(e) {
          if (!swipeDetected) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 25) { swipeDetected = false; return; }
          pinned = true;
          show(dx < 0 ? current + 1 : current - 1);
          swipeBlocked = true;
          setTimeout(function() { swipeBlocked = false; }, 350);
        }, { passive: true });
        wrap.addEventListener('touchcancel', function() { swipeDetected = false; }, { passive: true });
        if (link) {
          link.addEventListener('click', function(e) {
            if (swipeBlocked) { e.preventDefault(); e.stopPropagation(); }
          }, true);
        }
      });

      // Desktop slider arrows
      var scrollEl = root.querySelector('.bt-cp__scroll');
      var navBtns = root.querySelectorAll('[data-bt-cp-nav]');
      if (scrollEl && navBtns.length) {
        var updateNav = function() {
          var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
          navBtns.forEach(function(b) {
            var dir = b.getAttribute('data-bt-cp-nav');
            b.disabled = dir === 'prev' ? scrollEl.scrollLeft <= 2 : scrollEl.scrollLeft >= maxScroll - 2;
          });
        };
        navBtns.forEach(function(btn) {
          if (btn.__btNavReady) return;
          btn.__btNavReady = true;
          btn.addEventListener('click', function() {
            var card = scrollEl.querySelector('.bt-cp__card');
            if (!card) return;
            var grid = scrollEl.querySelector('.bt-cp__grid');
            var gap = grid ? parseFloat(getComputedStyle(grid).columnGap) || 20 : 20;
            var step = card.offsetWidth + gap;
            scrollEl.scrollBy({ left: btn.getAttribute('data-bt-cp-nav') === 'next' ? step : -step, behavior: 'smooth' });
          });
        });
        scrollEl.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav, { passive: true });
        updateNav();
      }

      // Quantity + cart
      root.querySelectorAll('[data-bt-addform]').forEach(function(form) {
        if (form.__btAddReady) return;
        form.__btAddReady = true;
        var valEl = form.querySelector('[data-bt-qty-val]');
        var qtyInput = form.querySelector('[data-bt-qty-input]');
        var cartBtn = form.querySelector('.bt-cp__cart-btn');
        var qty = 1;
        function setQty(v) {
          qty = Math.max(1, Math.min(99, v));
          valEl.textContent = String(qty);
          qtyInput.value = qty;
        }
        form.querySelectorAll('[data-bt-qty-dir]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            setQty(btn.getAttribute('data-bt-qty-dir') === 'plus' ? qty + 1 : qty - 1);
          });
        });
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          if (cartBtn.disabled || cartBtn.classList.contains('is-loading')) return;
          cartBtn.classList.add('is-loading');
          var fd = new FormData(form);
          fd.set('quantity', String(qty));

          flyImageToCart(form);

          var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
          fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          })
          .then(function(r) { return r.json().then(function(j) { return { ok: r.ok, body: j }; }); })
          .then(function(res) {
            cartBtn.classList.remove('is-loading');
            if (!res.ok) throw res.body;
            cartBtn.classList.add('is-success');
            setTimeout(function() { cartBtn.classList.remove('is-success'); }, 1400);
            refreshCartUI();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('bt:cart:added', { detail: res.body }));
            var drawer = document.querySelector('cart-drawer, cart-notification, cart-items-component');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          })
          .catch(function(err) {
            cartBtn.classList.remove('is-loading');
            console.warn('[bt-cp] add to cart failed', err);
          });
        });
      });
    }

    function refreshCartUI() {
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var count = cart.item_count;
          fetch(window.location.pathname + '?sections=header')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (!data || !data.header) return;
              var parser = new DOMParser();
              var doc = parser.parseFromString(data.header, 'text/html');
              ['cart-icon-bubble', 'cart-live-region-text'].forEach(function(id) {
                var newEl = doc.getElementById(id);
                var oldEl = document.getElementById(id);
                if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
              });
              var newBubble = doc.querySelector('.cart-count-bubble, cart-count, [data-cart-count]');
              var oldBubble = document.querySelector('.cart-count-bubble, cart-count, [data-cart-count]');
              if (newBubble && oldBubble) oldBubble.outerHTML = newBubble.outerHTML;
            })
            .catch(function() {});
          var selectors = ['.cart-count-bubble span:first-child', '.cart-count-bubble', '.cart-count', '[data-cart-count]', '.header__cart-count', '#cart-icon-bubble span', '#cart-count'];
          selectors.forEach(function(sel) {
            document.querySelectorAll(sel).forEach(function(el) {
              var text = (el.textContent || '').trim();
              if (!text || /^\d+$/.test(text)) {
                el.textContent = count > 0 ? count : '';
                if (count > 0) {
                  el.hidden = false; el.removeAttribute('hidden'); el.classList.remove('hidden'); el.style.display = '';
                }
              }
            });
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bt-cp', cartData: cart }); } catch (e) {}
          }
        })
        .catch(function(err) { console.warn('[bt-cp] refreshCartUI failed', err); });
    }

    function findCartTarget() {
      var selectors = [
        'cart-icon', 'cart-drawer', 'cart-notification',
        '[data-cart-icon]', '[data-header-cart]', '.header__icon--cart',
        'a[href="/cart"]', 'a[href*="/cart"]:not([href*="/cart/add"])',
        '[aria-label*="cart" i]', '[aria-label*="кошик" i]', '[aria-label*="koszyk" i]',
        '.cart-count-bubble', '.cart-icon', '#cart-icon-bubble'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetParent !== null) return el;
      }
      return null;
    }

    function flyImageToCart(form) {
      var card = form.closest('.bt-cp__card');
      if (!card) return;
      var srcImg = card.querySelector('.bt-cp__card-imgwrap img');
      if (!srcImg) return;
      var target = findCartTarget();
      var tRect = target ? target.getBoundingClientRect() : { left: window.innerWidth - 50, top: 20, width: 40, height: 40 };
      var sRect = srcImg.getBoundingClientRect();

      var fly = document.createElement('div');
      fly.className = 'bt-cart-fly';
      fly.style.left = sRect.left + 'px';
      fly.style.top = sRect.top + 'px';
      fly.style.width = sRect.width + 'px';
      fly.style.height = sRect.height + 'px';
      var img = document.createElement('img');
      img.src = srcImg.currentSrc || srcImg.src;
      img.alt = '';
      fly.appendChild(img);
      document.body.appendChild(fly);
      fly.offsetWidth;

      var targetX = tRect.left + tRect.width / 2 - sRect.width / 2;
      var targetY = tRect.top + tRect.height / 2 - sRect.height / 2;
      fly.style.transform = 'translate(' + (targetX - sRect.left) + 'px, ' + (targetY - sRect.top) + 'px) scale(' + Math.max(0.1, Math.min(tRect.width, tRect.height) / Math.max(sRect.width, sRect.height)) + ')';
      fly.classList.add('is-flying');

      fly.addEventListener('transitionend', function onEnd() {
        fly.removeEventListener('transitionend', onEnd);
        fly.remove();
        if (target) {
          target.classList.add('bt-cart-target-bounce');
          setTimeout(function() { target.classList.remove('bt-cart-target-bounce'); }, 600);
        }
      });
      setTimeout(function() { if (fly.parentNode) fly.remove(); }, 1500);
    }

    document.querySelectorAll('[data-bt-cp]').forEach(init);
    document.addEventListener('shopify:section:load', function(e) {
      if (e.target) e.target.querySelectorAll('[data-bt-cp]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-bricktopia"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      if (!root || root.__btCollReady) return;
      root.__btCollReady = true;

      // Shopper-facing "products per row" switcher (persists in localStorage)
      root.querySelectorAll('[data-bt-cols-switch]').forEach(function(sw) {
        var scope = sw.getAttribute('data-scope');
        sw.querySelectorAll('[data-bt-cols]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            try { localStorage.setItem(scope === 'm' ? 'btCollColsM2' : 'btCollColsD2', btn.getAttribute('data-bt-cols')); } catch (e) {}
            applyCols(root);
          });
        });
      });
      applyCols(root);

      // Filter sidebar toggle (mobile)
      var toggle = root.querySelector('[data-bt-coll-filter-toggle]');
      var closeBtn = root.querySelector('[data-bt-coll-close]');
      var overlay = root.querySelector('[data-bt-coll-overlay]');
      if (toggle) toggle.addEventListener('click', function() { root.classList.add('is-filter-open'); });
      if (closeBtn) closeBtn.addEventListener('click', function() { root.classList.remove('is-filter-open'); });
      if (overlay) overlay.addEventListener('click', function() { root.classList.remove('is-filter-open'); });

      // Product-card interactions (gallery + quick-buy) — extracted so AJAX
      // pages can re-bind the newly injected cards.
      bindGalleries(root);
      bindAddForms(root);

      // AJAX pagination — swap products in place without a full reload.
      bindPagination(root);

      // Smart search — predictive, catalog-wide instant results.
      bindSearch(root);
    }

    // ---- Smart search -------------------------------------------------------
    // Predictive search over the whole catalog with an instant results dropdown.
    function bindSearch(root) {
      var box = root.querySelector('[data-bt-search]');
      if (!box || box.__btSearchReady) return;
      box.__btSearchReady = true;

      var form = box.querySelector('.bt-coll__search-form');
      var input = box.querySelector('[data-bt-search-input]');
      var panel = box.querySelector('[data-bt-search-panel]');
      var results = box.querySelector('[data-bt-search-results]');
      var clearBtn = box.querySelector('[data-bt-search-clear]');
      if (!input || !panel || !results) return;

      var currency = box.getAttribute('data-currency') || '';
      var minChars = parseInt(box.getAttribute('data-min-chars'), 10) || 2;
      var allLabel = box.getAttribute('data-all-label') || 'Pokaż wszystkie wyniki';
      var emptyLabel = box.getAttribute('data-empty-label') || 'Nic nie znaleziono';
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

      var timer = null;
      var activeIdx = -1;
      var lastQuery = '';
      var reqId = 0;

      function fmtPrice(p) {
        if (p == null || p === '') return '';
        var n = typeof p === 'number' ? p : parseFloat(String(p).replace(',', '.'));
        if (isNaN(n)) return '';
        var s = (Math.round(n * 100) % 100 === 0) ? String(Math.round(n)) : n.toFixed(2);
        return s + (currency ? ' ' + currency : '');
      }

      function openPanel() { panel.hidden = false; box.setAttribute('data-open', ''); }
      function closePanel() {
        panel.hidden = true;
        box.removeAttribute('data-open');
        activeIdx = -1;
      }

      function items() { return results.querySelectorAll('.bt-coll__search-item'); }

      function setActive(idx) {
        var list = items();
        if (!list.length) return;
        if (idx < 0) idx = list.length - 1;
        if (idx >= list.length) idx = 0;
        activeIdx = idx;
        list.forEach(function(el, i) { el.classList.toggle('is-active', i === idx); });
        list[idx].scrollIntoView({ block: 'nearest' });
      }

      function render(products, query) {
        var html = '';
        if (!products.length) {
          html = '<div class="bt-coll__search-empty">' + escapeHtml(emptyLabel) + '</div>';
        } else {
          products.forEach(function(p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            var price = fmtPrice(p.price != null ? p.price : p.price_min);
            var cmp = fmtPrice(p.compare_at_price_min);
            var showCmp = cmp && p.compare_at_price_min && parseFloat(String(p.compare_at_price_min).replace(',', '.')) > parseFloat(String(p.price != null ? p.price : p.price_min).replace(',', '.'));
            html += '<a class="bt-coll__search-item" role="option" href="' + escapeAttr(p.url) + '">' +
              (img ? '<img class="bt-coll__search-thumb" src="' + escapeAttr(img) + '" alt="" loading="lazy" width="52" height="52">' : '<span class="bt-coll__search-thumb"></span>') +
              '<span class="bt-coll__search-meta">' +
                '<span class="bt-coll__search-title">' + escapeHtml(p.title || '') + '</span>' +
                (price ? '<span class="bt-coll__search-price">' + escapeHtml(price) + (showCmp ? '<s>' + escapeHtml(cmp) + '</s>' : '') + '</span>' : '') +
              '</span>' +
            '</a>';
          });
          html += '<a class="bt-coll__search-all" href="' + escapeAttr(routeRoot + 'search?q=' + encodeURIComponent(query) + '&type=product') + '">' + escapeHtml(allLabel) + '</a>';
        }
        results.innerHTML = html;
        activeIdx = -1;
        openPanel();
      }

      function fetchResults(query) {
        var myId = ++reqId;
        var url = routeRoot + 'search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (myId !== reqId) return; // a newer request superseded this one
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, query);
          })
          .catch(function() {
            if (myId !== reqId) return;
            closePanel();
          });
      }

      function onInput() {
        var q = input.value.trim();
        clearBtn.hidden = input.value.length === 0;
        if (q.length < minChars) {
          lastQuery = '';
          closePanel();
          return;
        }
        if (q === lastQuery) { openPanel(); return; }
        lastQuery = q;
        clearTimeout(timer);
        timer = setTimeout(function() { fetchResults(q); }, 220);
      }

      input.addEventListener('input', onInput);
      input.addEventListener('focus', function() {
        if (input.value.trim().length >= minChars && results.children.length) openPanel();
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); openPanel(); setActive(activeIdx + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
        else if (e.key === 'Enter') {
          var list = items();
          if (activeIdx >= 0 && list[activeIdx]) { e.preventDefault(); window.location.href = list[activeIdx].getAttribute('href'); }
          // otherwise let the form submit to the full search results page
        } else if (e.key === 'Escape') { closePanel(); input.blur(); }
      });

      clearBtn.addEventListener('click', function() {
        input.value = '';
        lastQuery = '';
        clearBtn.hidden = true;
        closePanel();
        input.focus();
      });

      // Close when clicking outside the search box.
      document.addEventListener('click', function(e) {
        if (!box.contains(e.target)) closePanel();
      });

      // Don't let a bare Enter (no highlight, empty-ish) reload if query too short.
      form.addEventListener('submit', function(e) {
        if (input.value.trim().length < minChars) e.preventDefault();
      });
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function escapeAttr(s) { return escapeHtml(s); }

    // Image gallery: hover swap + dots + touch swipe. Idempotent per card.
    function bindGalleries(scope) {
      scope.querySelectorAll('.bt-coll__card').forEach(function(card) {
        if (card.__btGalleryReady) return;
        var wrap = card.querySelector('.bt-coll__card-imgwrap');
        if (!wrap) return;
        var imgs = wrap.querySelectorAll('.bt-coll__card-img');
        var dots = card.querySelectorAll('.bt-coll__card-dot-btn');
        if (imgs.length < 2) return;
        card.__btGalleryReady = true;

        var current = 0;
        var pinned = false;

        function show(idx) {
          if (idx < 0) idx = imgs.length - 1;
          if (idx >= imgs.length) idx = 0;
          current = idx;
          for (var i = 0; i < imgs.length; i++) {
            imgs[i].classList.toggle('is-active', i === idx);
          }
          for (var j = 0; j < dots.length; j++) {
            dots[j].classList.toggle('is-active', j === idx);
          }
        }

        card.addEventListener('mouseenter', function() {
          if (!pinned) show(1);
        });
        card.addEventListener('mouseleave', function() {
          if (!pinned) show(0);
        });

        dots.forEach(function(dot, idx) {
          dot.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            pinned = true;
            show(idx);
          });
        });

        // Desktop arrows
        card.querySelectorAll('[data-bt-card-arrow]').forEach(function(arrow) {
          arrow.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            pinned = true;
            var dir = arrow.getAttribute('data-bt-card-arrow');
            show(dir === 'next' ? current + 1 : current - 1);
          });
        });

        // Touch swipe (mobile)
        var startX = 0, startY = 0;
        var swipeDetected = false;
        var swipeBlocked = false;
        var link = card.querySelector('.bt-coll__card-link');

        wrap.addEventListener('touchstart', function(e) {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          swipeDetected = false;
        }, { passive: true });

        wrap.addEventListener('touchmove', function(e) {
          if (e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          if (!swipeDetected) {
            if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) {
              swipeDetected = true;
            }
          }
          if (swipeDetected) {
            // Block browser gesture (back-swipe) and scroll
            if (e.cancelable) e.preventDefault();
          }
        }, { passive: false });

        wrap.addEventListener('touchend', function(e) {
          if (!swipeDetected) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 25) { swipeDetected = false; return; }
          pinned = true;
          show(dx < 0 ? current + 1 : current - 1);
          swipeBlocked = true;
          setTimeout(function() { swipeBlocked = false; }, 350);
        }, { passive: true });

        wrap.addEventListener('touchcancel', function() {
          swipeDetected = false;
        }, { passive: true });

        // Block the link click ONLY when a swipe just happened
        if (link) {
          link.addEventListener('click', function(e) {
            if (swipeBlocked) {
              e.preventDefault();
              e.stopPropagation();
            }
          }, true); // capture so we run before any descendant handler
        }
      });
    }

    // Quantity steppers + AJAX add to cart. Idempotent per form.
    function bindAddForms(scope) {
      scope.querySelectorAll('[data-bt-addform]').forEach(function(form) {
        if (form.__btFormReady) return;
        form.__btFormReady = true;
        var valEl = form.querySelector('[data-bt-qty-val]');
        var qtyInput = form.querySelector('[data-bt-qty-input]');
        var cartBtn = form.querySelector('.bt-coll__cart-btn');
        var qty = 1;
        var setQty = function(v) {
          qty = Math.max(1, Math.min(99, v));
          valEl.textContent = String(qty);
          qtyInput.value = qty;
        };

        form.querySelectorAll('[data-bt-qty-dir]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var d = btn.getAttribute('data-bt-qty-dir');
            setQty(d === 'plus' ? qty + 1 : qty - 1);
          });
        });

        form.addEventListener('submit', function(e) {
          e.preventDefault();
          if (cartBtn.disabled || cartBtn.classList.contains('is-loading')) return;
          cartBtn.classList.add('is-loading');

          var fd = new FormData(form);
          fd.set('quantity', String(qty));

          // Start fly animation immediately (looks nicer than waiting on server)
          flyImageToCart(form);

          var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
          fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          })
          .then(function(r) { return r.json().then(function(j) { return { ok: r.ok, body: j }; }); })
          .then(function(res) {
            cartBtn.classList.remove('is-loading');
            if (!res.ok) throw res.body;
            cartBtn.classList.add('is-success');
            setTimeout(function() { cartBtn.classList.remove('is-success'); }, 1400);
            refreshCartUI();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('bt:cart:added', { detail: res.body }));
            var drawer = document.querySelector('cart-drawer, cart-notification, cart-items-component');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          })
          .catch(function(err) {
            cartBtn.classList.remove('is-loading');
            console.warn('[bt-coll] add to cart failed', err);
          });
        });
      });
    }

    // Apply the saved "products per row" choice to the current grid.
    // Looks the grid up fresh each call — AJAX pagination replaces it.
    function applyCols(root) {
      var grid = root.querySelector('.bt-coll__grid');
      var switches = root.querySelectorAll('[data-bt-cols-switch]');
      if (!grid || !switches.length) return;
      switches.forEach(function(sw) {
        var scope = sw.getAttribute('data-scope');
        // v2 keys: bumped 2026-07-31 so old saved choices stop overriding the
        // theme default (desktop = 4 per row). A stale localStorage value from
        // an earlier visit wins forever otherwise.
        var key = scope === 'm' ? 'btCollColsM2' : 'btCollColsD2';
        var saved = null;
        try { saved = localStorage.getItem(key); } catch (e) {}
        var cur = saved || sw.getAttribute('data-default');
        if (saved) {
          if (scope === 'm') grid.style.setProperty('--bt-coll-cols-m', saved);
          else grid.setAttribute('data-grid-cols', saved);
        }
        sw.querySelectorAll('[data-bt-cols]').forEach(function(b) {
          b.classList.toggle('is-active', b.getAttribute('data-bt-cols') === String(cur));
        });
      });
    }

    // ---- AJAX pagination ----------------------------------------------------
    // Intercept clicks on the pagination links, fetch the target page, and swap
    // the product grid + pagination in place. Keeps sidebar/sort/scroll intact.
    function bindPagination(root) {
      if (root.__btPaginationReady) return;
      root.__btPaginationReady = true;

      root.addEventListener('click', function(e) {
        var link = e.target.closest('.bt-coll__pagination a[href]');
        if (!link || !root.contains(link)) return;
        // Allow modifier-clicks / middle-click to open in a new tab as usual.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        loadPage(root, link.getAttribute('href'), true);
      });

      // Handle browser back/forward between paginated states.
      if (!window.__btCollPopstateBound) {
        window.__btCollPopstateBound = true;
        window.addEventListener('popstate', function() {
          document.querySelectorAll('.bt-coll').forEach(function(el) {
            if (el.__btPaginationReady) loadPage(el, window.location.href, false);
          });
        });
      }
    }

    function loadPage(root, url, push) {
      var main = root.querySelector('.bt-coll__main');
      if (!main || !url) return;
      if (main.__btLoading) return;
      main.__btLoading = true;
      main.classList.add('is-loading-page');

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newSection = doc.getElementById(root.id) || doc.querySelector('.bt-coll');
          var newMain = newSection ? newSection.querySelector('.bt-coll__main') : null;
          if (!newMain) throw new Error('grid not found in response');

          main.innerHTML = newMain.innerHTML;
          main.classList.remove('is-loading-page');
          main.__btLoading = false;

          // Re-bind interactions on the freshly injected cards.
          bindGalleries(main);
          bindAddForms(main);
          applyCols(root); // re-apply saved "products per row" to the new grid

          if (push) {
            try { history.pushState({ btColl: true }, '', url); } catch (e) {}
          }

          // Bring the top of the grid into view.
          var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
        })
        .catch(function(err) {
          console.warn('[bt-coll] pagination load failed, falling back to navigation', err);
          main.classList.remove('is-loading-page');
          main.__btLoading = false;
          window.location.href = url; // graceful fallback: normal page load
        });
    }

    // Refresh header cart count after add
    function refreshCartUI() {
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      // 1) Get latest cart
      fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var count = cart.item_count;

          // 2) Try to update header section (works with most Shopify themes)
          fetch(window.location.pathname + '?sections=header')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (!data || !data.header) return;
              var parser = new DOMParser();
              var doc = parser.parseFromString(data.header, 'text/html');
              var targetIds = ['cart-icon-bubble', 'cart-live-region-text'];
              targetIds.forEach(function(id) {
                var newEl = doc.getElementById(id);
                var oldEl = document.getElementById(id);
                if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
              });
              // Replace by class for generic bubbles
              var newBubble = doc.querySelector('.cart-count-bubble, cart-count, [data-cart-count]');
              var oldBubble = document.querySelector('.cart-count-bubble, cart-count, [data-cart-count]');
              if (newBubble && oldBubble) oldBubble.outerHTML = newBubble.outerHTML;
            })
            .catch(function() {});

          // 3) Direct fallback: update text of count elements
          var selectors = [
            '.cart-count-bubble span:first-child',
            '.cart-count-bubble',
            '.cart-count',
            '[data-cart-count]',
            '.header__cart-count',
            '#cart-icon-bubble span',
            '#cart-count'
          ];
          selectors.forEach(function(sel) {
            document.querySelectorAll(sel).forEach(function(el) {
              var text = (el.textContent || '').trim();
              if (!text || /^\d+$/.test(text)) {
                el.textContent = count > 0 ? count : '';
                if (count > 0) {
                  el.hidden = false;
                  el.removeAttribute('hidden');
                  el.classList.remove('hidden');
                  el.style.display = '';
                }
              }
            });
          });

          // 4) Dispatch additional events for various theme listeners
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bt-coll', cartData: cart }); } catch (e) {}
          }
        })
        .catch(function(err) { console.warn('[bt-coll] refreshCartUI failed', err); });
    }

    // Fly-to-cart animation
    function findCartTarget() {
      var selectors = [
        'cart-icon', 'cart-drawer', 'cart-notification',
        '[data-cart-icon]', '[data-header-cart]', '.header__icon--cart',
        'a[href="/cart"]', 'a[href*="/cart"]:not([href*="/cart/add"])',
        '[aria-label*="cart" i]', '[aria-label*="кошик" i]', '[aria-label*="koszyk" i]',
        '.cart-count-bubble', '.cart-icon', '#cart-icon-bubble'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetParent !== null) return el;
      }
      return null;
    }

    function flyImageToCart(form) {
      var card = form.closest('.bt-coll__card');
      if (!card) return;
      var srcImg = card.querySelector('.bt-coll__card-imgwrap img');
      if (!srcImg) return;
      var target = findCartTarget();
      // Fallback: fly to top-right corner
      var tRect = target ? target.getBoundingClientRect() : { left: window.innerWidth - 50, top: 20, width: 40, height: 40 };
      var sRect = srcImg.getBoundingClientRect();

      var fly = document.createElement('div');
      fly.className = 'bt-cart-fly';
      fly.style.left = sRect.left + 'px';
      fly.style.top = sRect.top + 'px';
      fly.style.width = sRect.width + 'px';
      fly.style.height = sRect.height + 'px';
      var img = document.createElement('img');
      img.src = srcImg.currentSrc || srcImg.src;
      img.alt = '';
      fly.appendChild(img);
      document.body.appendChild(fly);

      // Trigger reflow then animate
      // eslint-disable-next-line no-unused-expressions
      fly.offsetWidth;

      var targetX = tRect.left + tRect.width / 2 - sRect.width / 2;
      var targetY = tRect.top + tRect.height / 2 - sRect.height / 2;
      var dx = targetX - sRect.left;
      var dy = targetY - sRect.top;
      var scale = Math.max(0.1, Math.min(tRect.width, tRect.height) / Math.max(sRect.width, sRect.height));

      fly.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ')';
      fly.classList.add('is-flying');

      fly.addEventListener('transitionend', function onEnd() {
        fly.removeEventListener('transitionend', onEnd);
        fly.remove();
        if (target) {
          target.classList.add('bt-cart-target-bounce');
          setTimeout(function() { target.classList.remove('bt-cart-target-bounce'); }, 600);
        }
      });
      // Safety: remove after 1.5s
      setTimeout(function() {
        if (fly.parentNode) fly.remove();
      }, 1500);
    }

    document.querySelectorAll('.bt-coll').forEach(init);
    document.addEventListener('shopify:section:load', function(e) {
      if (e.target) e.target.querySelectorAll('.bt-coll').forEach(init);
    });

    // Empty-state notify-me form. The native Shopify customer form does the real
    // submit (no preventDefault). In parallel the lead goes to sklad («Заявки з
    // сайту») via window.btLead.beacon — ALWAYS, whatever the Telegram setting;
    // the setting only travels as `notify` (sklad sends a short Telegram message
    // or not). data-tg-enabled / data-tg-source exist only when the setting is on.
    // Without assets/bt-lead.js → the old kickflip call, only when the setting is on.
    function bindNotifyForm(wrap) {
      if (!wrap || wrap.__btCollNotifyReady) return;
      wrap.__btCollNotifyReady = true;
      var form = wrap.querySelector('.bt-coll__notify-form');
      if (!form) return;
      var btn = form.querySelector('.bt-coll__notify-btn');
      var tgEnabled = wrap.getAttribute('data-tg-enabled');
      var tgSource = wrap.getAttribute('data-tg-source') || 'Empty collection lead';

      form.addEventListener('submit', function () {
        if (btn) btn.disabled = true;
        var beaconSent = false;
        // Check btLead at submit time, not at init: bt-lead.js is a deferred asset.
        if (window.btLead && typeof window.btLead.beacon === 'function') {
          try {
            var emailIn = form.querySelector('input[name="contact[email]"]');
            var phoneIn = form.querySelector('input[name="contact[phone]"]');
            var noteIn = form.querySelector('input[name="contact[note]"]');
            var tagsIn = form.querySelector('input[name="contact[tags]"]');
            var consentIn = form.querySelector('input[name="contact[accepts_marketing]"]');
            var email = emailIn ? String(emailIn.value || '').trim() : '';
            var phone = phoneIn ? String(phoneIn.value || '').trim() : '';
            var note = noteIn ? String(noteIn.value || '') : '';
            var tags = tagsIn ? String(tagsIn.value || '') : '';
            var handleMatch = /(?:^|,)\s*collection:([^,\s]+)/.exec(tags);
            window.btLead.beacon({
              kind: 'notify_me',
              source: tgSource,
              email: email,
              phone: phone,
              // raw value in `contact` too, so sklad never drops the lead over an email format
              contact_method: email ? 'Email' : (phone ? 'Phone' : ''),
              contact: email || phone,
              details: {
                note: note,
                tags: tags,
                consent: consentIn ? (consentIn.type === 'checkbox' ? !!consentIn.checked : consentIn.value === 'true') : false,
                collection: {
                  handle: handleMatch ? handleMatch[1] : '',
                  title: /^Empty collection:\s*/.test(note) ? note.replace(/^Empty collection:\s*/, '') : ''
                }
              },
              notify: tgEnabled === '1'
            });
            beaconSent = true;
          } catch (e) { /* ignore */ }
        }
        if (tgEnabled && !beaconSent) {
          try {
            var emailEl = form.querySelector('input[name="contact[email]"]');
            var phoneEl = form.querySelector('input[name="contact[phone]"]');
            var noteEl = form.querySelector('input[name="contact[note]"]');
            var lines = [
              '🔔 *' + tgSource + '*',
              '📧 ' + (emailEl ? emailEl.value : '—'),
            ];
            if (phoneEl && phoneEl.value) lines.push('📞 ' + phoneEl.value);
            if (noteEl && noteEl.value) lines.push('📝 ' + noteEl.value);
            lines.push('🌐 ' + window.location.href);
            fetch('https://web-production-05000.up.railway.app/site/notify', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                text: lines.join('\n'),
                parse_mode: 'Markdown'
              }),
              keepalive: true
            }).catch(function () {});
          } catch (e) { /* ignore */ }
        }
      });

      var successEl = wrap.querySelector('[data-bt-coll-notify-success]');
      if (successEl) {
        try { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      }
    }
    document.querySelectorAll('[data-bt-coll-notify]').forEach(bindNotifyForm);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-coll-notify]').forEach(bindNotifyForm);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notify-me"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindForm(root) {
      if (!root || root.__btNotifyReady) return;
      root.__btNotifyReady = true;

      var form = root.querySelector('.bt-notify__form');
      if (!form) return;
      var submit = form.querySelector('.bt-notify__submit');
      var tgEnabled = root.getAttribute('data-tg-enabled');
      var tgSource = root.getAttribute('data-tg-source') || 'Notify-me form';

      // Loading state on submit (Shopify will reload page on success/error)
      form.addEventListener('submit', function () {
        if (submit) {
          submit.classList.add('is-loading');
          submit.disabled = true;
        }

        // Lead → sklad («Заявки з сайту») via window.btLead.beacon — ALWAYS, whatever
        // the Telegram setting; the setting only travels as `notify` (sklad sends a
        // short Telegram message or not). No preventDefault: the native form still
        // submits. Checked at submit time, not at init: bt-lead.js is a deferred asset.
        var beaconSent = false;
        if (window.btLead && typeof window.btLead.beacon === 'function') {
          try {
            var emailIn = form.querySelector('input[name="contact[email]"]');
            var phoneIn = form.querySelector('input[name="contact[phone]"]');
            var noteIn = form.querySelector('input[name="contact[note]"]');
            var tagsIn = form.querySelector('input[name="contact[tags]"]');
            var consentIn = form.querySelector('input[name="contact[accepts_marketing]"]');
            var email = emailIn ? String(emailIn.value || '').trim() : '';
            var phone = phoneIn ? String(phoneIn.value || '').trim() : '';
            var note = noteIn ? String(noteIn.value || '') : '';
            var tags = tagsIn ? String(tagsIn.value || '') : '';
            var handleMatch = /(?:^|,)\s*collection:([^,\s]+)/.exec(tags);
            window.btLead.beacon({
              kind: 'notify_me',
              source: tgSource,
              email: email,
              phone: phone,
              // raw value in `contact` too, so sklad never drops the lead over an email format
              contact_method: email ? 'Email' : (phone ? 'Phone' : ''),
              contact: email || phone,
              details: {
                note: note,
                tags: tags,
                consent: consentIn ? (consentIn.type === 'checkbox' ? !!consentIn.checked : consentIn.value === 'true') : false,
                collection: {
                  handle: handleMatch ? handleMatch[1] : (root.getAttribute('data-collection-handle') || ''),
                  title: /^Empty collection:\s*/.test(note) ? note.replace(/^Empty collection:\s*/, '') : (root.getAttribute('data-collection-title') || '')
                }
              },
              notify: tgEnabled === '1'
            });
            beaconSent = true;
          } catch (e) { /* ignore */ }
        }

        // Fire-and-forget Telegram notification (parallel to native form submit)
        // Without assets/bt-lead.js — the old kickflip call, only when the setting is on.
        if (tgEnabled && !beaconSent) {
          try {
            var emailEl = form.querySelector('input[name="contact[email]"]');
            var phoneEl = form.querySelector('input[name="contact[phone]"]');
            var noteEl = form.querySelector('input[name="contact[note]"]');
            var consentEl = form.querySelector('input[name="contact[accepts_marketing]"]');

            var lines = [
              '🔔 *' + tgSource + '*',
              '📧 ' + (emailEl ? emailEl.value : '—'),
            ];
            if (phoneEl && phoneEl.value) lines.push('📞 ' + phoneEl.value);
            if (noteEl && noteEl.value) lines.push('📝 ' + noteEl.value);
            if (consentEl) {
              var checked = consentEl.type === 'hidden' ? consentEl.value === 'true' : consentEl.checked;
              lines.push('✉️ Marketing: ' + (checked ? 'yes' : 'no'));
            }
            lines.push('🌐 ' + window.location.href);

            fetch('https://web-production-05000.up.railway.app/site/notify', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                text: lines.join('\n'),
                parse_mode: 'Markdown'
              }),
              keepalive: true
            }).catch(function () {});
          } catch (e) { /* ignore */ }
        }
      });

      // Auto-scroll to success message if it appears after page reload
      var successEl = root.querySelector('[data-bt-notify-success]');
      if (successEl) {
        try { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      }
    }

    document.querySelectorAll('[data-bt-notify]').forEach(bindForm);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-notify]').forEach(bindForm);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cards-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bt-pcg-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });

    function observeAll() {
      document.querySelectorAll('.bt-pcg__card:not(.bt-pcg-in-view)').forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }

    document.addEventListener('shopify:section:load', observeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) {
      // Fallback: skip pre-anim (image stays at natural state)
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ps-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });

    function observeAll() {
      document.querySelectorAll('.product-showcase__card:not(.ps-in-view)').forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }

    // Re-observe on Shopify theme editor section reload
    document.addEventListener('shopify:section:load', observeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-bricktopia"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      if (!root || root.__btRpReady) return;
      root.__btRpReady = true;

      var url = root.getAttribute('data-url');
      var hasProducts = root.querySelector('.bt-rp__card');

      if (!hasProducts && url) {
        fetch(url)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newEl = doc.querySelector('[data-bt-rp]');
            if (newEl) {
              root.innerHTML = newEl.innerHTML;
              initCards(root);
            }
          })
          .catch(function(err) { console.warn('[bt-rp] recommendations fetch failed', err); });
      } else {
        initCards(root);
      }
    }

    function initCards(root) {
      // Image gallery
      root.querySelectorAll('.bt-rp__card').forEach(function(card) {
        if (card.__btGalleryReady) return;
        var wrap = card.querySelector('.bt-rp__card-imgwrap');
        if (!wrap) return;
        var imgs = wrap.querySelectorAll('.bt-rp__card-img');
        var dots = card.querySelectorAll('.bt-rp__card-dot-btn');
        if (imgs.length < 2) return;
        card.__btGalleryReady = true;

        var current = 0, pinned = false;
        var startX = 0, startY = 0, startT = 0;
        var swipeDetected = false, swipeBlocked = false;
        var link = card.querySelector('.bt-rp__card-link');

        function show(idx) {
          if (idx < 0) idx = imgs.length - 1;
          if (idx >= imgs.length) idx = 0;
          current = idx;
          for (var i = 0; i < imgs.length; i++) imgs[i].classList.toggle('is-active', i === idx);
          for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === idx);
        }

        card.addEventListener('mouseenter', function() { if (!pinned) show(1); });
        card.addEventListener('mouseleave', function() { if (!pinned) show(0); });
        dots.forEach(function(dot, idx) {
          dot.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation(); pinned = true; show(idx);
          });
        });
        card.querySelectorAll('[data-bt-card-arrow]').forEach(function(arrow) {
          arrow.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation(); pinned = true;
            var dir = arrow.getAttribute('data-bt-card-arrow');
            show(dir === 'next' ? current + 1 : current - 1);
          });
        });

        wrap.addEventListener('touchstart', function(e) {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX; startY = e.touches[0].clientY; startT = Date.now();
          swipeDetected = false;
        }, { passive: true });
        wrap.addEventListener('touchmove', function(e) {
          if (e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          if (!swipeDetected) {
            if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) swipeDetected = true;
          }
          if (swipeDetected && e.cancelable) e.preventDefault();
        }, { passive: false });
        wrap.addEventListener('touchend', function(e) {
          if (!swipeDetected) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 25) { swipeDetected = false; return; }
          pinned = true;
          show(dx < 0 ? current + 1 : current - 1);
          swipeBlocked = true;
          setTimeout(function() { swipeBlocked = false; }, 350);
        }, { passive: true });
        wrap.addEventListener('touchcancel', function() { swipeDetected = false; }, { passive: true });
        if (link) {
          link.addEventListener('click', function(e) {
            if (swipeBlocked) { e.preventDefault(); e.stopPropagation(); }
          }, true);
        }
      });

      // Desktop slider arrows
      var scrollEl = root.querySelector('.bt-rp__scroll');
      var navBtns = root.querySelectorAll('[data-bt-rp-nav]');
      if (scrollEl && navBtns.length) {
        var updateNav = function() {
          var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
          navBtns.forEach(function(b) {
            var dir = b.getAttribute('data-bt-rp-nav');
            b.disabled = dir === 'prev' ? scrollEl.scrollLeft <= 2 : scrollEl.scrollLeft >= maxScroll - 2;
          });
        };
        navBtns.forEach(function(btn) {
          if (btn.__btNavReady) return;
          btn.__btNavReady = true;
          btn.addEventListener('click', function() {
            var card = scrollEl.querySelector('.bt-rp__card');
            if (!card) return;
            var grid = scrollEl.querySelector('.bt-rp__grid');
            var gap = grid ? parseFloat(getComputedStyle(grid).columnGap) || 20 : 20;
            var step = card.offsetWidth + gap;
            scrollEl.scrollBy({ left: btn.getAttribute('data-bt-rp-nav') === 'next' ? step : -step, behavior: 'smooth' });
          });
        });
        scrollEl.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav, { passive: true });
        updateNav();
      }

      // Quantity + cart
      root.querySelectorAll('[data-bt-addform]').forEach(function(form) {
        if (form.__btAddReady) return;
        form.__btAddReady = true;
        var valEl = form.querySelector('[data-bt-qty-val]');
        var qtyInput = form.querySelector('[data-bt-qty-input]');
        var cartBtn = form.querySelector('.bt-rp__cart-btn');
        var qty = 1;
        function setQty(v) {
          qty = Math.max(1, Math.min(99, v));
          valEl.textContent = String(qty);
          qtyInput.value = qty;
        }
        form.querySelectorAll('[data-bt-qty-dir]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            setQty(btn.getAttribute('data-bt-qty-dir') === 'plus' ? qty + 1 : qty - 1);
          });
        });
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          if (cartBtn.disabled || cartBtn.classList.contains('is-loading')) return;
          cartBtn.classList.add('is-loading');
          var fd = new FormData(form);
          fd.set('quantity', String(qty));

          flyImageToCart(form);

          var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
          fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          })
          .then(function(r) { return r.json().then(function(j) { return { ok: r.ok, body: j }; }); })
          .then(function(res) {
            cartBtn.classList.remove('is-loading');
            if (!res.ok) throw res.body;
            cartBtn.classList.add('is-success');
            setTimeout(function() { cartBtn.classList.remove('is-success'); }, 1400);
            refreshCartUI();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('bt:cart:added', { detail: res.body }));
            var drawer = document.querySelector('cart-drawer, cart-notification, cart-items-component');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          })
          .catch(function(err) {
            cartBtn.classList.remove('is-loading');
            console.warn('[bt-rp] add to cart failed', err);
          });
        });
      });
    }

    function refreshCartUI() {
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var count = cart.item_count;
          fetch(window.location.pathname + '?sections=header')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (!data || !data.header) return;
              var parser = new DOMParser();
              var doc = parser.parseFromString(data.header, 'text/html');
              ['cart-icon-bubble', 'cart-live-region-text'].forEach(function(id) {
                var newEl = doc.getElementById(id);
                var oldEl = document.getElementById(id);
                if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
              });
              var newBubble = doc.querySelector('.cart-count-bubble, cart-count, [data-cart-count]');
              var oldBubble = document.querySelector('.cart-count-bubble, cart-count, [data-cart-count]');
              if (newBubble && oldBubble) oldBubble.outerHTML = newBubble.outerHTML;
            })
            .catch(function() {});
          var selectors = ['.cart-count-bubble span:first-child', '.cart-count-bubble', '.cart-count', '[data-cart-count]', '.header__cart-count', '#cart-icon-bubble span', '#cart-count'];
          selectors.forEach(function(sel) {
            document.querySelectorAll(sel).forEach(function(el) {
              var text = (el.textContent || '').trim();
              if (!text || /^\d+$/.test(text)) {
                el.textContent = count > 0 ? count : '';
                if (count > 0) {
                  el.hidden = false; el.removeAttribute('hidden'); el.classList.remove('hidden'); el.style.display = '';
                }
              }
            });
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bt-rp', cartData: cart }); } catch (e) {}
          }
        })
        .catch(function(err) { console.warn('[bt-rp] refreshCartUI failed', err); });
    }

    function findCartTarget() {
      var selectors = [
        'cart-icon', 'cart-drawer', 'cart-notification',
        '[data-cart-icon]', '[data-header-cart]', '.header__icon--cart',
        'a[href="/cart"]', 'a[href*="/cart"]:not([href*="/cart/add"])',
        '[aria-label*="cart" i]', '[aria-label*="кошик" i]', '[aria-label*="koszyk" i]',
        '.cart-count-bubble', '.cart-icon', '#cart-icon-bubble'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetParent !== null) return el;
      }
      return null;
    }

    function flyImageToCart(form) {
      var card = form.closest('.bt-rp__card');
      if (!card) return;
      var srcImg = card.querySelector('.bt-rp__card-imgwrap img');
      if (!srcImg) return;
      var target = findCartTarget();
      var tRect = target ? target.getBoundingClientRect() : { left: window.innerWidth - 50, top: 20, width: 40, height: 40 };
      var sRect = srcImg.getBoundingClientRect();

      var fly = document.createElement('div');
      fly.className = 'bt-cart-fly';
      fly.style.left = sRect.left + 'px';
      fly.style.top = sRect.top + 'px';
      fly.style.width = sRect.width + 'px';
      fly.style.height = sRect.height + 'px';
      var img = document.createElement('img');
      img.src = srcImg.currentSrc || srcImg.src;
      img.alt = '';
      fly.appendChild(img);
      document.body.appendChild(fly);
      fly.offsetWidth;

      var targetX = tRect.left + tRect.width / 2 - sRect.width / 2;
      var targetY = tRect.top + tRect.height / 2 - sRect.height / 2;
      fly.style.transform = 'translate(' + (targetX - sRect.left) + 'px, ' + (targetY - sRect.top) + 'px) scale(' + Math.max(0.1, Math.min(tRect.width, tRect.height) / Math.max(sRect.width, sRect.height)) + ')';
      fly.classList.add('is-flying');

      fly.addEventListener('transitionend', function onEnd() {
        fly.removeEventListener('transitionend', onEnd);
        fly.remove();
        if (target) {
          target.classList.add('bt-cart-target-bounce');
          setTimeout(function() { target.classList.remove('bt-cart-target-bounce'); }, 600);
        }
      });
      setTimeout(function() { if (fly.parentNode) fly.remove(); }, 1500);
    }

    document.querySelectorAll('[data-bt-rp]').forEach(init);
    document.addEventListener('shopify:section:load', function(e) {
      if (e.target) e.target.querySelectorAll('[data-bt-rp]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-grid-api"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__btRgaReady) return;
      root.__btRgaReady = true;

      var apiBase = root.getAttribute('data-api-base');
      var storeId = root.getAttribute('data-store-id');
      var apiStore = root.getAttribute('data-store') || 'ua';
      var pageLocale = (root.getAttribute('data-locale') || '').toLowerCase();
      var anonLabel = root.getAttribute('data-anon-label') || 'Anonim';
      var verifiedLabel = root.getAttribute('data-verified-label') || 'Zweryfikowany zakup';
      var handle = root.getAttribute('data-handle');
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 50;
      var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 6;
      var sort = root.getAttribute('data-sort') || 'recent';
      var mediaPos = root.getAttribute('data-media-position') || 'below';
      var ratingOffset = parseFloat(root.getAttribute('data-rating-offset')) || 0;
      var ratingMin = parseFloat(root.getAttribute('data-rating-min'));
      if (isNaN(ratingMin)) ratingMin = 4.0;

      var loadingEl = root.querySelector('[data-bt-rga-loading]');
      var gridEl = root.querySelector('[data-bt-rga-grid]');
      var emptyEl = root.querySelector('[data-bt-rga-empty]');
      var paginationEl = root.querySelector('[data-bt-rga-pagination]');
      var pagesEl = root.querySelector('[data-bt-rga-pages]');
      var prevBtn = root.querySelector('[data-bt-rga-prev]');
      var nextBtn = root.querySelector('[data-bt-rga-next]');
      var summaryEl = root.querySelector('[data-bt-rga-summary]');
      var avgEl = root.querySelector('[data-bt-rga-avg]');
      var avgStarsEl = root.querySelector('[data-bt-rga-avg-stars]');
      var countEl = root.querySelector('[data-bt-rga-count]');
      var stripEl = root.querySelector('[data-bt-rga-strip]');
      var firstBtn = root.querySelector('[data-bt-rga-first]');
      var lastBtn = root.querySelector('[data-bt-rga-last]');
      /* reviews — РОЗРІДЖЕНИЙ масив: reviews[i] = i-й відгук стрічки API.
         Раніше тягнули лише перші `limit` (50) і на цьому все закінчувалось —
         50 / 6 на сторінку = 9 сторінок при 900+ відгуках. Тепер решта
         догружається шматками по offset, коли відкривають сторінку чи
         гортають стрічку фото. */
      var reviews = [];
      var totalCount = 0;
      var CHUNK = Math.max(perPage, Math.floor(100 / perPage) * perPage); // ≤ 100 — ліміт API, кратно сторінці
      var inflight = {};
      var stripWrap = root.querySelector('[data-bt-rga-strip-wrap]');
      var stripPrevBtn = root.querySelector('[data-bt-rga-strip-prev]');
      var stripNextBtn = root.querySelector('[data-bt-rga-strip-next]');
      var stripUpTo = 0;
      var stripTiles = 0;
      var stripLoading = false;
      var pageReq = 0;
      var currentPage = 0;
      var allMediaUrls = [];
      var lbIndex = 0;

      function escapeHtml(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
      }
      var IMAGE_EXTS = ['jpg','jpeg','png','gif','webp','avif','heic','heif','bmp','svg'];
      var VIDEO_EXTS = ['mp4','webm','mov','m4v','ogg','ogv','mkv','3gp'];
      function guessMediaKind(url) {
        if (!url) return 'unknown';
        var pathname = url;
        try { pathname = new URL(url, 'http://x').pathname; }
        catch (e) { pathname = (url.split('?')[0] || '').split('#')[0]; }
        for (var i = 0; i < 2; i++) {
          var p;
          try { p = i === 0 ? pathname : decodeURIComponent(pathname); }
          catch (e) { p = pathname; }
          var m = p.match(/\.([a-z0-9]{2,5})$/i);
          if (!m) continue;
          var ext = m[1].toLowerCase();
          if (IMAGE_EXTS.indexOf(ext) !== -1) return 'image';
          if (VIDEO_EXTS.indexOf(ext) !== -1) return 'video';
        }
        return 'unknown';
      }
      function isVideo(url) { return guessMediaKind(url) === 'video'; }
            // ⚠ {% javascript %} не рендерить Liquid — мову беремо з <html lang>
      var BT_LANG = (document.documentElement.lang || 'pl').slice(0, 2);
      var BT_REVIEW_PHOTO_ALT = BT_LANG === 'en' ? 'Customer review photo' : BT_LANG === 'uk' ? 'Фото з відгуку клієнта' : 'Zdjęcie z opinii klienta';
      // 30.09.2026: it/ru — раніше падали на польський alt
      if (BT_LANG === 'it') BT_REVIEW_PHOTO_ALT = 'Foto dalla recensione di un cliente';
      else if (BT_LANG === 'de') BT_REVIEW_PHOTO_ALT = 'Foto aus einer Kundenbewertung';
      else if (BT_LANG === 'cs') BT_REVIEW_PHOTO_ALT = 'Fotografie z recenze zákazníka';
      else if (BT_LANG === 'es') BT_REVIEW_PHOTO_ALT = 'Foto de la opinión de un cliente';
      else if (BT_LANG === 'fr') BT_REVIEW_PHOTO_ALT = 'Photo issue d’un avis client';
      else if (BT_LANG === 'nl') BT_REVIEW_PHOTO_ALT = 'Foto uit een klantreview';
      else if (BT_LANG === 'sk') BT_REVIEW_PHOTO_ALT = 'Fotografia z recenzie zákazníka';
      else if (BT_LANG === 'hu') BT_REVIEW_PHOTO_ALT = 'Fotó egy vásárlói véleményből';
      else if (BT_LANG === 'ro') BT_REVIEW_PHOTO_ALT = 'Fotografie din recenzia unui client';
      else if (BT_LANG === 'lt') BT_REVIEW_PHOTO_ALT = 'Nuotrauka iš kliento atsiliepimo';
      else if (BT_LANG === 'lv') BT_REVIEW_PHOTO_ALT = 'Foto no klienta atsauksmes';
      else if (BT_LANG === 'et') BT_REVIEW_PHOTO_ALT = 'Foto kliendi arvustusest';
      else if (BT_LANG === 'ru') BT_REVIEW_PHOTO_ALT = 'Фото из отзыва клиента';
      /* 10.10.2026 (швидкість): фото відгуків лежать у Supabase оригіналами по 1–3 МБ — картці досить
         мініатюри через /render/image. Не віддалась — фолбек бере оригінал з data-bt-media-url.
         Лайтбокс (opts.controls) показує оригінал. Дзеркало — snippets/bt-rga-ssr-card.liquid. */
      var THUMB_EXTS = ['jpg','jpeg','png','webp','avif','heic','heif','bmp'];
      function thumbUrl(url) {
        if (!url || url.indexOf('/storage/v1/object/public/') === -1) return null;
        var path = (url.split('?')[0] || '').split('#')[0];
        var m = path.match(/\.([a-z0-9]{2,5})$/i);
        if (!m || THUMB_EXTS.indexOf(m[1].toLowerCase()) === -1) return null;
        /* 04.11.2026: готова мініатюра reviews/thumb/<name>.webp (робить lost-orders при завантаженні, lib/review-thumb.ts) —
           /render/image рахується в ліміт трансформацій Supabase (100 різних фото на місяць). Інші адреси — як раніше. */
        var RM = '/storage/v1/object/public/review-media/reviews/';
        var at = path.indexOf(RM);
        if (at !== -1 && path.slice(at + RM.length).indexOf('/') === -1) return path.slice(0, at + RM.length) + 'thumb/' + path.slice(at + RM.length).replace(/\.[^.]+$/, '') + '.webp';
        return path.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/') + '?width=720&height=720&resize=contain&quality=70';
      }
      function buildMediaTag(url, opts) {
        opts = opts || {};
        var kind = guessMediaKind(url);
        var initial = (kind === 'video') ? 'video' : 'image';
        var escaped = escapeHtml(url);
        var attrs = 'data-bt-media-url="' + escaped + '" data-bt-media-tried="' + initial + '"';
        if (initial === 'video') {
          return '<video src="' + escaped + '" muted playsinline preload="metadata"' + (opts.controls ? ' controls' : '') + ' ' + attrs + '></video>';
        }
        var altText = (opts.alt || BT_REVIEW_PHOTO_ALT).replace(/"/g, '&quot;');
        var thumb = opts.controls ? null : thumbUrl(url);
        if (thumb) attrs += ' data-bt-thumb="1"';
        var srcAttr = thumb ? thumb.replace(/&/g, '&amp;').replace(/"/g, '&quot;') : escaped;
        return '<img src="' + srcAttr + '" loading="lazy" decoding="async" alt="' + altText + '" ' + attrs + '>';
      }
      function removeBrokenMedia(el) {
        // Remove the tile/slide/strip item that contains the broken media.
        var tile = el.closest('.bt-rg__card-media-tile, .bt-rg__gallery-slide, .bt-rg__media-tile');
        if (!tile) { el.remove(); return; }
        var container = tile.parentElement;
        tile.remove();
        // If container is now empty, hide the whole media block so card looks like it had no media.
        if (container && !container.querySelector('img, video, .bt-rg__card-media-tile, .bt-rg__gallery-slide, .bt-rg__media-tile')) {
          var outer = container.closest('.bt-rg__card-media, .bt-rg__media-strip');
          if (outer) outer.style.display = 'none';
          else container.style.display = 'none';
        }
      }
      function attachMediaFallback(scope) {
        if (!scope) return;
        scope.querySelectorAll('[data-bt-media-url]:not([data-bt-media-bound])').forEach(function (el) {
          el.setAttribute('data-bt-media-bound', '1');
          /* Серверні картки: фото могло впасти ще до цього скрипта — тоді
             onerror у розмітці лишив мітку, і фолбек запускаємо вручну. */
          if (el.getAttribute('data-bt-media-failed')) {
            setTimeout(function () { el.dispatchEvent(new Event('error')); }, 0);
          }
          el.addEventListener('error', function onMediaError() {
            var u = el.getAttribute('data-bt-media-url');
            var tried = el.getAttribute('data-bt-media-tried');
            /* мініатюра Supabase не віддалась — пробуємо оригінал, лише потім відео */
            if (el.tagName === 'IMG' && el.getAttribute('data-bt-thumb') && !el.getAttribute('data-bt-thumb-failed')) {
              el.setAttribute('data-bt-thumb-failed', '1');
              el.removeAttribute('data-bt-media-failed');
              el.addEventListener('error', onMediaError, { once: true });
              el.src = u;
              return;
            }
            if (tried === 'image') {
              var v = document.createElement('video');
              v.src = u; v.muted = true; v.playsInline = true; v.preload = 'metadata';
              if (el.closest('.bt-rg__lightbox')) v.controls = true;
              v.setAttribute('data-bt-media-url', u);
              v.setAttribute('data-bt-media-tried', 'video');
              v.setAttribute('data-bt-media-bound', '1');
              v.addEventListener('error', function () {
                removeBrokenMedia(v);
              }, { once: true });
              el.replaceWith(v);
              // Show play icon if inside a gallery-media button
              var btn = v.closest('.bt-rg__gallery-media, .bt-rg__card-media-tile');
              if (btn && !btn.querySelector('.bt-rg__media-play')) {
                var p = document.createElement('span');
                p.className = 'bt-rg__media-play';
                p.textContent = '▶';
                p.setAttribute('aria-hidden', 'true');
                btn.appendChild(p);
              }
            } else {
              removeBrokenMedia(el);
            }
          }, { once: true });
        });
      }
      function formatDate(iso) {
        if (!iso) return '';
        try {
          var d = new Date(iso);
          var dd = String(d.getDate()).padStart(2, '0');
          var mm = String(d.getMonth() + 1).padStart(2, '0');
          return dd + '.' + mm + '.' + d.getFullYear();
        } catch (e) { return ''; }
      }
      function starsHtml(rating) {
        var r = Math.round(rating || 0);
        var out = '';
        for (var i = 1; i <= 5; i++) {
          out += '<span class="bt-rg__star' + (i <= r ? ' bt-rg__star--filled' : '') + '">' + (i <= r ? '★' : '☆') + '</span>';
        }
        return out;
      }
      /* 12.10.2026: чесний переклад. Відгук показуємо мовою сторінки, під ним —
         «перекладено з …» і кнопка оригіналу; біля дати — країна автора, якщо
         відома. Один код для карток із HTML (знімок) і намальованих тут:
         обидві несуть data-rid / data-tr / data-src / data-cc. */
      var TR_UI = {
        pl: { t: 'Przetłumaczono automatycznie {from}', show: 'Pokaż oryginał', hide: 'Ukryj oryginał',
              from: { pl: 'z polskiego', uk: 'z ukraińskiego', en: 'z angielskiego', it: 'z włoskiego', ru: 'z rosyjskiego' } },
        en: { t: 'Translated automatically {from}', show: 'Show original', hide: 'Hide original',
              from: { pl: 'from Polish', uk: 'from Ukrainian', en: 'from English', it: 'from Italian', ru: 'from Russian' } },
        uk: { t: 'Перекладено автоматично {from}', show: 'Показати оригінал', hide: 'Сховати оригінал',
              from: { pl: 'з польської', uk: 'з української', en: 'з англійської', it: 'з італійської', ru: 'з російської' } },
        ru: { t: 'Переведено автоматически {from}', show: 'Показать оригинал', hide: 'Скрыть оригинал',
              from: { pl: 'с польского', uk: 'с украинского', en: 'с английского', it: 'с итальянского', ru: 'с русского' } },
        it: { t: 'Tradotto automaticamente {from}', show: 'Mostra originale', hide: 'Nascondi originale',
              from: { pl: 'dal polacco', uk: 'dall\u2019ucraino', en: 'dall\u2019inglese', it: 'dall\u2019italiano', ru: 'dal russo' } },
        de: { t: 'Automatisch \u00fcbersetzt {from}', show: 'Original anzeigen', hide: 'Original ausblenden',
              from: { pl: 'aus dem Polnischen', uk: 'aus dem Ukrainischen', en: 'aus dem Englischen', it: 'aus dem Italienischen', ru: 'aus dem Russischen' } },
        cs: { t: 'Automaticky přeloženo {from}', show: 'Zobrazit originál', hide: 'Skrýt originál',
              from: { pl: 'z polštiny', uk: 'z ukrajinštiny', en: 'z angličtiny', it: 'z italštiny', ru: 'z ruštiny' } },
        es: { t: 'Traducido automáticamente {from}', show: 'Ver original', hide: 'Ocultar original',
              from: { pl: 'del polaco', uk: 'del ucraniano', en: 'del inglés', it: 'del italiano', ru: 'del ruso' } },
        fr: { t: 'Traduit automatiquement {from}', show: 'Afficher l’original', hide: 'Masquer l’original',
              from: { pl: 'du polonais', uk: 'de l’ukrainien', en: 'de l’anglais', it: 'de l’italien', ru: 'du russe' } },
        nl: { t: 'Automatisch vertaald {from}', show: 'Origineel tonen', hide: 'Origineel verbergen',
              from: { pl: 'uit het Pools', uk: 'uit het Oekraïens', en: 'uit het Engels', it: 'uit het Italiaans', ru: 'uit het Russisch' } },
        sk: { t: 'Automaticky preložené {from}', show: 'Zobraziť originál', hide: 'Skryť originál',
              from: { pl: 'z poľštiny', uk: 'z ukrajinčiny', en: 'z angličtiny', it: 'z taliančiny', ru: 'z ruštiny' } },
        hu: { t: 'Automatikusan lefordítva {from}', show: 'Eredeti megjelenítése', hide: 'Eredeti elrejtése',
              from: { pl: 'lengyelből', uk: 'ukránból', en: 'angolból', it: 'olaszból', ru: 'oroszból' } },
        ro: { t: 'Tradus automat {from}', show: 'Arată originalul', hide: 'Ascunde originalul',
              from: { pl: 'din poloneză', uk: 'din ucraineană', en: 'din engleză', it: 'din italiană', ru: 'din rusă' } },
        lt: { t: 'Išversta automatiškai {from}', show: 'Rodyti originalą', hide: 'Slėpti originalą',
              from: { pl: 'iš lenkų kalbos', uk: 'iš ukrainiečių kalbos', en: 'iš anglų kalbos', it: 'iš italų kalbos', ru: 'iš rusų kalbos' } },
        lv: { t: 'Automātiski tulkots {from}', show: 'Rādīt oriģinālu', hide: 'Slēpt oriģinālu',
              from: { pl: 'no poļu valodas', uk: 'no ukraiņu valodas', en: 'no angļu valodas', it: 'no itāļu valodas', ru: 'no krievu valodas' } },
        et: { t: 'Automaatselt tõlgitud {from}', show: 'Näita originaali', hide: 'Peida originaal',
              from: { pl: 'poola keelest', uk: 'ukraina keelest', en: 'inglise keelest', it: 'itaalia keelest', ru: 'vene keelest' } }
      };
      var trUi = TR_UI[BT_LANG] || TR_UI.en;
      var origById = {};
      var origLoading = null;
      function rememberOriginals(list) {
        (list || []).forEach(function (r) {
          if (r && r.translated && r.id != null) origById[r.id] = { title: r.original_title, body: r.original_body };
        });
      }
      function regionName(cc) {
        try { return new Intl.DisplayNames([BT_LANG], { type: 'region' }).of(cc) || cc; } catch (e) { return cc; }
      }
      function decorateCards() {
        if (!gridEl) return;
        rememberOriginals(reviews);
        gridEl.querySelectorAll('[data-bt-rga-card]:not([data-bt-deco])').forEach(function (card) {
          card.setAttribute('data-bt-deco', '1');
          var cc = (card.getAttribute('data-cc') || '').toUpperCase();
          var sub = card.querySelector('.bt-rg__card-sub-row');
          if (/^[A-Z]{2}$/.test(cc) && sub) {
            sub.insertAdjacentHTML('beforeend',
              '<span class="bt-rg__card-dot" aria-hidden="true">·</span>' +
              '<span class="bt-rg__card-country"><img src="https://cdn.shopify.com/static/images/flags/' + cc.toLowerCase() +
              '.svg?width=32" alt="" width="16" height="12" loading="lazy">' + escapeHtml(regionName(cc)) + '</span>');
          }
          var text = card.querySelector('.bt-rg__card-text');
          if (card.getAttribute('data-tr') === '1' && text) {
            var from = trUi.from[card.getAttribute('data-src') || ''] || '';
            var label = trUi.t.replace('{from}', from).replace(/\s+$/, '');
            text.insertAdjacentHTML('afterend',
              '<div class="bt-rg__card-tr"><span>' + escapeHtml(label) + '</span>' +
              '<button type="button" class="bt-rg__card-tr-btn" data-bt-rga-orig aria-expanded="false">' + escapeHtml(trUi.show) + '</button></div>');
          }
        });
      }
      function toggleOriginal(btn) {
        var card = btn.closest('[data-bt-rga-card]');
        if (!card) return;
        var box = card.querySelector('.bt-rg__card-orig');
        function mark(open) {
          btn.textContent = open ? trUi.hide : trUi.show;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        if (box) { box.hidden = !box.hidden; mark(!box.hidden); return; }
        var id = card.getAttribute('data-rid');
        function put() {
          var o = origById[id];
          if (!o || !o.body) { btn.hidden = true; return; }
          box = document.createElement('div');
          box.className = 'bt-rg__card-orig';
          var src = card.getAttribute('data-src');
          if (src) box.setAttribute('lang', src);
          box.innerHTML = (o.title ? '<strong>' + escapeHtml(o.title) + '</strong>' : '') + escapeHtml(o.body);
          btn.parentNode.insertAdjacentElement('afterend', box);
          mark(true);
        }
        if (origById[id]) { put(); return; }
        /* Картки зі знімка в HTML оригіналу не несуть (ліміт метафілда) — тягнемо раз, за першим кліком. */
        if (!origLoading) {
          origLoading = fetch(productUrl.replace(/&limit=\d+/, '&limit=100'))
            .then(function (r) { return r.json(); })
            .then(function (list) { rememberOriginals(list && list.data); })
            .catch(function () {});
        }
        origLoading.then(put);
      }

      function renderCard(r, pageNum) {
        var name = r.author_name || anonLabel;
        var firstLetter = (name.trim().charAt(0) || '?').toUpperCase();
        var media = '';
        if (r.images && r.images.length) {
          if (mediaPos === 'below') {
            // Row of thumbnails layout
            media = '<div class="bt-rg__card-media bt-rg__card-media-row">' + r.images.map(function (url) {
              var kind = guessMediaKind(url);
              var playIcon = (kind === 'video') ? '<span class="bt-rg__media-play" aria-hidden="true">▶</span>' : '';
              return '<button type="button" class="bt-rg__card-media-tile" data-bt-rga-media="' + escapeHtml(url) + '" aria-label="Open">' +
                buildMediaTag(url, { alt: BT_REVIEW_PHOTO_ALT + (typeof name === 'string' && name ? ': ' + name : '') }) + playIcon + '</button>';
            }).join('') + '</div>';
          } else {
            // Gallery with arrows (right/left layouts)
            var slides = r.images.map(function (url, idx) {
              var active = idx === 0 ? ' is-active' : '';
              var kind = guessMediaKind(url);
              var playIcon = (kind === 'video') ? '<span class="bt-rg__media-play" aria-hidden="true">▶</span>' : '';
              return '<div class="bt-rg__gallery-slide' + active + '" data-bt-rga-slide="' + idx + '">' +
                '<button type="button" class="bt-rg__gallery-media" data-bt-rga-media="' + escapeHtml(url) + '" aria-label="Open">' +
                  buildMediaTag(url, { alt: BT_REVIEW_PHOTO_ALT + (typeof name === 'string' && name ? ': ' + name : '') }) + playIcon +
                '</button>' +
              '</div>';
            }).join('');
            var arrows = '';
            var dots = '';
            if (r.images.length > 1) {
              arrows =
                '<button type="button" class="bt-rg__gallery-arrow bt-rg__gallery-arrow--prev" data-bt-rga-gprev aria-label="Previous image"><span class="bt-rg__chevron bt-rg__chevron--prev"></span></button>' +
                '<button type="button" class="bt-rg__gallery-arrow bt-rg__gallery-arrow--next" data-bt-rga-gnext aria-label="Next image"><span class="bt-rg__chevron bt-rg__chevron--next"></span></button>' +
                '<span class="bt-rg__gallery-counter"><span data-bt-rga-gcount>1</span>/' + r.images.length + '</span>';
              dots = '<div class="bt-rg__gallery-dots">' + r.images.map(function (_, i) {
                return '<button type="button" class="bt-rg__gallery-dot' + (i === 0 ? ' is-active' : '') + '" data-bt-rga-gdot="' + i + '" aria-label="Image ' + (i + 1) + '"></button>';
              }).join('') + '</div>';
            }
            media = '<div class="bt-rg__card-media bt-rg__card-gallery" data-bt-rga-gallery data-count="' + r.images.length + '" data-current="0">' +
                '<div class="bt-rg__gallery-track">' + slides + '</div>' +
                arrows +
                dots +
              '</div>';
          }
        }
        var adminReply = r.admin_reply
          ? '<div class="bt-rg__card-admin-reply"><strong>Kloniko:</strong> ' + escapeHtml(r.admin_reply) + '</div>'
          : '';
        var textBlock =
          '<div class="bt-rg__card-text-block">' +
            '<div class="bt-rg__card-top">' +
              '<div class="bt-rg__card-avatar">' + escapeHtml(firstLetter) + '</div>' +
              '<div class="bt-rg__card-info">' +
                '<div class="bt-rg__card-name-row">' +
                  '<span class="bt-rg__card-author">' + escapeHtml(name) + '</span>' +
                  (r.verified_purchase ? '<span class="bt-rg__card-badge" title="' + escapeHtml(verifiedLabel) + '">✓</span>' : '') +
                '</div>' +
                '<div class="bt-rg__card-sub-row">' +
                  '<span class="bt-rg__card-stars">' + starsHtml(r.rating) + '</span>' +
                  '<span class="bt-rg__card-dot" aria-hidden="true">·</span>' +
                  '<span class="bt-rg__card-date">' + escapeHtml(formatDate(r.created_at)) + '</span>' +
                '</div>' +
              '</div>' +
            '</div>' +
            (r.title ? '<h3 class="bt-rg__card-title">' + escapeHtml(r.title) + '</h3>' : '') +
            (r.body ? '<div class="bt-rg__card-text">' + escapeHtml(r.body) + '</div>' : '') +
            adminReply +
          '</div>';
        var metaAttrs = (r.id != null ? ' data-rid="' + escapeHtml(String(r.id)) + '"' : '') +
          (r.translated ? ' data-tr="1" data-src="' + escapeHtml(r.source_locale || '') + '"' : '') +
          (r.country_code ? ' data-cc="' + escapeHtml(r.country_code) + '"' : '');
        return '<article class="bt-rg__card" data-bt-rga-card data-page="' + pageNum + '"' + metaAttrs + '>' +
          textBlock +
          media +
        '</article>';
      }

      /* Стрічка фото: усі фото з відгуків поспіль, від першого; дописуємо
         хвіст, коли суцільний початок `reviews` подовжується. */
      function renderMediaStrip() {
        if (!stripEl) return;
        var tiles = [];
        while (stripUpTo < reviews.length && reviews[stripUpTo]) {
          var r = reviews[stripUpTo++];
          if (!r.images || !r.images.length) continue;
          var name = r.author_name || '';
          r.images.forEach(function (url) {
            var kind = guessMediaKind(url);
            var playIcon = (kind === 'video') ? '<span class="bt-rg__media-play" aria-hidden="true">▶</span>' : '';
            tiles.push('<button type="button" class="bt-rg__media-tile" data-bt-rga-media="' + escapeHtml(url) + '" aria-label="Open">' + buildMediaTag(url, { alt: BT_REVIEW_PHOTO_ALT + (typeof name === 'string' && name ? ': ' + name : '') }) + playIcon + '</button>');
          });
        }
        if (tiles.length) {
          stripTiles += tiles.length;
          stripEl.insertAdjacentHTML('beforeend', tiles.join(''));
          attachMediaFallback(stripEl);
        }
        if (stripTiles && stripWrap) stripWrap.hidden = false;
        updateStripArrows();
      }
      function stripHasMore() { return stripUpTo < totalCount; }
      function updateStripArrows() {
        if (!stripEl) return;
        var atStart = stripEl.scrollLeft <= 2;
        var atEnd = stripEl.scrollLeft + stripEl.clientWidth >= stripEl.scrollWidth - 2;
        if (stripPrevBtn) stripPrevBtn.hidden = atStart;
        if (stripNextBtn) stripNextBtn.hidden = atEnd && !stripHasMore();
      }
      /* Догрузка, коли до кінця стрічки лишилось менше ~2 екранів. Якщо в
         шматку мало фото — повторюємо, поки стрічка знову не стане довгою. */
      function maybeLoadStrip(force) {
        if (!stripEl || stripLoading || !stripHasMore()) return;
        var left = stripEl.scrollWidth - (stripEl.scrollLeft + stripEl.clientWidth);
        if (!force && left > stripEl.clientWidth * 2) return;
        stripLoading = true;
        var done = function (ok) {
          stripLoading = false;
          renderMediaStrip();
          if (ok) maybeLoadStrip(false);
        };
        fetchChunk(stripUpTo).then(function () { done(true); }, function () { done(false); });
      }
      if (stripEl) {
        var stripTick = false;
        stripEl.addEventListener('scroll', function () {
          if (stripTick) return;
          stripTick = true;
          requestAnimationFrame(function () {
            stripTick = false;
            updateStripArrows();
            maybeLoadStrip(false);
          });
        }, { passive: true });
        var stripStep = function (dir) {
          var dx = Math.max(220, Math.round(stripEl.clientWidth * 0.85)) * dir;
          try { stripEl.scrollBy({ left: dx, behavior: 'smooth' }); }
          catch (e) { stripEl.scrollLeft += dx; }
          if (dir > 0) maybeLoadStrip(false);
        };
        if (stripPrevBtn) stripPrevBtn.addEventListener('click', function () { stripStep(-1); });
        if (stripNextBtn) stripNextBtn.addEventListener('click', function () { stripStep(1); });
      }

      /* Один шматок API (CHUNK відгуків, вирівняний по CHUNK). Той самий
         шматок не тягнемо двічі паралельно; після помилки — можна ще раз. */
      function fetchChunk(offset) {
        offset = Math.floor(offset / CHUNK) * CHUNK;
        if (inflight[offset]) return inflight[offset];
        if (typeof productUrl !== 'string') return Promise.reject(new Error('no url'));
        var url = productUrl.replace(/([?&])limit=\d+/, '$1limit=' + CHUNK) + '&offset=' + offset;
        var p = fetch(url).then(function (r) { return r.json(); }).then(function (list) {
          if (!list || !list.success || !Array.isArray(list.data)) throw new Error('bad response');
          if (typeof list.total === 'number') totalCount = list.total;
          addReviews(list.data, offset);
        });
        inflight[offset] = p;
        p.catch(function () { delete inflight[offset]; });
        return p;
      }
      function addReviews(list, offset) {
        var html = '';
        list.forEach(function (r, i) {
          var idx = offset + i;
          if (reviews[idx]) return; // уже є (серверний рендер або попередній шматок)
          reviews[idx] = r;
          html += renderCard(r, Math.floor(idx / perPage));
        });
        if (totalCount < reviews.length) totalCount = reviews.length;
        if (!html) return;
        gridEl.insertAdjacentHTML('beforeend', html);
        applyPageVisibility();
        attachMediaFallback(gridEl);
        renderMediaStrip();
        buildAllMediaList();
      }
      function totalPagesCount() {
        return Math.ceil(Math.max(totalCount, reviews.length) / perPage) || 1;
      }
      function pageLoaded(pg) {
        var end = Math.min((pg + 1) * perPage, Math.max(totalCount, reviews.length));
        for (var i = pg * perPage; i < end; i++) if (!reviews[i]) return false;
        return true;
      }
      function applyPageVisibility() {
        gridEl.querySelectorAll('[data-bt-rga-card]').forEach(function (c) {
          c.classList.toggle('is-hidden', parseInt(c.getAttribute('data-page'), 10) !== currentPage);
        });
      }

      function centerActivePage() {
        if (!pagesEl) return;
        var active = pagesEl.querySelector('.is-active');
        if (!active) return;
        var containerWidth = pagesEl.clientWidth;
        var target = active.offsetLeft - (containerWidth / 2) + (active.offsetWidth / 2);
        target = Math.max(0, Math.min(target, pagesEl.scrollWidth - containerWidth));
        try { pagesEl.scrollTo({ left: target, behavior: 'smooth' }); }
        catch (e) { pagesEl.scrollLeft = target; }
      }
      function renderPagination() {
        if (!paginationEl || !pagesEl) return;
        var totalPages = totalPagesCount();
        if (totalPages <= 1) {
          paginationEl.hidden = true;
          return;
        }
        paginationEl.hidden = false;
        /* 150+ сторінок кнопками не намалюєш: перша, остання і кілька поруч
           з поточною, між ними «…». */
        var win = (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ? 1 : 2;
        var btns = [];
        var prevShown = -1;
        for (var i = 0; i < totalPages; i++) {
          var show = i === 0 || i === totalPages - 1 || Math.abs(i - currentPage) <= win ||
            (currentPage <= win + 1 && i <= win * 2 + 1) ||
            (currentPage >= totalPages - win - 2 && i >= totalPages - win * 2 - 2);
          if (!show) continue;
          if (prevShown >= 0 && i - prevShown === 2) {
            btns.push('<button type="button" class="bt-rg__page-btn bt-rg__page-btn--num" data-bt-rga-page="' + (i - 1) + '">' + i + '</button>');
          } else if (prevShown >= 0 && i - prevShown > 2) {
            btns.push('<span class="bt-rg__page-gap" aria-hidden="true">…</span>');
          }
          btns.push('<button type="button" class="bt-rg__page-btn bt-rg__page-btn--num' + (i === currentPage ? ' is-active' : '') + '" data-bt-rga-page="' + i + '">' + (i + 1) + '</button>');
          prevShown = i;
        }
        pagesEl.innerHTML = btns.join('');
        if (prevBtn) prevBtn.disabled = currentPage === 0;
        if (nextBtn) nextBtn.disabled = currentPage >= totalPages - 1;
        // Show first/last jump buttons only when many pages
        var showJump = totalPages > 5;
        if (firstBtn) {
          firstBtn.hidden = !showJump;
          firstBtn.disabled = currentPage === 0;
        }
        if (lastBtn) {
          lastBtn.hidden = !showJump;
          lastBtn.disabled = currentPage >= totalPages - 1;
        }
        // Center the active page button in the scroll container (mobile-friendly)
        requestAnimationFrame(centerActivePage);
      }

      function goToPage(idx) {
        var totalPages = totalPagesCount();
        if (idx < 0) idx = 0;
        if (idx >= totalPages) idx = totalPages - 1;
        currentPage = idx;
        renderPagination();
        if (pageLoaded(idx)) {
          pageReq++;
          gridEl.classList.remove('is-loading');
          applyPageVisibility();
          return;
        }
        /* Сторінки ще нема — показуємо стару напівпрозорою, поки тягнемо. */
        var req = ++pageReq;
        gridEl.classList.add('is-loading');
        var finish = function () {
          if (req !== pageReq) return;
          gridEl.classList.remove('is-loading');
          applyPageVisibility();
        };
        fetchChunk(idx * perPage).then(finish, finish);
      }

      function buildAllMediaList() {
        allMediaUrls = [];
        reviews.forEach(function (r) { // forEach пропускає дірки розрідженого масиву
          if (!r.images || !r.images.length) return;
          r.images.forEach(function (u) {
            if (allMediaUrls.indexOf(u) === -1) allMediaUrls.push(u);
          });
        });
      }

      function renderAll() {
        if (!reviews.length) {
          if (emptyEl) emptyEl.hidden = false;
          if (gridEl) gridEl.hidden = true;
          if (paginationEl) paginationEl.hidden = true;
          return;
        }
        var html = reviews.map(function (r, i) {
          return renderCard(r, Math.floor(i / perPage));
        }).join('');
        gridEl.innerHTML = html;
        gridEl.hidden = false;
        if (emptyEl) emptyEl.hidden = true;
        if (totalCount < reviews.length) totalCount = reviews.length;
        goToPage(0);
        decorateCards();
        attachMediaFallback(gridEl);
        if (stripEl) { stripEl.innerHTML = ''; stripUpTo = 0; stripTiles = 0; }
        renderMediaStrip();
        buildAllMediaList();
      }

      /* Same rating adjustment as the bt-review-summary block, so this grid's
         header always shows the same number as the summary at the top of the
         product page. */
      function adjustAverage(avg) {
        var v = (typeof avg === 'number' ? avg : parseFloat(avg)) + ratingOffset;
        if (v < ratingMin) v = ratingMin;
        if (v > 5) v = 5;
        return v;
      }

      /* Shopify's structured_data has no aggregateRating because reviews live
         in our own API — inject the displayed rating into the product JSON-LD
         so Google can show review stars in search results.

         ⚠⚠ ТІЛЬКИ коли блок показує відгуки САМЕ цього товару (handle не
         порожній). Якщо блок показує загальні відгуки магазину, вписувати їх
         у aggregateRating товару НЕ МОЖНА: за правилами Google рейтинг у
         схемі Product має стосуватися цього товару, інакше — manual action
         у пошуку і червоний прапорець для Merchant Center (Misrepresentation).
         Станом на 09.2026 до товарів не привʼязано жодного відгуку, тож на
         картках умова не спрацьовує і схема лишається без рейтингу — це
         правильна поведінка. */
      function patchProductSchema(count, average) {
        if (!count || !handle) return;
        var scripts = document.querySelectorAll('script[type="application/ld+json"]');
        for (var i = 0; i < scripts.length; i++) {
          var data;
          try { data = JSON.parse(scripts[i].textContent); } catch (e) { continue; }
          if (!data || data['@type'] !== 'Product') continue;
          data.aggregateRating = {
            '@type': 'AggregateRating',
            'ratingValue': (Math.round(average * 10) / 10).toFixed(1),
            'reviewCount': count,
            'bestRating': '5',
            'worstRating': '1'
          };
          scripts[i].textContent = JSON.stringify(data);
          break;
        }
      }

      function updateSummary(count, average) {
        average = adjustAverage(average);
        patchProductSchema(count, average);
        if (!summaryEl) return;
        if (!count) { summaryEl.hidden = true; return; }
        summaryEl.hidden = false;
        if (avgEl) avgEl.textContent = (Math.round(average * 10) / 10).toFixed(1);
        if (countEl) countEl.textContent = count;
        if (avgStarsEl) {
          var avgRounded = Math.round(average);
          var stars = '';
          for (var i = 1; i <= 5; i++) stars += (i <= avgRounded ? '★' : '☆');
          avgStarsEl.textContent = stars;
        }
      }

      // Fetch summary + reviews
      // 1. Try to render embedded defaults INSTANTLY (before API fetch)
      function parseDefaults(raw) {
        if (!raw) return null;
        try {
          var p = JSON.parse(raw);
          if (Array.isArray(p)) return { data: p };
          if (p && typeof p === 'object') return p;
        } catch (e) { console.warn('[Bt: Reviews grid] defaults JSON parse error', e); }
        return null;
      }
      /* 0. Картки вже прийшли в HTML зі знімка (серверний рендер) — нічого не
         тягнемо: лише збираємо список фото для стрічки/лайтбокса з розмітки
         й вмикаємо пагінацію. */
      var ssrGrid = gridEl && gridEl.hasAttribute('data-bt-rga-ssr');
      if (ssrGrid) {
        reviews = Array.prototype.map.call(gridEl.querySelectorAll('[data-bt-rga-card]'), function (card) {
          var urls = [];
          card.querySelectorAll('[data-bt-rga-media]').forEach(function (b) {
            var u = b.getAttribute('data-bt-rga-media');
            if (urls.indexOf(u) === -1) urls.push(u);
          });
          return { images: urls };
        });
        totalCount = Math.max(parseInt(countEl && countEl.textContent, 10) || 0, reviews.length);
        goToPage(0);
        decorateCards();
        attachMediaFallback(gridEl);
        renderMediaStrip();
        buildAllMediaList();
      }

      var defaultsScript = ssrGrid ? null : root.querySelector('[data-bt-rga-defaults]');
      var hasDefaults = false;
      if (defaultsScript) {
        var defaultsData = parseDefaults(defaultsScript.textContent);
        if (defaultsData && Array.isArray(defaultsData.data) && defaultsData.data.length) {
          reviews = defaultsData.data;
          if (loadingEl) loadingEl.hidden = true;
          if (defaultsData.summary || (defaultsData.count != null && defaultsData.average != null)) {
            updateSummary(defaultsData.count || (defaultsData.summary && defaultsData.summary.count) || reviews.length,
                          defaultsData.average || (defaultsData.summary && defaultsData.summary.average) || 5);
          }
          renderAll();
          hasDefaults = true;
        }
      }

      // 2. Fetch fresh data from API
      var storeQs = '&store=' + encodeURIComponent(apiStore);
      var localeQs = pageLocale ? '&locale=' + encodeURIComponent(pageLocale) : '';
      var summaryUrl = apiBase + '/api/public/reviews/summary?storeId=' + encodeURIComponent(storeId) + storeQs;
      var productUrl = apiBase + '/api/public/reviews/product?storeId=' + encodeURIComponent(storeId) + storeQs + localeQs +
        '&limit=' + limit + '&sort=' + encodeURIComponent(sort);
      if (handle) {
        summaryUrl += '&handle=' + encodeURIComponent(handle);
        productUrl += '&handle=' + encodeURIComponent(handle);
      }

      if (!ssrGrid) Promise.all([
        fetch(summaryUrl).then(function (r) { return r.json(); }).catch(function () { return null; }),
        fetch(productUrl).then(function (r) { return r.json(); }).catch(function () { return null; })
      ]).then(function (results) {
        if (loadingEl) loadingEl.hidden = true;
        var sum = results[0];
        var list = results[1];
        if (sum && sum.success) updateSummary(sum.count, sum.average);
        if (list && list.success && Array.isArray(list.data) && list.data.length) {
          // Replace defaults with fresh API data
          reviews = list.data;
          totalCount = typeof list.total === 'number' ? list.total : list.data.length;
          renderAll();
        } else if (!hasDefaults) {
          // No defaults and API returned nothing → empty state
          if (emptyEl) emptyEl.hidden = false;
        }
        // else: keep showing defaults if API failed/empty
      }).catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        if (!hasDefaults) {
          if (emptyEl) emptyEl.hidden = false;
        }
      });

      // Pagination clicks
      root.addEventListener('click', function (e) {
        var origBtn = e.target.closest('[data-bt-rga-orig]');
        if (origBtn) { toggleOriginal(origBtn); return; }
        var pageBtn = e.target.closest('[data-bt-rga-page]');
        if (pageBtn) { goToPage(parseInt(pageBtn.getAttribute('data-bt-rga-page'), 10)); return; }
        if (e.target.closest('[data-bt-rga-prev]')) { goToPage(currentPage - 1); return; }
        if (e.target.closest('[data-bt-rga-next]')) { goToPage(currentPage + 1); return; }
        if (e.target.closest('[data-bt-rga-first]')) { goToPage(0); return; }
        if (e.target.closest('[data-bt-rga-last]')) {
          goToPage(totalPagesCount() - 1);
          return;
        }
      });

      // Gallery navigation
      function setGallery(gallery, idx) {
        var count = parseInt(gallery.getAttribute('data-count'), 10) || 0;
        if (count < 2) return;
        if (idx < 0) idx = count - 1;
        if (idx >= count) idx = 0;
        gallery.setAttribute('data-current', idx);
        gallery.querySelectorAll('[data-bt-rga-slide]').forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.getAttribute('data-bt-rga-slide'), 10) === idx);
        });
        gallery.querySelectorAll('[data-bt-rga-gdot]').forEach(function (d) {
          d.classList.toggle('is-active', parseInt(d.getAttribute('data-bt-rga-gdot'), 10) === idx);
        });
        var counter = gallery.querySelector('[data-bt-rga-gcount]');
        if (counter) counter.textContent = idx + 1;
      }
      root.addEventListener('click', function (e) {
        var prev = e.target.closest('[data-bt-rga-gprev]');
        var next = e.target.closest('[data-bt-rga-gnext]');
        var dot = e.target.closest('[data-bt-rga-gdot]');
        if (prev || next || dot) {
          var gallery = (prev || next || dot).closest('[data-bt-rga-gallery]');
          if (!gallery) return;
          e.stopPropagation();
          var cur = parseInt(gallery.getAttribute('data-current'), 10) || 0;
          if (prev) setGallery(gallery, cur - 1);
          else if (next) setGallery(gallery, cur + 1);
          else if (dot) setGallery(gallery, parseInt(dot.getAttribute('data-bt-rga-gdot'), 10));
        }
      });

      // Lightbox with navigation
      var lightboxEl = root.querySelector('[data-bt-rga-lightbox]');
      var lightboxContentEl = root.querySelector('[data-bt-rga-lightbox-content]');
      var lbPrevBtn = root.querySelector('[data-bt-rga-lb-prev]');
      var lbNextBtn = root.querySelector('[data-bt-rga-lb-next]');
      var lbCounterEl = root.querySelector('[data-bt-rga-lb-counter]');

      function showLightboxMedia(url) {
        if (!lightboxContentEl) return;
        lightboxContentEl.innerHTML = buildMediaTag(url, { controls: true });
        attachMediaFallback(lightboxContentEl);
        var v = lightboxContentEl.querySelector('video');
        if (v) { v.controls = true; v.autoplay = true; try { v.play(); } catch (err) {} }
      }
      function updateLightboxNav() {
        var total = allMediaUrls.length;
        var hasNav = total > 1;
        if (lbPrevBtn) lbPrevBtn.hidden = !hasNav;
        if (lbNextBtn) lbNextBtn.hidden = !hasNav;
        if (lbCounterEl) {
          lbCounterEl.hidden = !hasNav;
          if (hasNav) lbCounterEl.textContent = (lbIndex + 1) + ' / ' + total;
        }
      }
      function openLightbox(url) {
        var idx = allMediaUrls.indexOf(url);
        if (idx < 0) {
          // Standalone (not part of the collected list) — still show, but no nav
          lbIndex = -1;
          showLightboxMedia(url);
          if (lbPrevBtn) lbPrevBtn.hidden = true;
          if (lbNextBtn) lbNextBtn.hidden = true;
          if (lbCounterEl) lbCounterEl.hidden = true;
        } else {
          lbIndex = idx;
          showLightboxMedia(allMediaUrls[lbIndex]);
          updateLightboxNav();
        }
        if (lightboxEl) { lightboxEl.classList.add('is-open'); lightboxEl.setAttribute('aria-hidden', 'false'); }
        document.body.classList.add('bt-rga-lightbox-open');
      }
      function closeLightbox() {
        if (lightboxEl) { lightboxEl.classList.remove('is-open'); lightboxEl.setAttribute('aria-hidden', 'true'); }
        if (lightboxContentEl) lightboxContentEl.innerHTML = '';
        document.body.classList.remove('bt-rga-lightbox-open');
      }
      function navLightbox(dir) {
        var total = allMediaUrls.length;
        if (total <= 1 || lbIndex < 0) return;
        if (dir > 0 && lbIndex === total - 1 && stripEl && stripHasMore()) {
          var from = lbIndex;
          maybeLoadStrip(true);
          var wait = inflight[Math.floor(stripUpTo / CHUNK) * CHUNK];
          if (wait) {
            wait.then(function () {
              if (lbIndex !== from || allMediaUrls.length <= from + 1) return;
              lbIndex = from + 1;
              showLightboxMedia(allMediaUrls[lbIndex]);
              updateLightboxNav();
            }, function () {});
            return;
          }
        }
        lbIndex = (lbIndex + dir + total) % total;
        showLightboxMedia(allMediaUrls[lbIndex]);
        updateLightboxNav();
      }

      root.addEventListener('click', function (e) {
        var mediaBtn = e.target.closest('[data-bt-rga-media]');
        var closeBtn = e.target.closest('[data-bt-rga-close]');
        var prevLb = e.target.closest('[data-bt-rga-lb-prev]');
        var nextLb = e.target.closest('[data-bt-rga-lb-next]');
        if (prevLb) { e.stopPropagation(); navLightbox(-1); return; }
        if (nextLb) { e.stopPropagation(); navLightbox(1); return; }
        if (mediaBtn) {
          e.preventDefault();
          openLightbox(mediaBtn.getAttribute('data-bt-rga-media'));
        } else if (closeBtn || e.target === lightboxEl) {
          closeLightbox();
        }
      });

      // Keyboard navigation
      document.addEventListener('keydown', function (e) {
        if (!lightboxEl || !lightboxEl.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') navLightbox(-1);
        else if (e.key === 'ArrowRight') navLightbox(1);
      });

      // Touch swipe on lightbox
      if (lightboxEl) {
        var lbStartX = 0, lbStartY = 0, lbStartT = 0;
        lightboxEl.addEventListener('touchstart', function (e) {
          lbStartX = e.touches[0].clientX;
          lbStartY = e.touches[0].clientY;
          lbStartT = Date.now();
        }, { passive: true });
        lightboxEl.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - lbStartX;
          var dy = e.changedTouches[0].clientY - lbStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          if (Date.now() - lbStartT > 700) return;
          navLightbox(dx < 0 ? 1 : -1);
        });
      }

      // Submit review popup (iframe)
      var openBtn = root.querySelector('[data-bt-rga-open]');
      var modal = root.querySelector('[data-bt-rga-modal]');
      var iframe = root.querySelector('[data-bt-rga-iframe]');
      /* The form keeps working after the review is saved — it shows the promo
         code, offers the survey and the 5%→10% upgrade. So a submit is NOT a
         close signal: we only remember it, and refresh the grid once the
         visitor actually closes the popup (or clicks «go to store», which the
         form reports as `user-done`). Closing on `review-submitted` used to
         kill the promo code before anyone could copy it. */
      var reviewSubmitted = false;
      function closeModal() {
        if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
        if (iframe) iframe.src = 'about:blank';
        if (reviewSubmitted) window.location.reload();
      }
      if (openBtn && modal && iframe) {
        openBtn.addEventListener('click', function () {
          var url = new URL('https://bricktopia-reviews.vercel.app/embed');
          url.searchParams.set('store', apiStore);
          if (pageLocale) url.searchParams.set('locale', pageLocale);
          if (handle) url.searchParams.set('product', handle);
          iframe.src = url.toString();
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
        });
        root.querySelectorAll('[data-bt-rga-modal-close]').forEach(function (b) {
          b.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) closeModal();
        });
      }

      window.addEventListener('message', function (e) {
        if (!e.data || e.data.source !== 'bricktopia-reviews') return;
        if (e.data.type === 'review-submitted' || e.data.type === 'survey-submitted') {
          reviewSubmitted = true;
          return;
        }
        if (e.data.type === 'user-done') closeModal();
        /* The form reports its content height so the iframe can grow/shrink
           with the step instead of sitting at a fixed 720px. */
        if (e.data.type === 'resize' && e.data.height && iframe) {
          var h = Math.max(360, Math.min(Number(e.data.height) + 8, Math.round(window.innerHeight * 0.86)));
          iframe.style.height = h + 'px';
        }
      });
    }

    document.querySelectorAll('[data-bt-rga]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-rga]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Pagination
    document.querySelectorAll('[data-bt-rg-pagination]').forEach(function (pag) {
      if (pag.__btRgReady) return;
      pag.__btRgReady = true;

      var section = pag.closest('.bt-rg');
      if (!section) return;
      var totalPages = parseInt(pag.getAttribute('data-total-pages'), 10);
      var cards = section.querySelectorAll('[data-bt-rg-card]');
      var pageBtns = pag.querySelectorAll('[data-bt-rg-page]');
      var prevBtn = pag.querySelector('[data-bt-rg-prev]');
      var nextBtn = pag.querySelector('[data-bt-rg-next]');
      var current = 0;

      function render(idx) {
        if (idx < 0) idx = 0;
        if (idx >= totalPages) idx = totalPages - 1;
        current = idx;
        cards.forEach(function (c) {
          var pg = parseInt(c.getAttribute('data-page'), 10);
          c.classList.toggle('is-hidden', pg !== idx);
        });
        pageBtns.forEach(function (b) {
          b.classList.toggle('is-active', parseInt(b.getAttribute('data-bt-rg-page'), 10) === idx);
        });
        if (prevBtn) prevBtn.disabled = idx === 0;
        if (nextBtn) nextBtn.disabled = idx >= totalPages - 1;
        // Scroll to top of grid
        var grid = section.querySelector('[data-bt-rg-grid]');
        if (grid) {
          var rect = grid.getBoundingClientRect();
          if (rect.top < 0) {
            window.scrollTo({ top: window.scrollY + rect.top - 80, behavior: 'smooth' });
          }
        }
      }

      pageBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          render(parseInt(btn.getAttribute('data-bt-rg-page'), 10));
        });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { render(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { render(current + 1); });
      render(0);
    });

    // Lightbox
    document.addEventListener('click', function (e) {
      var imgBtn = e.target.closest('[data-bt-rg-media-image]');
      var vidBtn = e.target.closest('[data-bt-rg-media-video]');
      var closeBtn = e.target.closest('[data-bt-rg-close]');
      var lightbox = e.target.closest('[data-bt-rg-lightbox]');

      if (imgBtn) {
        var src = imgBtn.getAttribute('data-bt-rg-media-image');
        openLightbox(imgBtn, '<img src="' + src + '" alt="">');
      } else if (vidBtn) {
        var vsrc = vidBtn.getAttribute('data-bt-rg-media-video');
        openLightbox(vidBtn, '<video src="' + vsrc + '" controls autoplay playsinline></video>');
      } else if (closeBtn || (lightbox && e.target === lightbox)) {
        closeLightbox(closeBtn || lightbox);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.bt-rg__lightbox.is-open').forEach(closeLightbox);
    });

    function openLightbox(from, html) {
      var section = from.closest('.bt-rg');
      if (!section) return;
      var lightbox = section.querySelector('[data-bt-rg-lightbox]');
      var content = section.querySelector('[data-bt-rg-lightbox-content]');
      if (!lightbox || !content) return;
      content.innerHTML = html;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bt-rg-lightbox-open');
    }

    function closeLightbox(el) {
      var lightbox = el.matches && el.matches('[data-bt-rg-lightbox]') ? el : el.closest('.bt-rg')?.querySelector('[data-bt-rg-lightbox]');
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      var content = lightbox.querySelector('[data-bt-rg-lightbox-content]');
      if (content) content.innerHTML = '';
      document.body.classList.remove('bt-rg-lightbox-open');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-marquee-api"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__btRmReady) return;
      root.__btRmReady = true;

      var apiBase = root.getAttribute('data-api-base');
      var storeId = root.getAttribute('data-store-id');
      var apiStore = root.getAttribute('data-store') || 'ua';
      var pageLocale = (root.getAttribute('data-locale') || '').toLowerCase();
      var anonLabel = root.getAttribute('data-anon-label') || 'Anonim';
      var handle = root.getAttribute('data-handle');
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 30;
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 40;
      var sort = root.getAttribute('data-sort') || 'recent';
      var rows = parseInt(root.getAttribute('data-rows'), 10) || 1;
      if (rows < 1) rows = 1;
      if (rows > 4) rows = 4;
      var rowDirs = [
        root.getAttribute('data-row-1-dir') || 'left',
        root.getAttribute('data-row-2-dir') || 'right',
        root.getAttribute('data-row-3-dir') || 'left',
        root.getAttribute('data-row-4-dir') || 'right'
      ];
      var photosFilter = root.getAttribute('data-photos-filter') || 'all';
      var loadingEl = root.querySelector('[data-bt-rm-loading]');
      var rowsEl = root.querySelector('[data-bt-rm-rows]');
      var emptyEl = root.querySelector('[data-bt-rm-empty]');

      /* 12.10.2026: підпис «перекладено з …» під перекладеним відгуком
         (словник — дзеркало snippets/bt-review-tr-note.liquid; повна версія з
         кнопкою оригіналу — у reviews-grid-api). */
      function trNote(r) {
        if (!r || !r.translated) return '';
        var T = {
          pl: ['Przetłumaczono automatycznie', { pl: 'z polskiego', uk: 'z ukraińskiego', en: 'z angielskiego', it: 'z włoskiego', ru: 'z rosyjskiego' }],
          en: ['Translated automatically', { pl: 'from Polish', uk: 'from Ukrainian', en: 'from English', it: 'from Italian', ru: 'from Russian' }],
          uk: ['Перекладено автоматично', { pl: 'з польської', uk: 'з української', en: 'з англійської', it: 'з італійської', ru: 'з російської' }],
          ru: ['Переведено автоматически', { pl: 'с польского', uk: 'с украинского', en: 'с английского', it: 'с итальянского', ru: 'с русского' }],
          de: ['Automatisch übersetzt', { pl: 'aus dem Polnischen', uk: 'aus dem Ukrainischen', en: 'aus dem Englischen', it: 'aus dem Italienischen', ru: 'aus dem Russischen' }],
          it: ['Tradotto automaticamente', { pl: 'dal polacco', uk: 'dall\u2019ucraino', en: 'dall\u2019inglese', it: 'dall\u2019italiano', ru: 'dal russo' }],
          cs: ['Automaticky přeloženo', { pl: 'z polštiny', uk: 'z ukrajinštiny', en: 'z angličtiny', it: 'z italštiny', ru: 'z ruštiny' }],
          es: ['Traducido automáticamente', { pl: 'del polaco', uk: 'del ucraniano', en: 'del inglés', it: 'del italiano', ru: 'del ruso' }],
          fr: ['Traduit automatiquement', { pl: 'du polonais', uk: 'de l’ukrainien', en: 'de l’anglais', it: 'de l’italien', ru: 'du russe' }],
          nl: ['Automatisch vertaald', { pl: 'uit het Pools', uk: 'uit het Oekraïens', en: 'uit het Engels', it: 'uit het Italiaans', ru: 'uit het Russisch' }],
          sk: ['Automaticky preložené', { pl: 'z poľštiny', uk: 'z ukrajinčiny', en: 'z angličtiny', it: 'z taliančiny', ru: 'z ruštiny' }],
          hu: ['Automatikusan lefordítva', { pl: 'lengyelből', uk: 'ukránból', en: 'angolból', it: 'olaszból', ru: 'oroszból' }],
          ro: ['Tradus automat', { pl: 'din poloneză', uk: 'din ucraineană', en: 'din engleză', it: 'din italiană', ru: 'din rusă' }],
          lt: ['Išversta automatiškai', { pl: 'iš lenkų kalbos', uk: 'iš ukrainiečių kalbos', en: 'iš anglų kalbos', it: 'iš italų kalbos', ru: 'iš rusų kalbos' }],
          lv: ['Automātiski tulkots', { pl: 'no poļu valodas', uk: 'no ukraiņu valodas', en: 'no angļu valodas', it: 'no itāļu valodas', ru: 'no krievu valodas' }],
          et: ['Automaatselt tõlgitud', { pl: 'poola keelest', uk: 'ukraina keelest', en: 'inglise keelest', it: 'itaalia keelest', ru: 'vene keelest' }]
        };
        var d = T[(document.documentElement.lang || 'pl').slice(0, 2)] || T.en;
        var label = d[0] + (d[1][r.source_locale] ? ' ' + d[1][r.source_locale] : '');
        return '<div class="bt-review-tr-note" style="font-size:12px;line-height:1.4;opacity:.6;margin-top:6px">' + esc(label) + '</div>';
      }

      function esc(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
      }
      var IMAGE_EXTS = ['jpg','jpeg','png','gif','webp','avif','heic','heif','bmp','svg'];
      var VIDEO_EXTS = ['mp4','webm','mov','m4v','ogg','ogv','mkv','3gp'];
      function guessMediaKind(url) {
        if (!url) return 'unknown';
        var pathname = url;
        try { pathname = new URL(url, 'http://x').pathname; }
        catch (e) { pathname = (url.split('?')[0] || '').split('#')[0]; }
        for (var i = 0; i < 2; i++) {
          var p;
          try { p = i === 0 ? pathname : decodeURIComponent(pathname); }
          catch (e) { p = pathname; }
          var m = p.match(/\.([a-z0-9]{2,5})$/i);
          if (!m) continue;
          var ext = m[1].toLowerCase();
          if (IMAGE_EXTS.indexOf(ext) !== -1) return 'image';
          if (VIDEO_EXTS.indexOf(ext) !== -1) return 'video';
        }
        return 'unknown';
      }
            // ⚠ {% javascript %} не рендерить Liquid — мову беремо з <html lang>
      var BT_LANG = (document.documentElement.lang || 'pl').slice(0, 2);
      var BT_REVIEW_PHOTO_ALT = BT_LANG === 'en' ? 'Customer review photo' : BT_LANG === 'uk' ? 'Фото з відгуку клієнта' : 'Zdjęcie z opinii klienta';
      // 30.09.2026: it/ru — раніше падали на польський alt
      if (BT_LANG === 'it') BT_REVIEW_PHOTO_ALT = 'Foto dalla recensione di un cliente';
      else if (BT_LANG === 'de') BT_REVIEW_PHOTO_ALT = 'Foto aus der Kundenbewertung';
      else if (BT_LANG === 'cs') BT_REVIEW_PHOTO_ALT = 'Fotografie z recenze zákazníka';
      else if (BT_LANG === 'es') BT_REVIEW_PHOTO_ALT = 'Foto de la opinión de un cliente';
      else if (BT_LANG === 'fr') BT_REVIEW_PHOTO_ALT = 'Photo issue d’un avis client';
      else if (BT_LANG === 'nl') BT_REVIEW_PHOTO_ALT = 'Foto uit een klantreview';
      else if (BT_LANG === 'sk') BT_REVIEW_PHOTO_ALT = 'Fotografia z recenzie zákazníka';
      else if (BT_LANG === 'hu') BT_REVIEW_PHOTO_ALT = 'Fotó egy vásárlói véleményből';
      else if (BT_LANG === 'ro') BT_REVIEW_PHOTO_ALT = 'Fotografie din recenzia unui client';
      else if (BT_LANG === 'lt') BT_REVIEW_PHOTO_ALT = 'Nuotrauka iš kliento atsiliepimo';
      else if (BT_LANG === 'lv') BT_REVIEW_PHOTO_ALT = 'Foto no klienta atsauksmes';
      else if (BT_LANG === 'et') BT_REVIEW_PHOTO_ALT = 'Foto kliendi arvustusest';
      else if (BT_LANG === 'ru') BT_REVIEW_PHOTO_ALT = 'Фото из отзыва клиента';
      /* 10.10.2026 (швидкість): фото відгуків лежать у Supabase оригіналами по 1–3 МБ — картці досить
         мініатюри через /render/image. Не віддалась — фолбек бере оригінал з data-bt-media-url.
         Лайтбокс (opts.controls) показує оригінал. Дзеркало — snippets/bt-rm-ssr-card.liquid. */
      var THUMB_EXTS = ['jpg','jpeg','png','webp','avif','heic','heif','bmp'];
      function thumbUrl(url) {
        if (!url || url.indexOf('/storage/v1/object/public/') === -1) return null;
        var path = (url.split('?')[0] || '').split('#')[0];
        var m = path.match(/\.([a-z0-9]{2,5})$/i);
        if (!m || THUMB_EXTS.indexOf(m[1].toLowerCase()) === -1) return null;
        /* 04.11.2026: готова мініатюра reviews/thumb/<name>.webp (робить lost-orders при завантаженні, lib/review-thumb.ts) —
           /render/image рахується в ліміт трансформацій Supabase (100 різних фото на місяць). Інші адреси — як раніше. */
        var RM = '/storage/v1/object/public/review-media/reviews/';
        var at = path.indexOf(RM);
        if (at !== -1 && path.slice(at + RM.length).indexOf('/') === -1) return path.slice(0, at + RM.length) + 'thumb/' + path.slice(at + RM.length).replace(/\.[^.]+$/, '') + '.webp';
        return path.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/') + '?width=640&height=400&resize=cover&quality=70';
      }
      function buildMediaTag(url, opts) {
        opts = opts || {};
        var kind = guessMediaKind(url);
        var initial = (kind === 'video') ? 'video' : 'image';
        var escaped = esc(url);
        var attrs = 'data-bt-media-url="' + escaped + '" data-bt-media-tried="' + initial + '"';
        if (initial === 'video') {
          return '<video src="' + escaped + '" muted playsinline preload="metadata"' + (opts.controls ? ' controls' : '') + ' ' + attrs + '></video>';
        }
        var altText = (opts.alt || BT_REVIEW_PHOTO_ALT).replace(/"/g, '&quot;');
        var thumb = opts.controls ? null : thumbUrl(url);
        if (thumb) attrs += ' data-bt-thumb="1"';
        var srcAttr = thumb ? thumb.replace(/&/g, '&amp;').replace(/"/g, '&quot;') : escaped;
        return '<img src="' + srcAttr + '" loading="lazy" decoding="async" alt="' + altText + '" ' + attrs + '>';
      }
      function removeBrokenMedia(el) {
        var mediaWrap = el.closest('.bt-rm__card-media');
        if (mediaWrap) mediaWrap.remove();
        else el.remove();
      }
      function attachMediaFallback(scope) {
        if (!scope) return;
        scope.querySelectorAll('[data-bt-media-url]:not([data-bt-media-bound])').forEach(function (el) {
          el.setAttribute('data-bt-media-bound', '1');
          /* Серверні картки: фото могло впасти ще до цього скрипта — тоді
             onerror у розмітці лишив мітку, і фолбек запускаємо вручну. */
          if (el.getAttribute('data-bt-media-failed')) {
            setTimeout(function () { el.dispatchEvent(new Event('error')); }, 0);
          }
          el.addEventListener('error', function onMediaError() {
            var u = el.getAttribute('data-bt-media-url');
            var tried = el.getAttribute('data-bt-media-tried');
            /* мініатюра Supabase не віддалась — пробуємо оригінал, лише потім відео */
            if (el.tagName === 'IMG' && el.getAttribute('data-bt-thumb') && !el.getAttribute('data-bt-thumb-failed')) {
              el.setAttribute('data-bt-thumb-failed', '1');
              el.removeAttribute('data-bt-media-failed');
              el.addEventListener('error', onMediaError, { once: true });
              el.src = u;
              return;
            }
            if (tried === 'image') {
              var v = document.createElement('video');
              v.src = u; v.muted = true; v.playsInline = true; v.preload = 'metadata';
              v.setAttribute('data-bt-media-url', u);
              v.setAttribute('data-bt-media-tried', 'video');
              v.setAttribute('data-bt-media-bound', '1');
              v.addEventListener('error', function () {
                removeBrokenMedia(v);
              }, { once: true });
              el.replaceWith(v);
              var mediaEl = v.closest('.bt-rm__card-media');
              if (mediaEl && !mediaEl.querySelector('.bt-rm__card-media-play')) {
                var p = document.createElement('span');
                p.className = 'bt-rm__card-media-play';
                p.textContent = '▶';
                p.setAttribute('aria-hidden', 'true');
                mediaEl.appendChild(p);
              }
            } else {
              removeBrokenMedia(el);
            }
          }, { once: true });
        });
      }
      function stars(r) {
        var f = Math.round(r || 0);
        var out = '';
        for (var i = 1; i <= 5; i++) out += (i <= f ? '★' : '☆');
        return out;
      }
      function renderCard(r) {
        var name = r.author_name || anonLabel;
        var letter = (name.trim().charAt(0) || '?').toUpperCase();
        var mediaHtml = '';
        if (r.images && r.images.length > 0) {
          var firstUrl = r.images[0];
          var kind = guessMediaKind(firstUrl);
          var playIcon = (kind === 'video') ? '<span class="bt-rm__card-media-play" aria-hidden="true">▶</span>' : '';
          var countBadge = r.images.length > 1
            ? '<span class="bt-rm__card-media-count">+' + (r.images.length - 1) + '</span>'
            : '';
          mediaHtml = '<div class="bt-rm__card-media">' + buildMediaTag(firstUrl, { alt: BT_REVIEW_PHOTO_ALT + ': ' + name }) + playIcon + countBadge + '</div>';
        }
        return '<div class="bt-rm__card">' +
          '<div class="bt-rm__card-top">' +
            '<div class="bt-rm__card-avatar">' + esc(letter) + '</div>' +
            '<div class="bt-rm__card-info">' +
              '<span class="bt-rm__card-name">' + esc(name) + '</span>' +
              '<span class="bt-rm__card-stars">' + stars(r.rating) + '</span>' +
            '</div>' +
          '</div>' +
          mediaHtml +
          (r.body ? '<div class="bt-rm__card-text">' + esc(r.body) + '</div>' + trNote(r) : '') +
        '</div>';
      }

      function parseDefaults(raw) {
        if (!raw) return null;
        try {
          var p = JSON.parse(raw);
          if (Array.isArray(p)) return p;
          if (p && Array.isArray(p.data)) return p.data;
        } catch (e) { console.warn('[Bt: Reviews marquee] defaults JSON parse error', e); }
        return null;
      }

      function renderRows(reviews) {
        function hasMedia(r) { return r && r.images && r.images.length > 0; }
        var source = reviews;
        if (photosFilter === 'only') source = source.filter(hasMedia);
        else if (photosFilter === 'priority') {
          var w = source.filter(hasMedia), wo = source.filter(function (r) { return !hasMedia(r); });
          source = w.concat(wo);
        }
        if (!source.length) return false;
        var count = source.length;
        var baseDuration = Math.max(15, count * (60 / speed) * 2);
        rowsEl.innerHTML = '';
        for (var i = 0; i < rows; i++) {
          var rowReviews = (i % 2 === 1) ? source.slice().reverse() : source;
          if (i >= 2) {
            var offset = Math.floor(count / (i + 1));
            rowReviews = rowReviews.slice(offset).concat(rowReviews.slice(0, offset));
          }
          var cardsHtml = rowReviews.map(renderCard).join('');
          var track = document.createElement('div');
          track.className = 'bt-rm__track';
          track.setAttribute('data-direction', rowDirs[i] || 'left');
          var dur = baseDuration * (1 + i * 0.08);
          track.style.setProperty('--bt-rm-duration', dur + 's');
          track.innerHTML = cardsHtml + cardsHtml;
          rowsEl.appendChild(track);
        }
        rowsEl.hidden = false;
        attachMediaFallback(rowsEl);
        return true;
      }

      /* 0. Ряди вже прийшли в HTML зі знімка (серверний рендер) — нічого не
         тягнемо, лише вмикаємо фолбек для фото/відео. */
      if (rowsEl && rowsEl.hasAttribute('data-bt-rm-ssr')) {
        attachMediaFallback(rowsEl);
        return;
      }

      // 1. Render embedded defaults INSTANTLY
      var defaultsScript = root.querySelector('[data-bt-rm-defaults]');
      var hasDefaults = false;
      if (defaultsScript) {
        var defaults = parseDefaults(defaultsScript.textContent);
        if (defaults && defaults.length) {
          if (loadingEl) loadingEl.hidden = true;
          if (renderRows(defaults)) hasDefaults = true;
        }
      }

      // 2. Fetch fresh data
      var url = apiBase + '/api/public/reviews/product?storeId=' + encodeURIComponent(storeId) +
        '&store=' + encodeURIComponent(apiStore) + (pageLocale ? '&locale=' + encodeURIComponent(pageLocale) : '') +
        '&limit=' + limit + '&sort=' + encodeURIComponent(sort);
      if (handle) url += '&handle=' + encodeURIComponent(handle);

      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        if (loadingEl) loadingEl.hidden = true;
        if (!data || !data.success || !Array.isArray(data.data) || !data.data.length) {
          if (!hasDefaults) {
            if (emptyEl) emptyEl.hidden = false;
          }
          return;
        }
        if (!renderRows(data.data) && !hasDefaults) {
          if (emptyEl) emptyEl.hidden = false;
        }
      }).catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        if (!hasDefaults) {
          if (emptyEl) emptyEl.hidden = false;
        }
      });
    }
    document.querySelectorAll('[data-bt-rm]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-rm]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-spotlight-api"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__btRsaReady) return;
      root.__btRsaReady = true;

      var apiBase = root.getAttribute('data-api-base');
      var storeId = root.getAttribute('data-store-id');
      var apiStore = root.getAttribute('data-store') || 'ua';
      var pageLocale = (root.getAttribute('data-locale') || '').toLowerCase();
      var anonLabel = root.getAttribute('data-anon-label') || 'Anonim';
      var verifiedLabel = root.getAttribute('data-verified-label') || 'Zweryfikowany zakup';
      var handle = root.getAttribute('data-handle');
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 30;
      var sort = root.getAttribute('data-sort') || 'recent';
      var autoInterval = parseInt(root.getAttribute('data-interval'), 10) || 0;

      var loadingEl = root.querySelector('[data-bt-rsa-loading]');
      var stageEl = root.querySelector('[data-bt-rsa-stage]');
      var emptyEl = root.querySelector('[data-bt-rsa-empty]');
      var controlsEl = root.querySelector('[data-bt-rsa-controls]');
      var dotsEl = root.querySelector('[data-bt-rsa-dots]');
      var prevBtn = root.querySelector('[data-bt-rsa-prev]');
      var nextBtn = root.querySelector('[data-bt-rsa-next]');
      var reviews = [];
      var current = 0;
      var timer = null;

      /* 12.10.2026: підпис «перекладено з …» під перекладеним відгуком
         (словник — дзеркало snippets/bt-review-tr-note.liquid; повна версія з
         кнопкою оригіналу — у reviews-grid-api). */
      function trNote(r) {
        if (!r || !r.translated) return '';
        var T = {
          pl: ['Przetłumaczono automatycznie', { pl: 'z polskiego', uk: 'z ukraińskiego', en: 'z angielskiego', it: 'z włoskiego', ru: 'z rosyjskiego' }],
          en: ['Translated automatically', { pl: 'from Polish', uk: 'from Ukrainian', en: 'from English', it: 'from Italian', ru: 'from Russian' }],
          uk: ['Перекладено автоматично', { pl: 'з польської', uk: 'з української', en: 'з англійської', it: 'з італійської', ru: 'з російської' }],
          ru: ['Переведено автоматически', { pl: 'с польского', uk: 'с украинского', en: 'с английского', it: 'с итальянского', ru: 'с русского' }],
          de: ['Automatisch übersetzt', { pl: 'aus dem Polnischen', uk: 'aus dem Ukrainischen', en: 'aus dem Englischen', it: 'aus dem Italienischen', ru: 'aus dem Russischen' }],
          it: ['Tradotto automaticamente', { pl: 'dal polacco', uk: 'dall\u2019ucraino', en: 'dall\u2019inglese', it: 'dall\u2019italiano', ru: 'dal russo' }],
          cs: ['Automaticky přeloženo', { pl: 'z polštiny', uk: 'z ukrajinštiny', en: 'z angličtiny', it: 'z italštiny', ru: 'z ruštiny' }],
          es: ['Traducido automáticamente', { pl: 'del polaco', uk: 'del ucraniano', en: 'del inglés', it: 'del italiano', ru: 'del ruso' }],
          fr: ['Traduit automatiquement', { pl: 'du polonais', uk: 'de l’ukrainien', en: 'de l’anglais', it: 'de l’italien', ru: 'du russe' }],
          nl: ['Automatisch vertaald', { pl: 'uit het Pools', uk: 'uit het Oekraïens', en: 'uit het Engels', it: 'uit het Italiaans', ru: 'uit het Russisch' }],
          sk: ['Automaticky preložené', { pl: 'z poľštiny', uk: 'z ukrajinčiny', en: 'z angličtiny', it: 'z taliančiny', ru: 'z ruštiny' }],
          hu: ['Automatikusan lefordítva', { pl: 'lengyelből', uk: 'ukránból', en: 'angolból', it: 'olaszból', ru: 'oroszból' }],
          ro: ['Tradus automat', { pl: 'din poloneză', uk: 'din ucraineană', en: 'din engleză', it: 'din italiană', ru: 'din rusă' }],
          lt: ['Išversta automatiškai', { pl: 'iš lenkų kalbos', uk: 'iš ukrainiečių kalbos', en: 'iš anglų kalbos', it: 'iš italų kalbos', ru: 'iš rusų kalbos' }],
          lv: ['Automātiski tulkots', { pl: 'no poļu valodas', uk: 'no ukraiņu valodas', en: 'no angļu valodas', it: 'no itāļu valodas', ru: 'no krievu valodas' }],
          et: ['Automaatselt tõlgitud', { pl: 'poola keelest', uk: 'ukraina keelest', en: 'inglise keelest', it: 'itaalia keelest', ru: 'vene keelest' }]
        };
        var d = T[(document.documentElement.lang || 'pl').slice(0, 2)] || T.en;
        var label = d[0] + (d[1][r.source_locale] ? ' ' + d[1][r.source_locale] : '');
        return '<div class="bt-review-tr-note" style="font-size:12px;line-height:1.4;opacity:.6;margin-top:6px">' + escapeHtml(label) + '</div>';
      }

      function escapeHtml(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
      }
      var IMAGE_EXTS = ['jpg','jpeg','png','gif','webp','avif','heic','heif','bmp','svg'];
      var VIDEO_EXTS = ['mp4','webm','mov','m4v','ogg','ogv','mkv','3gp'];
      function guessMediaKind(url) {
        if (!url) return 'unknown';
        var pathname = url;
        try { pathname = new URL(url, 'http://x').pathname; }
        catch (e) { pathname = (url.split('?')[0] || '').split('#')[0]; }
        for (var i = 0; i < 2; i++) {
          var p;
          try { p = i === 0 ? pathname : decodeURIComponent(pathname); }
          catch (e) { p = pathname; }
          var m = p.match(/\.([a-z0-9]{2,5})$/i);
          if (!m) continue;
          var ext = m[1].toLowerCase();
          if (IMAGE_EXTS.indexOf(ext) !== -1) return 'image';
          if (VIDEO_EXTS.indexOf(ext) !== -1) return 'video';
        }
        return 'unknown';
      }
      function isVideo(url) { return guessMediaKind(url) === 'video'; }
      function buildMediaTag(url, opts) {
        opts = opts || {};
        var kind = guessMediaKind(url);
        var initial = (kind === 'video') ? 'video' : 'image';
        var escaped = escapeHtml(url);
        var attrs = 'data-bt-media-url="' + escaped + '" data-bt-media-tried="' + initial + '"';
        if (initial === 'video') {
          return '<video src="' + escaped + '" muted playsinline preload="metadata"' + (opts.controls ? ' controls' : '') + ' ' + attrs + '></video>';
        }
        return '<img src="' + escaped + '" loading="lazy" alt="" ' + attrs + '>';
      }
      function removeBrokenMedia(el) {
        var tile = el.closest('.bt-rs__gallery-item');
        if (!tile) { el.remove(); return; }
        var gallery = tile.parentElement;
        tile.remove();
        if (gallery && gallery.classList.contains('bt-rs__gallery')) {
          var remaining = gallery.querySelectorAll('.bt-rs__gallery-item').length;
          if (remaining === 0) {
            var media = gallery.closest('.bt-rs__media');
            if (media) {
              media.style.display = 'none';
              var inner = media.closest('.bt-rs__slide-inner');
              if (inner) inner.style.gridTemplateColumns = '1fr';
            }
          } else {
            gallery.setAttribute('data-count', remaining);
          }
        }
      }
      function attachMediaFallback(scope) {
        if (!scope) return;
        scope.querySelectorAll('[data-bt-media-url]:not([data-bt-media-bound])').forEach(function (el) {
          el.setAttribute('data-bt-media-bound', '1');
          el.addEventListener('error', function () {
            var u = el.getAttribute('data-bt-media-url');
            var tried = el.getAttribute('data-bt-media-tried');
            if (tried === 'image') {
              var v = document.createElement('video');
              v.src = u; v.muted = true; v.playsInline = true; v.preload = 'metadata';
              if (el.closest('.bt-rs__lightbox')) v.controls = true;
              v.setAttribute('data-bt-media-url', u);
              v.setAttribute('data-bt-media-tried', 'video');
              v.setAttribute('data-bt-media-bound', '1');
              v.addEventListener('error', function () {
                removeBrokenMedia(v);
              }, { once: true });
              el.replaceWith(v);
              var btn = v.closest('.bt-rs__gallery-item');
              if (btn && !btn.querySelector('.bt-rs__gallery-play')) {
                var p = document.createElement('span');
                p.className = 'bt-rs__gallery-play';
                p.textContent = '▶';
                p.setAttribute('aria-hidden', 'true');
                btn.appendChild(p);
              }
            } else {
              removeBrokenMedia(el);
            }
          }, { once: true });
        });
      }
      function starsHtml(r) {
        var filled = Math.round(r || 0);
        var out = '';
        for (var i = 1; i <= 5; i++) out += (i <= filled ? '★' : '☆');
        return out;
      }

      function renderMedia(imgs, name) {
        if (!imgs || !imgs.length) {
          var letter = (name || '?').trim().charAt(0).toUpperCase();
          return '<div class="bt-rs__photo bt-rs__photo--letter">' + escapeHtml(letter) + '</div>';
        }
        var count = Math.min(3, imgs.length);
        var tiles = imgs.slice(0, 3).map(function (url, i) {
          var cls = (i === 0) ? 'bt-rs__gallery-item--main' : 'bt-rs__gallery-item--thumb';
          var kind = guessMediaKind(url);
          var playIcon = (kind === 'video') ? '<span class="bt-rs__gallery-play" aria-hidden="true">▶</span>' : '';
          return '<button type="button" class="bt-rs__gallery-item ' + cls + '" data-bt-rsa-media="' + escapeHtml(url) + '" aria-label="Open">' +
            buildMediaTag(url) + playIcon +
          '</button>';
        }).join('');
        return '<div class="bt-rs__gallery" data-count="' + count + '">' + tiles + '</div>';
      }

      function renderSlide(r, idx) {
        var name = r.author_name || anonLabel;
        var productLink = (r.product_handle && r.product_handle !== 'store' && !handle)
          ? '<a href="/products/' + escapeHtml(r.product_handle) + '" class="bt-rs__author-badge">' + escapeHtml(r.product_title || r.product_handle) + '</a>'
          : '';
        var adminReply = r.admin_reply
          ? '<div class="bt-rs__admin-reply"><strong>Kloniko:</strong> ' + escapeHtml(r.admin_reply) + '</div>'
          : '';
        return '<article class="bt-rs__slide' + (idx === 0 ? ' is-active' : '') + '" data-bt-rsa-slide="' + idx + '">' +
          '<div class="bt-rs__slide-inner">' +
            '<div class="bt-rs__media">' + renderMedia(r.images, name) + '</div>' +
            '<div class="bt-rs__content">' +
              '<div class="bt-rs__stars">' + starsHtml(r.rating) + '</div>' +
              (r.title ? '<h3 class="bt-rs__title">' + escapeHtml(r.title) + '</h3>' : '') +
              (r.body ? '<div class="bt-rs__text">' + escapeHtml(r.body) + '</div>' + trNote(r) : '') +
              '<div class="bt-rs__author-row">' +
                '<span class="bt-rs__author-name">— ' + escapeHtml(name) + '</span>' +
                (r.verified_purchase ? '<span class="bt-rs__author-badge">' + escapeHtml(verifiedLabel) + '</span>' : '') +
                productLink +
              '</div>' +
              adminReply +
            '</div>' +
          '</div>' +
        '</article>';
      }

      // Above this many reviews the dot row wraps into several lines on mobile —
      // switch to a compact "n / total" counter instead.
      var MAX_DOTS = 10;

      function renderDots() {
        if (!dotsEl) return;
        if (reviews.length > MAX_DOTS) {
          dotsEl.classList.add('bt-rs__dots--counter');
          dotsEl.innerHTML = '<span class="bt-rs__counter" data-bt-rsa-counter aria-live="polite"><b>1</b> / ' + reviews.length + '</span>';
          return;
        }
        dotsEl.classList.remove('bt-rs__dots--counter');
        dotsEl.innerHTML = reviews.map(function (_, i) {
          return '<button type="button" class="bt-rs__dot' + (i === 0 ? ' is-active' : '') + '" data-bt-rsa-dot="' + i + '" aria-label="Review ' + (i + 1) + '"></button>';
        }).join('');
      }

      function show(idx) {
        if (idx < 0) idx = reviews.length - 1;
        if (idx >= reviews.length) idx = 0;
        current = idx;
        stageEl.querySelectorAll('[data-bt-rsa-slide]').forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.getAttribute('data-bt-rsa-slide'), 10) === idx);
        });
        if (dotsEl) {
          var counter = dotsEl.querySelector('[data-bt-rsa-counter]');
          if (counter) {
            counter.innerHTML = '<b>' + (idx + 1) + '</b> / ' + reviews.length;
          } else {
            dotsEl.querySelectorAll('[data-bt-rsa-dot]').forEach(function (d) {
              d.classList.toggle('is-active', parseInt(d.getAttribute('data-bt-rsa-dot'), 10) === idx);
            });
          }
        }
      }

      function parseDefaults(raw) {
        if (!raw) return null;
        try {
          var p = JSON.parse(raw);
          if (Array.isArray(p)) return p;
          if (p && Array.isArray(p.data)) return p.data;
        } catch (e) { console.warn('[Bt: Reviews spotlight] defaults JSON parse error', e); }
        return null;
      }

      function renderReviews(list) {
        reviews = list;
        stageEl.innerHTML = reviews.map(renderSlide).join('');
        stageEl.hidden = false;
        attachMediaFallback(stageEl);
        if (reviews.length > 1) {
          renderDots();
          if (controlsEl) controlsEl.hidden = false;
        } else {
          if (controlsEl) controlsEl.hidden = true;
        }
        current = 0;
      }

      // 1. Render embedded defaults INSTANTLY
      var defaultsScript = root.querySelector('[data-bt-rsa-defaults]');
      var hasDefaults = false;
      if (defaultsScript) {
        var defaults = parseDefaults(defaultsScript.textContent);
        if (defaults && defaults.length) {
          if (loadingEl) loadingEl.hidden = true;
          renderReviews(defaults);
          hasDefaults = true;
        }
      }

      // 2. Fetch fresh from API
      var url = apiBase + '/api/public/reviews/product?storeId=' + encodeURIComponent(storeId) +
        '&store=' + encodeURIComponent(apiStore) + (pageLocale ? '&locale=' + encodeURIComponent(pageLocale) : '') +
        '&limit=' + limit + '&sort=' + encodeURIComponent(sort);
      if (handle) url += '&handle=' + encodeURIComponent(handle);

      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        if (loadingEl) loadingEl.hidden = true;
        if (!data || !data.success || !Array.isArray(data.data) || !data.data.length) {
          if (!hasDefaults) {
            if (emptyEl) emptyEl.hidden = false;
          }
          return;
        }
        renderReviews(data.data);
        // Autoplay
        if (autoInterval > 0 && reviews.length > 1) {
          if (timer) clearInterval(timer);
          timer = setInterval(function () { show(current + 1); }, autoInterval * 1000);
          root.addEventListener('mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
        }
      }).catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        if (!hasDefaults) {
          if (emptyEl) emptyEl.hidden = false;
        }
      });

      // Controls
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-bt-rsa-prev]')) { show(current - 1); return; }
        if (e.target.closest('[data-bt-rsa-next]')) { show(current + 1); return; }
        var dot = e.target.closest('[data-bt-rsa-dot]');
        if (dot) { show(parseInt(dot.getAttribute('data-bt-rsa-dot'), 10)); return; }
      });

      // Touch swipe
      var startX = 0, startT = 0;
      if (stageEl) {
        stageEl.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startT = Date.now();
        }, { passive: true });
        stageEl.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 40 || Date.now() - startT > 600) return;
          show(dx < 0 ? current + 1 : current - 1);
        });
      }

      // Lightbox
      root.addEventListener('click', function (e) {
        var mediaBtn = e.target.closest('[data-bt-rsa-media]');
        var closeBtn = e.target.closest('[data-bt-rsa-close]');
        var lightbox = root.querySelector('[data-bt-rsa-lightbox]');
        var content = root.querySelector('[data-bt-rsa-lightbox-content]');
        if (mediaBtn) {
          e.preventDefault();
          var url = mediaBtn.getAttribute('data-bt-rsa-media');
          if (content) content.innerHTML = buildMediaTag(url, { controls: true });
          attachMediaFallback(content);
          var v = content && content.querySelector('video');
          if (v) { v.controls = true; v.autoplay = true; try { v.play(); } catch (err) {} }
          if (lightbox) { lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false'); }
          document.body.classList.add('bt-rsa-lightbox-open');
        } else if (closeBtn || e.target === lightbox) {
          if (lightbox) { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); }
          if (content) content.innerHTML = '';
          document.body.classList.remove('bt-rsa-lightbox-open');
        }
      });
    }

    document.querySelectorAll('[data-bt-rsa]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-rsa]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__btRsReady) return;
      root.__btRsReady = true;

      var slides = root.querySelectorAll('[data-bt-rs-slide]');
      var dots = root.querySelectorAll('[data-bt-rs-dot]');
      var prev = root.querySelector('[data-bt-rs-prev]');
      var next = root.querySelector('[data-bt-rs-next]');
      var autoplay = root.getAttribute('data-bt-rs-autoplay');

      if (slides.length < 2) return;

      var current = 0;
      function show(idx) {
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        current = idx;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }

      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { show(i); });
      });

      // Auto-rotate
      var autoInterval = parseInt(root.getAttribute('data-bt-rs-interval') || '0', 10);
      if (autoInterval > 0) {
        var timer = setInterval(function () { show(current + 1); }, autoInterval * 1000);
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
      }

      // Touch swipe
      var startX = 0, startT = 0;
      var stage = root.querySelector('[data-bt-rs-stage]');
      if (stage) {
        stage.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startT = Date.now();
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 40 || Date.now() - startT > 600) return;
          show(dx < 0 ? current + 1 : current - 1);
        });
      }
    }

    document.querySelectorAll('[data-bt-rs]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-rs]').forEach(init);
    });

    // Lightbox for gallery photos
    document.addEventListener('click', function (e) {
      var zoomBtn = e.target.closest('[data-bt-rs-zoom]');
      var closeBtn = e.target.closest('[data-bt-rs-close]');
      var lightbox = e.target.closest('[data-bt-rs-lightbox]');

      if (zoomBtn) {
        var section = zoomBtn.closest('.bt-rs');
        if (!section) return;
        var lb = section.querySelector('[data-bt-rs-lightbox]');
        var content = section.querySelector('[data-bt-rs-lightbox-content]');
        if (!lb || !content) return;
        var src = zoomBtn.getAttribute('data-bt-rs-zoom');
        content.innerHTML = '<img src="' + src + '" alt="">';
        lb.classList.add('is-open');
        lb.setAttribute('aria-hidden', 'false');
        document.body.classList.add('bt-rs-lightbox-open');
      } else if (closeBtn || (lightbox && e.target === lightbox)) {
        var lb2 = (closeBtn || lightbox).closest('.bt-rs').querySelector('[data-bt-rs-lightbox]');
        if (!lb2) return;
        lb2.classList.remove('is-open');
        lb2.setAttribute('aria-hidden', 'true');
        var c = lb2.querySelector('[data-bt-rs-lightbox-content]');
        if (c) c.innerHTML = '';
        document.body.classList.remove('bt-rs-lightbox-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.bt-rs__lightbox.is-open').forEach(function (lb) {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        var c = lb.querySelector('[data-bt-rs-lightbox-content]');
        if (c) c.innerHTML = '';
        document.body.classList.remove('bt-rs-lightbox-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-wall-api"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__btRwReady) return;
      root.__btRwReady = true;

      var apiBase = root.getAttribute('data-api-base');
      var storeId = root.getAttribute('data-store-id');
      var apiStore = root.getAttribute('data-store') || 'pl';
      var pageLocale = (root.getAttribute('data-locale') || '').toLowerCase();
      var anonLabel = root.getAttribute('data-anon-label') || 'Anonim';
      var verifiedLabel = root.getAttribute('data-verified-label') || 'Zweryfikowano';
      var handle = root.getAttribute('data-handle');
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 30;
      var sort = root.getAttribute('data-sort') || 'recent';
      var photosOnly = root.getAttribute('data-photos-only') === 'true';

      var loadingEl = root.querySelector('[data-bt-rw-loading]');
      var wallEl = root.querySelector('[data-bt-rw-wall]');
      var emptyEl = root.querySelector('[data-bt-rw-empty]');
      var summaryEl = root.querySelector('[data-bt-rw-summary]');
      var avgEl = root.querySelector('[data-bt-rw-avg]');
      var avgStarsEl = root.querySelector('[data-bt-rw-avg-stars]');
      var countEl = root.querySelector('[data-bt-rw-count]');

      /* 12.10.2026: підпис «перекладено з …» під перекладеним відгуком
         (словник — дзеркало snippets/bt-review-tr-note.liquid; повна версія з
         кнопкою оригіналу — у reviews-grid-api). */
      function trNote(r) {
        if (!r || !r.translated) return '';
        var T = {
          pl: ['Przetłumaczono automatycznie', { pl: 'z polskiego', uk: 'z ukraińskiego', en: 'z angielskiego', it: 'z włoskiego', ru: 'z rosyjskiego' }],
          en: ['Translated automatically', { pl: 'from Polish', uk: 'from Ukrainian', en: 'from English', it: 'from Italian', ru: 'from Russian' }],
          uk: ['Перекладено автоматично', { pl: 'з польської', uk: 'з української', en: 'з англійської', it: 'з італійської', ru: 'з російської' }],
          ru: ['Переведено автоматически', { pl: 'с польского', uk: 'с украинского', en: 'с английского', it: 'с итальянского', ru: 'с русского' }],
          de: ['Automatisch übersetzt', { pl: 'aus dem Polnischen', uk: 'aus dem Ukrainischen', en: 'aus dem Englischen', it: 'aus dem Italienischen', ru: 'aus dem Russischen' }],
          it: ['Tradotto automaticamente', { pl: 'dal polacco', uk: 'dall\u2019ucraino', en: 'dall\u2019inglese', it: 'dall\u2019italiano', ru: 'dal russo' }],
          cs: ['Přeloženo automaticky', { pl: 'z polštiny', uk: 'z ukrajinštiny', en: 'z angličtiny', it: 'z italštiny', ru: 'z ruštiny' }],
          es: ['Traducido automáticamente', { pl: 'del polaco', uk: 'del ucraniano', en: 'del inglés', it: 'del italiano', ru: 'del ruso' }],
          fr: ['Traduit automatiquement', { pl: 'du polonais', uk: 'de l\u2019ukrainien', en: 'de l\u2019anglais', it: 'de l\u2019italien', ru: 'du russe' }],
          nl: ['Automatisch vertaald', { pl: 'uit het Pools', uk: 'uit het Oekraïens', en: 'uit het Engels', it: 'uit het Italiaans', ru: 'uit het Russisch' }],
          sk: ['Automaticky preložené', { pl: 'z poľštiny', uk: 'z ukrajinčiny', en: 'z angličtiny', it: 'z taliančiny', ru: 'z ruštiny' }],
          hu: ['Automatikusan lefordítva', { pl: 'lengyelből', uk: 'ukránból', en: 'angolból', it: 'olaszból', ru: 'oroszból' }],
          ro: ['Tradus automat', { pl: 'din poloneză', uk: 'din ucraineană', en: 'din engleză', it: 'din italiană', ru: 'din rusă' }],
          lt: ['Išversta automatiškai', { pl: 'iš lenkų kalbos', uk: 'iš ukrainiečių kalbos', en: 'iš anglų kalbos', it: 'iš italų kalbos', ru: 'iš rusų kalbos' }],
          lv: ['Automātiski tulkots', { pl: 'no poļu valodas', uk: 'no ukraiņu valodas', en: 'no angļu valodas', it: 'no itāļu valodas', ru: 'no krievu valodas' }],
          et: ['Automaatselt tõlgitud', { pl: 'poola keelest', uk: 'ukraina keelest', en: 'inglise keelest', it: 'itaalia keelest', ru: 'vene keelest' }]
        };
        var d = T[(document.documentElement.lang || 'pl').slice(0, 2)] || T.en;
        var label = d[0] + (d[1][r.source_locale] ? ' ' + d[1][r.source_locale] : '');
        return '<div class="bt-review-tr-note" style="font-size:12px;line-height:1.4;opacity:.6;margin-top:6px">' + esc(label) + '</div>';
      }

      function esc(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
      }
      var IMAGE_EXTS = ['jpg','jpeg','png','gif','webp','avif','heic','heif','bmp','svg'];
      var VIDEO_EXTS = ['mp4','webm','mov','m4v','ogg','ogv','mkv','3gp'];
      function guessMediaKind(url) {
        if (!url) return 'unknown';
        var pathname = url;
        try { pathname = new URL(url, 'http://x').pathname; }
        catch (e) { pathname = (url.split('?')[0] || '').split('#')[0]; }
        for (var i = 0; i < 2; i++) {
          var p;
          try { p = i === 0 ? pathname : decodeURIComponent(pathname); }
          catch (e) { p = pathname; }
          var m = p.match(/\.([a-z0-9]{2,5})$/i);
          if (!m) continue;
          var ext = m[1].toLowerCase();
          if (IMAGE_EXTS.indexOf(ext) !== -1) return 'image';
          if (VIDEO_EXTS.indexOf(ext) !== -1) return 'video';
        }
        return 'unknown';
      }
      /* 10.10.2026 (швидкість): фото відгуків лежать у Supabase оригіналами по 1–3 МБ — картці досить
         мініатюри через /render/image. Не віддалась — фолбек бере оригінал з data-bt-media-url.
         Лайтбокс (opts.controls) показує оригінал. Стіна рендериться лише в JS, SSR-дзеркала немає. */
      var THUMB_EXTS = ['jpg','jpeg','png','webp','avif','heic','heif','bmp'];
      function thumbUrl(url) {
        if (!url || url.indexOf('/storage/v1/object/public/') === -1) return null;
        var path = (url.split('?')[0] || '').split('#')[0];
        var m = path.match(/\.([a-z0-9]{2,5})$/i);
        if (!m || THUMB_EXTS.indexOf(m[1].toLowerCase()) === -1) return null;
        /* 04.11.2026: готова мініатюра reviews/thumb/<name>.webp (робить lost-orders при завантаженні, lib/review-thumb.ts) —
           /render/image рахується в ліміт трансформацій Supabase (100 різних фото на місяць). Інші адреси — як раніше. */
        var RM = '/storage/v1/object/public/review-media/reviews/';
        var at = path.indexOf(RM);
        if (at !== -1 && path.slice(at + RM.length).indexOf('/') === -1) return path.slice(0, at + RM.length) + 'thumb/' + path.slice(at + RM.length).replace(/\.[^.]+$/, '') + '.webp';
        return path.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/') + '?width=720&height=720&resize=contain&quality=70';
      }
      function buildMediaTag(url, opts) {
        opts = opts || {};
        var kind = guessMediaKind(url);
        var initial = (kind === 'video') ? 'video' : 'image';
        var escaped = esc(url);
        var attrs = 'data-bt-media-url="' + escaped + '" data-bt-media-tried="' + initial + '"';
        if (initial === 'video') {
          return '<video src="' + escaped + '" muted playsinline preload="metadata"' + (opts.controls ? ' controls' : '') + ' ' + attrs + '></video>';
        }
        var thumb = opts.controls ? null : thumbUrl(url);
        if (thumb) attrs += ' data-bt-thumb="1"';
        var srcAttr = thumb ? thumb.replace(/&/g, '&amp;').replace(/"/g, '&quot;') : escaped;
        return '<img src="' + srcAttr + '" loading="lazy" decoding="async" alt="" ' + attrs + '>';
      }
      function removeBrokenMedia(el) {
        var mediaWrap = el.closest('.bt-rw__card-media');
        if (mediaWrap) mediaWrap.remove();
        else el.remove();
      }
      function attachMediaFallback(scope) {
        if (!scope) return;
        scope.querySelectorAll('[data-bt-media-url]:not([data-bt-media-bound])').forEach(function (el) {
          el.setAttribute('data-bt-media-bound', '1');
          el.addEventListener('error', function onMediaError() {
            var u = el.getAttribute('data-bt-media-url');
            var tried = el.getAttribute('data-bt-media-tried');
            /* мініатюра Supabase не віддалась — пробуємо оригінал, лише потім відео */
            if (el.tagName === 'IMG' && el.getAttribute('data-bt-thumb') && !el.getAttribute('data-bt-thumb-failed')) {
              el.setAttribute('data-bt-thumb-failed', '1');
              el.removeAttribute('data-bt-media-failed');
              el.addEventListener('error', onMediaError, { once: true });
              el.src = u;
              return;
            }
            if (tried === 'image') {
              var v = document.createElement('video');
              v.src = u; v.muted = true; v.playsInline = true; v.preload = 'metadata';
              if (el.closest('.bt-rw__lightbox')) v.controls = true;
              v.setAttribute('data-bt-media-url', u);
              v.setAttribute('data-bt-media-tried', 'video');
              v.setAttribute('data-bt-media-bound', '1');
              v.addEventListener('error', function () {
                removeBrokenMedia(v);
              }, { once: true });
              el.replaceWith(v);
              // Update parent data-bt-rw-is-video and add play icon if needed
              var mediaEl = v.closest('[data-bt-rw-zoom]');
              if (mediaEl) {
                mediaEl.setAttribute('data-bt-rw-is-video', '1');
                if (!mediaEl.querySelector('.bt-rw__card-media-play')) {
                  var p = document.createElement('span');
                  p.className = 'bt-rw__card-media-play';
                  p.textContent = '▶';
                  p.setAttribute('aria-hidden', 'true');
                  mediaEl.appendChild(p);
                }
              }
            } else {
              removeBrokenMedia(el);
            }
          }, { once: true });
        });
      }
      function stars(r) {
        var f = Math.round(r || 0);
        var out = '';
        for (var i = 1; i <= 5; i++) out += (i <= f ? '★' : '☆');
        return out;
      }
      function renderCard(r) {
        var name = r.author_name || anonLabel;
        var hasMedia = r.images && r.images.length > 0;
        var mediaHtml = '';
        if (hasMedia) {
          var firstUrl = r.images[0];
          var kind = guessMediaKind(firstUrl);
          var isVid = kind === 'video';
          var countBadge = r.images.length > 1
            ? '<span class="bt-rw__card-media-count">+' + (r.images.length - 1) + '</span>'
            : '';
          var playIcon = isVid ? '<span class="bt-rw__card-media-play" aria-hidden="true">▶</span>' : '';
          mediaHtml = '<div class="bt-rw__card-media" data-bt-rw-zoom="' + esc(firstUrl) + '" data-bt-rw-gallery="' + esc(JSON.stringify(r.images)) + '" data-bt-rw-is-video="' + (isVid ? '1' : '0') + '">' + buildMediaTag(firstUrl) + countBadge + playIcon + '</div>';
        }
        return '<article class="bt-rw__card">' +
          mediaHtml +
          '<div class="bt-rw__card-body">' +
            '<div class="bt-rw__card-stars">' + stars(r.rating) + '</div>' +
            (r.body ? '<div class="bt-rw__card-text">' + esc(r.body) + '</div>' + trNote(r) : '') +
            '<div class="bt-rw__card-author">' +
              '<span class="bt-rw__card-author-name">' + esc(name) + '</span>' +
              (r.verified_purchase ? '<span class="bt-rw__card-verified" title="' + esc(verifiedLabel) + '">✓</span>' : '') +
            '</div>' +
          '</div>' +
        '</article>';
      }

      function parseDefaults(raw) {
        if (!raw) return null;
        try {
          var p = JSON.parse(raw);
          if (Array.isArray(p)) return p;
          if (p && Array.isArray(p.data)) return p.data;
        } catch (e) { console.warn('[Bt: Reviews wall] defaults JSON parse error', e); }
        return null;
      }

      function renderWall(reviews) {
        var list = photosOnly ? reviews.filter(function (r) { return r.images && r.images.length > 0; }) : reviews;
        if (!list.length) return false;
        wallEl.innerHTML = list.map(renderCard).join('');
        wallEl.hidden = false;
        attachMediaFallback(wallEl);
        return true;
      }

      // 1. Render embedded defaults INSTANTLY
      var defaultsScript = root.querySelector('[data-bt-rw-defaults]');
      var hasDefaults = false;
      if (defaultsScript) {
        var defaults = parseDefaults(defaultsScript.textContent);
        if (defaults && defaults.length) {
          if (loadingEl) loadingEl.hidden = true;
          if (renderWall(defaults)) hasDefaults = true;
        }
      }

      // 2. Fetch fresh data
      var storeQs = '&store=' + encodeURIComponent(apiStore);
      var localeQs = pageLocale ? '&locale=' + encodeURIComponent(pageLocale) : '';
      var url = apiBase + '/api/public/reviews/product?storeId=' + encodeURIComponent(storeId) +
        storeQs + localeQs +
        '&limit=' + limit + '&sort=' + encodeURIComponent(sort);
      if (handle) url += '&handle=' + encodeURIComponent(handle);

      // Rating summary (average + total count) — language-independent.
      function updateSummary(count, average) {
        if (!summaryEl) return;
        if (!count) { summaryEl.hidden = true; return; }
        summaryEl.hidden = false;
        if (avgEl) avgEl.textContent = (Math.round(average * 10) / 10).toFixed(1);
        if (countEl) countEl.textContent = count;
        if (avgStarsEl) avgStarsEl.textContent = stars(average);
      }
      if (summaryEl) {
        var summaryUrl = apiBase + '/api/public/reviews/summary?storeId=' + encodeURIComponent(storeId) + storeQs;
        if (handle) summaryUrl += '&handle=' + encodeURIComponent(handle);
        fetch(summaryUrl).then(function (r) { return r.json(); }).then(function (s) {
          if (s && s.success) updateSummary(s.count, s.average);
        }).catch(function () {});
      }

      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        if (loadingEl) loadingEl.hidden = true;
        if (!data || !data.success || !Array.isArray(data.data) || !data.data.length) {
          if (!hasDefaults) {
            if (emptyEl) emptyEl.hidden = false;
          }
          return;
        }
        if (!renderWall(data.data) && !hasDefaults) {
          if (emptyEl) emptyEl.hidden = false;
        }
      }).catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        if (!hasDefaults) {
          if (emptyEl) emptyEl.hidden = false;
        }
      });

      // Lightbox with gallery navigation
      var lightbox = root.querySelector('[data-bt-rw-lightbox]');
      var content = root.querySelector('[data-bt-rw-lightbox-content]');
      var prevBtn = root.querySelector('[data-bt-rw-prev]');
      var nextBtn = root.querySelector('[data-bt-rw-next]');
      var counterEl = root.querySelector('[data-bt-rw-counter]');
      var lbGallery = [];
      var lbIndex = 0;

      function lbShow(i) {
        if (!lbGallery.length || !content) return;
        lbIndex = ((i % lbGallery.length) + lbGallery.length) % lbGallery.length;
        content.innerHTML = buildMediaTag(lbGallery[lbIndex], { controls: true });
        attachMediaFallback(content);
        var v = content.querySelector('video');
        if (v) { v.controls = true; v.autoplay = true; try { v.play(); } catch (err) {} }
        var multi = lbGallery.length > 1;
        if (prevBtn) prevBtn.hidden = !multi;
        if (nextBtn) nextBtn.hidden = !multi;
        if (counterEl) {
          counterEl.hidden = !multi;
          counterEl.textContent = (lbIndex + 1) + ' / ' + lbGallery.length;
        }
      }

      function lbOpen(gallery, startIndex) {
        lbGallery = gallery;
        lbShow(startIndex || 0);
        if (lightbox) { lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false'); }
        document.body.classList.add('bt-rw-lightbox-open');
      }

      function lbClose() {
        if (lightbox) { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); }
        if (content) content.innerHTML = '';
        lbGallery = [];
        document.body.classList.remove('bt-rw-lightbox-open');
      }

      function lbIsOpen() {
        return lightbox && lightbox.classList.contains('is-open');
      }

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-bt-rw-prev]')) { lbShow(lbIndex - 1); return; }
        if (e.target.closest('[data-bt-rw-next]')) { lbShow(lbIndex + 1); return; }
        var mediaEl = e.target.closest('[data-bt-rw-zoom]');
        var closeBtn = e.target.closest('[data-bt-rw-close]');
        if (mediaEl) {
          e.preventDefault();
          var gallery = null;
          var rawGallery = mediaEl.getAttribute('data-bt-rw-gallery');
          if (rawGallery) {
            try {
              var parsed = JSON.parse(rawGallery);
              if (Array.isArray(parsed) && parsed.length) gallery = parsed;
            } catch (err) {}
          }
          if (!gallery) gallery = [mediaEl.getAttribute('data-bt-rw-zoom')];
          lbOpen(gallery, 0);
        } else if (closeBtn || e.target === lightbox) {
          lbClose();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (!lbIsOpen()) return;
        if (e.key === 'Escape') lbClose();
        else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
        else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });

      // Swipe navigation on touch devices
      if (lightbox) {
        var touchX = null, touchY = null;
        lightbox.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { touchX = null; return; }
          touchX = e.touches[0].clientX;
          touchY = e.touches[0].clientY;
        }, { passive: true });
        lightbox.addEventListener('touchend', function (e) {
          if (touchX == null || !e.changedTouches.length) return;
          var dx = e.changedTouches[0].clientX - touchX;
          var dy = e.changedTouches[0].clientY - touchY;
          touchX = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && lbGallery.length > 1) {
            lbShow(dx < 0 ? lbIndex + 1 : lbIndex - 1);
          }
        }, { passive: true });
      }

      // Submit review popup (iframe) — same form as the grid section
      var openBtn = root.querySelector('[data-bt-rw-open]');
      var modal = root.querySelector('[data-bt-rw-modal]');
      var iframe = root.querySelector('[data-bt-rw-iframe]');
      if (openBtn && modal && iframe) {
        /* The form keeps working after the review is saved — it shows the promo
           code, offers the survey and the 5%→10% upgrade. So a submit is NOT a
           close signal: we only remember it, and refresh the wall once the
           visitor actually closes the popup (or clicks «go to store», which the
           form reports as `user-done`). Closing on `review-submitted` used to
           kill the promo code before anyone could copy it. */
        var reviewSubmitted = false;
        function closeModal() {
          modal.hidden = true;
          document.body.style.overflow = '';
          iframe.src = 'about:blank';
          if (reviewSubmitted) window.location.reload();
        }
        openBtn.addEventListener('click', function () {
          var formUrl = new URL('https://bricktopia-reviews.vercel.app/embed');
          formUrl.searchParams.set('store', apiStore);
          if (pageLocale) formUrl.searchParams.set('locale', pageLocale);
          if (handle) formUrl.searchParams.set('product', handle);
          iframe.src = formUrl.toString();
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
        });
        root.querySelectorAll('[data-bt-rw-modal-close]').forEach(function (b) {
          b.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) closeModal();
        });
        window.addEventListener('message', function (e) {
          if (!e.data || e.data.source !== 'bricktopia-reviews') return;
          if (e.data.type === 'review-submitted' || e.data.type === 'survey-submitted') {
            reviewSubmitted = true;
            return;
          }
          if (e.data.type === 'user-done') closeModal();
          /* The form reports its content height so the iframe can grow/shrink
             with the step instead of sitting at a fixed 720px. */
          if (e.data.type === 'resize' && e.data.height) {
            var h = Math.max(360, Math.min(Number(e.data.height) + 8, Math.round(window.innerHeight * 0.86)));
            iframe.style.height = h + 'px';
          }
        });
      }
    }
    document.querySelectorAll('[data-bt-rw]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-rw]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
